import React from 'react';

export function SmallBusinessSvg({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 858 611"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M487.75 134.25L713.55 134.25V0L487.75 0V134.25Z"
        fill="#FAF3EE"
      />
      <path d="M354.58 0H178.34V134.25H354.58V0Z" fill="#FAF3EE" />
      <path
        d="M178.33 128.63L353.74 128.63V7.48989L178.33 7.48989L178.33 128.63Z"
        fill="#C7C7CA"
      />
      <path
        d="M303.33 49.61H323.03C324.41 49.61 325.57 48.58 325.73 47.2099L327.92 28.95H298.45L300.64 47.2099C300.8 48.58 301.96 49.61 303.34 49.61H303.33Z"
        fill="#6F452E"
      />
      <path
        d="M305.46 39.2899H306.75V29.0699L311.77 13.8199C311.99 13.2199 312.72 12.9999 313.26 13.0099C313.8 13.0099 314.51 13.2399 314.72 13.8599L319.39 29.0699V39.2999H320.68V28.8799L315.95 13.4699C315.59 12.4199 314.54 11.7399 313.28 11.7299C312.01 11.7099 310.94 12.3699 310.56 13.4099L305.47 28.8799V39.3099L305.46 39.2899Z"
        fill="#A66745"
      />
      <path d="M318.71 31.6599H321.19V27.8699H318.71V31.6599Z" fill="#C77B53" />
      <path d="M304.86 31.6599H307.34V27.8699H304.86V31.6599Z" fill="#C77B53" />
      <path
        d="M248.3 49.53H269.86C271.81 49.53 273.29 47.76 272.93 45.84L270.46 32.52C270.19 31.04 268.9 29.97 267.39 29.97H250.77C249.27 29.97 247.97 31.04 247.7 32.52L245.23 45.84C244.87 47.76 246.35 49.53 248.3 49.53Z"
        fill="#57545B"
      />
      <path
        d="M252.07 32.93H253.72V27.41C253.72 25.09 255.61 23.2001 257.93 23.2001H260.04C262.36 23.2001 264.25 25.09 264.25 27.41V32.93H265.9V27.41C265.9 24.18 263.27 21.55 260.04 21.55H257.93C254.7 21.55 252.07 24.18 252.07 27.41V32.93Z"
        fill="#A66745"
      />
      <path
        d="M265.06 34.1201C264.36 34.1201 263.8 33.5501 263.8 32.8601V31.1601H266.33V32.8601C266.33 33.5601 265.76 34.1201 265.07 34.1201H265.06Z"
        fill="#8D8994"
      />
      <path
        d="M252.89 34.2801C253.59 34.2801 254.15 33.7101 254.15 33.0201V31.3201H251.62V33.0201C251.62 33.7201 252.19 34.2801 252.88 34.2801H252.89Z"
        fill="#8D8994"
      />
      <path
        d="M254.25 41H263.91C264.423 41 264.84 40.5836 264.84 40.07V40.06C264.84 39.5464 264.423 39.13 263.91 39.13H254.25C253.736 39.13 253.32 39.5464 253.32 40.06V40.07C253.32 40.5836 253.736 41 254.25 41Z"
        fill="#8D8994"
      />
      <path
        d="M228.26 126.76H264.22C266.2 114.8 265.09 108.33 260.41 99.4302H232.07C227.39 108.33 226.29 114.8 228.26 126.76Z"
        fill="#835353"
      />
      <path d="M231.47 99.4302H261V94.6502H231.47V99.4302Z" fill="#E38C4F" />
      <path
        d="M235.88 94.6401H237.03C237.03 82.2501 239.96 76.4701 246.24 76.4701C252.52 76.4701 255.45 82.4101 255.45 94.6401H256.6C256.6 81.6401 253.21 75.3201 246.24 75.3201C239.27 75.3201 235.88 81.6401 235.88 94.6401Z"
        fill="#E38C4F"
      />
      <path
        d="M204.38 49.7601H225.26C226.72 49.7601 227.95 48.6701 228.12 47.2201L229.13 38.8101L226.84 27.8601H202.79L200.5 38.8101L201.51 47.2201C201.68 48.6701 202.91 49.7601 204.37 49.7601H204.38Z"
        fill="#693E20"
      />
      <path
        d="M206.64 38.81H208.01V27.95L210.93 17.4C211.09 17.07 212.64 16.51 215.23 16.53C217.81 16.56 219.09 17.14 219.25 17.41L221.41 27.93V38.81H222.78V27.72L220.55 16.99C220 15.39 216.66 15.18 215.25 15.16C214.09 15.15 210.27 15.24 209.65 16.94L209.63 16.99L206.65 27.76V38.8L206.64 38.81Z"
        fill="#96592E"
      />
      <path d="M223.31 26.71H220.69V30.73H223.31V26.71Z" fill="#E38C4F" />
      <path d="M208.63 26.71H206.01V30.73H208.63V26.71Z" fill="#E38C4F" />
      <path
        d="M557.17 126.77H587.25C589.35 126.77 591.12 125.2 591.37 123.11L592.82 111L589.53 95.23H554.88L551.59 111L553.04 123.11C553.29 125.2 555.06 126.77 557.16 126.77H557.17Z"
        fill="#DACEB5"
      />
      <path
        d="M560.42 111H562.39V95.3601L566.6 80.1601C566.84 79.6801 569.05 78.8701 572.79 78.9101C576.51 78.9501 578.36 79.8001 578.57 80.1801L581.69 95.3301V111H583.66L583.64 95.0301L580.45 79.5801C579.66 77.2701 574.84 76.9701 572.81 76.9501C571.13 76.9301 565.64 77.0601 564.74 79.5101L564.72 79.5901L560.43 95.1001V111.01L560.42 111Z"
        fill="#F0E2C7"
      />
      <path d="M584.44 93.5701H580.66V99.3601H584.44V93.5701Z" fill="#B8AD98" />
      <path d="M563.29 93.5701H559.51V99.3601H563.29V93.5701Z" fill="#B8AD98" />
      <path
        d="M589.97 126.77H617.45C619.37 126.77 620.99 125.33 621.22 123.43L622.55 112.36L619.54 97.95H587.89L584.88 112.36L586.21 123.43C586.44 125.34 588.06 126.77 589.98 126.77H589.97Z"
        fill="#525052"
      />
      <path
        d="M592.94 112.36H594.74V98.07L598.58 84.19C598.8 83.75 600.82 83.01 604.24 83.05C607.64 83.09 609.32 83.86 609.52 84.21L612.37 98.05V112.37H614.17L614.15 97.78L611.24 83.66C610.52 81.55 606.12 81.28 604.26 81.26C602.74 81.25 597.71 81.36 596.89 83.6L596.87 83.67L592.95 97.84V112.37L592.94 112.36Z"
        fill="#77787B"
      />
      <path d="M611.44 101.73H614.89V96.44H611.44V101.73Z" fill="#B2B4B8" />
      <path d="M592.12 101.73H595.57V96.44H592.12V101.73Z" fill="#B2B4B8" />
      <path d="M289.29 126.76H335.12V119.16H289.29V126.76Z" fill="#525052" />
      <path d="M330.75 113.6H295.33V119.16H330.75V113.6Z" fill="#97AEBC" />
      <path d="M333.53 108.06H294V113.99H333.53V108.06Z" fill="#835353" />
      <path
        d="M211.14 126.76H231.1C232.91 126.76 234.27 125.12 233.94 123.34L231.65 111.01C231.4 109.64 230.2 108.65 228.81 108.65H213.43C212.04 108.65 210.84 109.64 210.59 111.01L208.3 123.34C207.97 125.12 209.33 126.76 211.14 126.76Z"
        fill="#CB9392"
      />
      <path
        d="M214.63 111.4H216.16V106.29C216.16 104.14 217.91 102.4 220.05 102.4H222.01C224.16 102.4 225.9 104.15 225.9 106.29V111.4H227.43V106.29C227.43 103.3 225 100.87 222.01 100.87H220.05C217.06 100.87 214.63 103.3 214.63 106.29V111.4Z"
        fill="#6F605B"
      />
      <path
        d="M226.659 112.49C227.309 112.49 227.829 111.97 227.829 111.32V109.74H225.489V111.32C225.489 111.97 226.009 112.49 226.659 112.49Z"
        fill="#FFB8B7"
      />
      <path
        d="M215.39 112.64C216.04 112.64 216.56 112.12 216.56 111.47V109.89H214.22V111.47C214.22 112.12 214.74 112.64 215.39 112.64Z"
        fill="#FFB8B7"
      />
      <path
        d="M216.66 118.86H225.59C226.07 118.86 226.45 118.47 226.45 118C226.45 117.52 226.06 117.14 225.59 117.14H216.66C216.18 117.14 215.8 117.53 215.8 118C215.8 118.48 216.19 118.86 216.66 118.86Z"
        fill="#FFB8B7"
      />
      <path
        d="M665.52 126.8H692.16C694.57 126.8 696.39 124.61 695.95 122.24L692.9 105.78C692.56 103.95 690.97 102.63 689.11 102.63H668.57C666.71 102.63 665.12 103.96 664.78 105.78L661.73 122.24C661.29 124.61 663.11 126.8 665.52 126.8Z"
        fill="#CB9392"
      />
      <path
        d="M670.18 106.29H672.22V99.47C672.22 96.6 674.55 94.27 677.42 94.27H680.03C682.9 94.27 685.23 96.6 685.23 99.47V106.29H687.27V99.47C687.27 95.48 684.02 92.23 680.03 92.23H677.42C673.43 92.23 670.18 95.48 670.18 99.47V106.29Z"
        fill="#6F605B"
      />
      <path
        d="M686.24 107.75C687.1 107.75 687.8 107.05 687.8 106.19V104.09H684.68V106.19C684.68 107.05 685.38 107.75 686.24 107.75Z"
        fill="#FFB8B7"
      />
      <path
        d="M671.2 107.96C672.06 107.96 672.76 107.26 672.76 106.4V104.3H669.64V106.4C669.64 107.26 670.34 107.96 671.2 107.96Z"
        fill="#FFB8B7"
      />
      <path
        d="M672.88 116.26H684.8C685.44 116.26 685.95 115.74 685.95 115.11C685.95 114.47 685.43 113.96 684.8 113.96H672.88C672.24 113.96 671.73 114.48 671.73 115.11C671.73 115.75 672.25 116.26 672.88 116.26Z"
        fill="#FFB8B7"
      />
      <path
        d="M535.99 49.76H561.29C562.68 41.35 561.9 36.8 558.61 30.53H538.67C535.38 36.79 534.6 41.34 535.99 49.76Z"
        fill="#4A3930"
      />
      <path
        d="M538.26 30.54L559.03 30.54V27.17L538.26 27.17V30.54Z"
        fill="#634F4E"
      />
      <path
        d="M541.36 27.1701H542.17C542.17 18.4501 544.23 14.3901 548.65 14.3901C553.07 14.3901 555.13 18.5701 555.13 27.1701H555.94C555.94 18.0301 553.56 13.5801 548.65 13.5801C543.74 13.5801 541.36 18.0201 541.36 27.1701Z"
        fill="#4A3930"
      />
      <path d="M545.64 32.3101H551.21V28.0601H545.64V32.3101Z" fill="#F0F0D2" />
      <path d="M547.56 31.6401H549.08V28.8501H547.56V31.6401Z" fill="#4A3930" />
      <path
        d="M596.6 49.77L623.87 49.77C625.129 49.77 626.15 48.7492 626.15 47.49V33.96C626.15 32.7008 625.129 31.68 623.87 31.68L596.6 31.68C595.341 31.68 594.32 32.7008 594.32 33.96V47.49C594.32 48.7492 595.341 49.77 596.6 49.77Z"
        fill="#993A29"
      />
      <path
        d="M637.35 49.9099L667.45 49.9099C669.168 49.9099 670.56 48.5175 670.56 46.7999V23.5199C670.56 21.8023 669.168 20.4099 667.45 20.4099L637.35 20.4099C635.632 20.4099 634.24 21.8023 634.24 23.5199V46.7999C634.24 48.5175 635.632 49.9099 637.35 49.9099Z"
        fill="#FBD5A2"
      />
      <path
        d="M487.75 57.25L713.55 57.25V49.77L487.75 49.77V57.25Z"
        fill="#E79361"
      />
      <path
        opacity="0.1"
        d="M487.75 65.73L713.55 65.73V57.25L487.75 57.25V65.73Z"
        fill="#231F20"
      />
      <path
        d="M487.75 134.25L713.55 134.25V126.77L487.75 126.77V134.25Z"
        fill="#E79361"
      />
      <path
        opacity="0.1"
        d="M487.75 142.74L713.55 142.74V134.26L487.75 134.26V142.74Z"
        fill="#231F20"
      />
      <path
        d="M487.75 7.47998L713.55 7.47998V-1.95503e-05L487.75 -1.95503e-05V7.47998Z"
        fill="#E79361"
      />
      <path
        opacity="0.1"
        d="M487.75 17.8501L713.55 17.8501V7.4901L487.75 7.4901V17.8501Z"
        fill="#231F20"
      />
      <path d="M354.58 49.76H178.34V57.24H354.58V49.76Z" fill="#E79361" />
      <path
        opacity="0.1"
        d="M354.58 57.24H178.34V65.72H354.58V57.24Z"
        fill="#231F20"
      />
      <path d="M354.58 126.77H178.34V134.25H354.58V126.77Z" fill="#E79361" />
      <path
        opacity="0.1"
        d="M354.58 134.25H178.34V142.73H354.58V134.25Z"
        fill="#231F20"
      />
      <path d="M354.58 0H178.34V7.48H354.58V0Z" fill="#E79361" />
      <path
        opacity="0.1"
        d="M354.58 7.47998H178.34V17.84H354.58V7.47998Z"
        fill="#231F20"
      />
      <g style={{ mixBlendMode: 'multiply' }}>
        <path
          d="M858 578.12C858 610.7 665.93 610.7 429 610.7C192.07 610.7 0 610.71 0 578.12C0 545.53 192.71 505.75 429.64 505.75C666.57 505.75 858 545.53 858 578.12Z"
          fill="#FAFAFA"
        />
      </g>
      <path d="M450.979 20.21H395.699V90.27H450.979V20.21Z" fill="#F2E6DF" />
      <path
        d="M394.14 91.8299H452.52V18.6599H394.14V91.8299ZM449.41 88.7199H397.24V21.7699H449.41V88.7199Z"
        fill="#C5B2AB"
      />
      <path d="M441.87 28.2H404.79V80.44H441.87V28.2Z" fill="#AB8585" />
      <path
        d="M833.41 278.41C834.31 279.34 834.85 280.6 834.81 281.99L834.55 290.94C834.55 292.55 833.4 293.85 831.98 293.85H818.22C816.8 293.85 815.65 292.55 815.65 290.94L815.39 281.99C815.35 280.61 815.89 279.34 816.79 278.43V254.67C816.07 253.37 815.39 252.05 815.39 250.45C815.39 246.66 817.56 243.37 820.73 241.77C821.36 241.45 821.77 240.81 821.77 240.1V239.14H821.58C821.48 239.14 821.39 239.05 821.39 238.95C821.39 238.85 821.47 238.76 821.58 238.76H821.77V238.3C821.33 238.3 821.01 237.98 821.01 237.58V234.54C821.01 234.14 821.33 233.82 821.73 233.82H828.49C828.89 233.82 829.21 234.14 829.21 234.54V237.58C829.21 237.98 828.89 238.3 828.49 238.3V238.76H828.64C828.74 238.76 828.83 238.85 828.83 238.95C828.83 239.05 828.75 239.14 828.64 239.14H828.49V239.52L828.45 240.1C828.45 240.81 828.86 241.45 829.49 241.77C832.66 243.37 834.83 246.66 834.83 250.45C834.83 252.05 834.15 253.37 833.43 254.67V278.41H833.41Z"
        fill="#F4F4F4"
      />
      <path
        d="M634.14 262.05C633.52 260.08 632.89 257.77 632.8 256.55C632.38 250.74 638.03 242.9 639.17 241.3V238.69H639C638.9 238.69 638.83 238.61 638.83 238.52C638.83 238.43 638.91 238.35 639 238.35H639.17V237.93C638.77 237.93 638.47 237.63 638.47 237.27V234.48C638.47 234.11 638.77 233.82 639.13 233.82H645.33C645.7 233.82 645.99 234.12 645.99 234.48V237.27C645.99 237.64 645.69 237.93 645.33 237.93C645.29 237.93 645.29 238.35 645.29 238.35H645.46C645.56 238.35 645.63 238.43 645.63 238.52C645.63 238.61 645.55 238.69 645.46 238.69H645.29V241.3C646.43 242.9 651.93 250.73 651.66 256.55C651.6 257.89 651.05 260.29 650.42 262.29C651.49 264.58 652.86 267.61 652.86 270.84C652.86 273.04 651.97 276.27 650.92 278.85C651.54 280.77 652.04 283.08 652.04 284.43C652.04 286.34 649.03 293.82 647.67 293.82H646.26C645.98 293.82 645.72 293.67 645.58 293.43C645.43 293.17 645.16 293.04 644.9 293.04C644.64 293.04 644.37 293.17 644.22 293.43C644.08 293.67 643.82 293.82 643.54 293.82H640.9C640.62 293.82 640.36 293.67 640.22 293.43C640.07 293.17 639.8 293.04 639.54 293.04C639.28 293.04 639.01 293.17 638.86 293.43C638.77 293.54 638.75 293.58 638.72 293.61C638.63 293.68 638.6 293.71 638.56 293.73C638.31 293.82 638.25 293.83 638.18 293.83H636.77C635.41 293.83 632.4 286.35 632.4 284.44C632.4 283.08 632.9 280.78 633.52 278.86C632.46 276.28 631.58 273.05 631.58 270.85C631.58 267.5 633.05 264.37 634.13 262.05H634.14Z"
        fill="#F4F4F4"
      />
      <path
        d="M680.57 414.87C680.01 413.87 679.49 412.85 679.49 411.62C679.49 408.7 681.16 406.18 683.6 404.95C684.09 404.7 684.4 404.21 684.4 403.66V402.92H684.25C684.17 402.92 684.1 402.85 684.1 402.77C684.1 402.69 684.17 402.62 684.25 402.62H684.4V402.27C684.06 402.27 683.82 402.02 683.82 401.72V399.38C683.82 399.07 684.07 398.83 684.37 398.83H689.57C689.88 398.83 690.12 399.08 690.12 399.38V401.72C690.12 402.03 689.87 402.27 689.57 402.27V402.62H689.69C689.77 402.62 689.84 402.69 689.84 402.77C689.84 402.85 689.77 402.92 689.69 402.92H689.57V403.21L689.54 403.66C689.54 404.21 689.85 404.7 690.34 404.95C692.78 406.18 694.45 408.71 694.45 411.62C694.45 412.85 693.93 413.86 693.37 414.87V433.13C694.06 433.84 694.48 434.82 694.45 435.88L694.25 442.76C694.25 443.99 693.36 445 692.27 445H681.69C680.6 445 679.71 444 679.71 442.76L679.51 435.88C679.48 434.82 679.9 433.84 680.59 433.14V414.86L680.57 414.87Z"
        fill="#F4F4F4"
      />
      <path
        d="M688.08 278.41C688.98 279.34 689.52 280.6 689.48 281.99L689.22 290.94C689.22 292.55 688.07 293.85 686.65 293.85H672.89C671.47 293.85 670.32 292.55 670.32 290.94L670.06 281.99C670.02 280.61 670.56 279.34 671.46 278.43V254.67C670.74 253.37 670.06 252.05 670.06 250.45C670.06 246.66 672.23 243.37 675.4 241.77C676.03 241.45 676.44 240.81 676.44 240.1V239.14H676.25C676.15 239.14 676.06 239.05 676.06 238.95C676.06 238.85 676.15 238.76 676.25 238.76H676.44V238.3C676 238.3 675.68 237.98 675.68 237.58V234.54C675.68 234.14 676 233.82 676.4 233.82H683.16C683.56 233.82 683.88 234.14 683.88 234.54V237.58C683.88 237.98 683.56 238.3 683.16 238.3V238.76H683.31C683.41 238.76 683.5 238.85 683.5 238.95C683.5 239.05 683.41 239.14 683.31 239.14H683.16V239.52L683.12 240.1C683.12 240.81 683.53 241.45 684.16 241.77C687.33 243.37 689.5 246.66 689.5 250.45C689.5 252.05 688.82 253.37 688.1 254.67V278.41H688.08Z"
        fill="#F4F4F4"
      />
      <path
        d="M632.96 208.16C633.41 207.54 633.84 206.96 634.12 206.49C634.21 206.33 634.3 206.17 634.38 206.01C634.42 205.93 634.45 205.84 634.48 205.74C634.51 205.58 634.53 205.42 634.53 205.25C634.53 205.09 634.51 204.93 634.47 204.77C634.44 204.66 634.39 204.55 634.34 204.44C634.29 204.34 634.23 204.23 634.17 204.13C634.11 204.04 634.05 203.94 633.98 203.87C633.72 203.6 631.59 198.59 631.42 196.74C631 192.1 636.65 179.73 637.79 178.45V176.37H637.62C637.52 176.37 637.45 176.31 637.45 176.23C637.45 176.15 637.53 176.09 637.62 176.09H637.79V175.76C637.39 175.76 637.09 175.52 637.09 175.23V173C637.09 172.71 637.39 172.47 637.75 172.47H643.95C644.31 172.47 644.61 172.71 644.61 173V175.23C644.61 175.52 644.31 175.76 643.95 175.76C643.91 175.76 643.91 176.09 643.91 176.09H644.08C644.18 176.09 644.25 176.15 644.25 176.23C644.25 176.31 644.17 176.37 644.08 176.37H643.91V178.45C645.05 179.73 650.55 192.09 650.28 196.74C650.17 198.59 648.62 202.95 647.72 203.87C647.65 203.95 647.59 204.04 647.53 204.13C647.47 204.23 647.41 204.33 647.36 204.44C647.31 204.55 647.26 204.65 647.23 204.77C647.19 204.93 647.18 205.09 647.17 205.25C647.17 205.41 647.19 205.57 647.23 205.73C647.25 205.82 647.28 205.91 647.32 206C647.4 206.16 647.49 206.32 647.58 206.48C648.43 207.91 650.64 211.3 650.64 212.95C650.64 214.48 647.63 220.46 646.27 220.46H644.87C644.59 220.46 644.33 220.34 644.19 220.15C643.89 219.73 643.13 219.73 642.83 220.15C642.69 220.34 642.43 220.46 642.15 220.46H639.52C639.24 220.46 638.98 220.34 638.84 220.15C638.54 219.73 637.78 219.73 637.48 220.15C637.4 220.26 637.29 220.34 637.15 220.39C637.03 220.44 636.92 220.46 636.8 220.46H635.4C634.04 220.46 631.03 214.48 631.03 212.95C631.03 211.84 632.02 209.41 632.93 208.15L632.96 208.16Z"
        fill="#F4F4F4"
      />
      <path
        d="M795.739 262.41C796.059 262.82 796.48 264.73 796.89 267.28C797.63 271.96 798.309 278.8 798.189 282.44C798.029 287.53 797.819 291.38 797.819 291.38C797.819 292.74 796.719 293.85 795.349 293.85H782.179C780.819 293.85 779.71 292.75 779.71 291.38C779.71 291.38 779.5 287.53 779.34 282.44C779.22 278.8 779.9 271.97 780.64 267.28C781.04 264.73 781.46 262.83 781.78 262.41C781.92 262.24 782.029 262.03 782.109 261.81C782.149 261.71 782.169 261.61 782.199 261.5C781.909 261.3 781.879 261.26 781.859 261.22C781.799 261.09 781.78 261.02 781.78 260.95V260.38C781.78 260.3 781.799 260.23 781.819 260.16C781.959 259.95 782 259.94 782.03 259.91C782.16 259.83 782.209 259.83 782.249 259.82C782.309 259.7 782.319 259.59 782.319 259.48C782.199 259.45 782.159 259.45 782.109 259.43C782.009 259.36 781.969 259.34 781.939 259.31C781.789 259.06 781.78 258.99 781.78 258.91V258.34C781.78 258.26 781.799 258.19 781.819 258.12C781.959 257.91 782 257.9 782.03 257.87C782.15 257.8 782.199 257.79 782.239 257.78C782.299 257.71 782.299 257.65 782.299 257.59C782.299 257.54 782.299 257.49 782.299 257.44C782.189 257.41 782.149 257.4 782.099 257.39C781.999 257.32 781.959 257.3 781.929 257.27C781.899 257.24 781.889 257.21 781.869 257.17C781.789 257.02 781.77 256.95 781.77 256.87V256.3C781.77 256.23 781.789 256.16 781.809 256.09C782.179 255.59 782.169 255.54 782.159 255.51C782.079 255.3 781.99 255.1 781.89 254.9C781.02 253.09 779.689 251.47 779.689 249.3C779.689 245.77 781.709 242.71 784.659 241.22C785.249 240.92 785.629 240.32 785.629 239.66V238.76H785.449C785.349 238.76 785.27 238.68 785.27 238.58C785.27 238.48 785.349 238.4 785.449 238.4H785.629V237.98C785.219 237.98 784.919 237.68 784.919 237.31V234.48C784.919 234.11 785.22 233.81 785.59 233.81H791.89C792.26 233.81 792.559 234.11 792.559 234.48V237.31C792.559 237.68 792.26 237.98 791.89 237.98C791.85 237.98 791.849 238.4 791.849 238.4H792.03C792.13 238.4 792.21 238.48 792.21 238.58C792.21 238.68 792.13 238.76 792.03 238.76H791.849V239.06C791.849 239.11 791.849 239.66 791.849 239.66C791.849 240.32 792.229 240.92 792.819 241.22C795.769 242.71 797.789 245.77 797.789 249.3C797.789 251.46 796.46 253.08 795.59 254.9C795.49 255.1 795.399 255.3 795.319 255.51C795.309 255.54 795.299 255.59 795.289 255.65C795.589 255.95 795.609 255.99 795.629 256.02C795.689 256.15 795.71 256.22 795.71 256.29V256.86C795.71 256.94 795.689 257.01 795.669 257.08C795.529 257.29 795.49 257.31 795.449 257.33C795.339 257.4 795.299 257.4 795.249 257.41C795.179 257.54 795.179 257.64 795.179 257.75C795.289 257.78 795.339 257.78 795.379 257.8C795.479 257.87 795.519 257.89 795.549 257.92C795.579 257.95 795.589 257.98 795.609 258.01C795.689 258.16 795.71 258.23 795.71 258.31V258.88C795.71 258.96 795.689 259.03 795.669 259.1C795.519 259.31 795.49 259.33 795.449 259.35C795.329 259.42 795.279 259.43 795.229 259.44C795.159 259.57 795.159 259.67 795.159 259.78C795.269 259.8 795.319 259.81 795.369 259.83C795.469 259.9 795.509 259.92 795.539 259.95C795.689 260.2 795.699 260.27 795.699 260.35V260.92C795.699 260.99 795.679 261.06 795.659 261.13C795.319 261.57 795.339 261.68 795.379 261.78C795.469 262 795.58 262.21 795.71 262.38L795.739 262.41Z"
        fill="#F4F4F4"
      />
      <path
        d="M635.389 358.07C635.839 357.29 636.269 356.57 636.549 355.99C636.639 355.79 636.729 355.59 636.809 355.39C636.849 355.29 636.879 355.17 636.909 355.06C636.939 354.86 636.959 354.65 636.959 354.45C636.959 354.25 636.939 354.04 636.899 353.84C636.869 353.7 636.819 353.57 636.769 353.43C636.719 353.3 636.659 353.17 636.599 353.05C636.539 352.94 636.479 352.82 636.409 352.72C636.149 352.38 634.019 346.12 633.849 343.81C633.429 338 639.079 322.53 640.219 320.94V318.33H640.049C639.949 318.33 639.879 318.25 639.879 318.16C639.879 318.07 639.959 317.99 640.049 317.99H640.219V317.57C639.819 317.57 639.519 317.27 639.519 316.91V314.12C639.519 313.76 639.819 313.46 640.179 313.46H646.379C646.749 313.46 647.039 313.76 647.039 314.12V316.91C647.039 317.27 646.739 317.57 646.379 317.57C646.339 317.57 646.339 317.99 646.339 317.99H646.509C646.609 317.99 646.679 318.07 646.679 318.16C646.679 318.25 646.599 318.33 646.509 318.33H646.339V320.94C647.479 322.54 652.979 338 652.709 343.81C652.599 346.13 651.049 351.57 650.149 352.72C650.079 352.81 650.019 352.93 649.959 353.05C649.899 353.18 649.839 353.31 649.789 353.44C649.739 353.57 649.689 353.71 649.659 353.85C649.619 354.05 649.609 354.25 649.599 354.46C649.599 354.66 649.619 354.87 649.659 355.07C649.679 355.19 649.709 355.3 649.749 355.41C649.829 355.61 649.919 355.82 650.009 356.01C650.859 357.8 653.069 362.03 653.069 364.09C653.069 366 650.059 373.48 648.699 373.48H647.299C647.019 373.48 646.759 373.33 646.619 373.09C646.319 372.57 645.559 372.57 645.259 373.09C645.119 373.33 644.859 373.48 644.579 373.48H641.949C641.669 373.48 641.409 373.33 641.269 373.09C640.969 372.57 640.209 372.57 639.909 373.09C639.829 373.22 639.719 373.33 639.579 373.39C639.459 373.45 639.349 373.48 639.229 373.48H637.829C636.469 373.48 633.459 366 633.459 364.09C633.459 362.71 634.449 359.67 635.359 358.09L635.389 358.07Z"
        fill="#F4F4F4"
      />
      <path
        d="M723.079 262.41C723.399 262.82 723.819 264.73 724.229 267.28C724.969 271.96 725.649 278.8 725.529 282.44C725.369 287.53 725.159 291.38 725.159 291.38C725.159 292.74 724.059 293.85 722.689 293.85H709.519C708.159 293.85 707.049 292.75 707.049 291.38C707.049 291.38 706.839 287.53 706.679 282.44C706.559 278.8 707.239 271.97 707.979 267.28C708.379 264.73 708.799 262.83 709.119 262.41C709.259 262.24 709.369 262.03 709.449 261.81C709.489 261.71 709.509 261.61 709.539 261.5C709.249 261.3 709.219 261.26 709.199 261.22C709.139 261.09 709.119 261.02 709.119 260.95V260.38C709.119 260.3 709.139 260.23 709.159 260.16C709.299 259.95 709.339 259.94 709.369 259.91C709.499 259.83 709.549 259.83 709.589 259.82C709.649 259.7 709.659 259.59 709.659 259.48C709.539 259.45 709.499 259.45 709.449 259.43C709.349 259.36 709.309 259.34 709.269 259.31C709.119 259.06 709.109 258.99 709.109 258.91V258.34C709.109 258.26 709.129 258.19 709.149 258.12C709.289 257.91 709.329 257.9 709.359 257.87C709.479 257.8 709.529 257.79 709.569 257.78C709.629 257.71 709.629 257.65 709.629 257.59C709.629 257.54 709.629 257.49 709.629 257.44C709.519 257.41 709.479 257.4 709.429 257.39C709.329 257.32 709.289 257.3 709.259 257.27C709.229 257.24 709.219 257.21 709.199 257.17C709.119 257.02 709.109 256.95 709.109 256.87V256.3C709.109 256.23 709.129 256.16 709.149 256.09C709.519 255.59 709.509 255.54 709.499 255.51C709.419 255.3 709.329 255.1 709.229 254.9C708.359 253.09 707.029 251.47 707.029 249.3C707.029 245.77 709.049 242.71 711.999 241.22C712.589 240.92 712.969 240.32 712.969 239.66V238.76H712.789C712.689 238.76 712.609 238.68 712.609 238.58C712.609 238.48 712.689 238.4 712.789 238.4H712.969V237.98C712.559 237.98 712.259 237.68 712.259 237.31V234.48C712.259 234.11 712.559 233.81 712.929 233.81H719.229C719.599 233.81 719.899 234.11 719.899 234.48V237.31C719.899 237.68 719.599 237.98 719.229 237.98C719.189 237.98 719.189 238.4 719.189 238.4H719.369C719.469 238.4 719.549 238.48 719.549 238.58C719.549 238.68 719.469 238.76 719.369 238.76H719.189V239.06C719.189 239.11 719.189 239.66 719.189 239.66C719.189 240.32 719.569 240.92 720.159 241.22C723.109 242.71 725.129 245.77 725.129 249.3C725.129 251.46 723.799 253.08 722.929 254.9C722.829 255.1 722.739 255.3 722.659 255.51C722.649 255.54 722.639 255.59 722.629 255.65C722.929 255.95 722.949 255.99 722.969 256.02C723.029 256.15 723.049 256.22 723.049 256.29V256.86C723.049 256.94 723.029 257.01 723.009 257.08C722.869 257.29 722.829 257.31 722.789 257.33C722.679 257.4 722.639 257.4 722.589 257.41C722.519 257.54 722.519 257.64 722.519 257.75C722.619 257.77 722.669 257.78 722.699 257.79C722.819 257.87 722.859 257.89 722.889 257.92C723.029 258.16 723.049 258.24 723.049 258.32V258.89C723.049 258.97 723.029 259.04 723.009 259.11C722.859 259.32 722.829 259.34 722.789 259.36C722.669 259.43 722.619 259.44 722.569 259.45C722.499 259.58 722.499 259.68 722.499 259.79C722.609 259.81 722.649 259.82 722.689 259.83C722.809 259.91 722.849 259.93 722.879 259.96C723.029 260.21 723.039 260.28 723.039 260.36V260.93C723.039 261 723.019 261.07 722.999 261.14C722.659 261.58 722.679 261.69 722.719 261.79C722.809 262.01 722.919 262.22 723.049 262.39L723.079 262.41Z"
        fill="#F4F4F4"
      />
      <path
        d="M670.79 363.47C670.73 363.43 670.68 363.37 670.63 363.31C670.53 363.15 670.49 363.05 670.49 362.93C670.49 362.7 670.48 362.46 670.47 362.22C670.39 359.72 670.32 356.92 670.3 354.13C670.3 353.95 670.3 353.78 670.3 353.6C670.3 353.41 670.3 353.22 670.3 353.03C670.3 352.41 670.3 351.79 670.3 351.18C670.3 351.04 670.3 350.9 670.3 350.76C670.3 350.11 670.3 349.47 670.32 348.83C670.32 348.74 670.32 348.66 670.32 348.58C670.33 347.91 670.35 347.25 670.37 346.61C670.39 345.88 670.42 345.23 670.45 344.61C670.54 342.93 670.67 341.47 670.85 340.35C671.04 339.21 671.87 337.14 672.71 335.93C672.77 335.85 672.83 335.77 672.89 335.69C672.95 335.61 672.98 335.53 673 335.45C673.05 335.19 672.81 334.89 672.88 334.57C672.93 334.36 673.14 334.15 673.21 333.94C673.25 333.81 673.29 333.68 673.31 333.55C673.33 333.45 673.34 333.35 673.33 333.26C673.33 333.2 673.32 333.14 673.3 333.08C673.2 332.82 673.11 332.62 673.02 332.42C672.17 330.63 670.85 329.04 670.85 326.91C670.85 323.42 672.85 323.71 675.76 322.23C676.33 321.94 676.7 321.35 676.7 320.7V319.81H676.52C676.42 319.81 676.35 319.73 676.35 319.64C676.35 319.55 676.43 319.47 676.52 319.47H676.69V319.05C676.29 319.05 675.99 318.75 675.99 318.39V315.6C675.99 315.24 676.29 314.94 676.65 314.94H682.85C683.22 314.94 683.51 315.24 683.51 315.6V318.39C683.51 318.76 683.21 319.05 682.85 319.05C682.81 319.05 682.81 319.47 682.81 319.47H682.98C683.08 319.47 683.15 319.55 683.15 319.64C683.15 319.73 683.07 319.81 682.98 319.81H682.81V320.7C682.81 321.34 683.17 321.93 683.75 322.23C686.66 323.71 688.66 323.42 688.66 326.91C688.66 329.04 687.35 330.64 686.49 332.42C686.4 332.62 686.31 332.82 686.22 333.02C686.19 333.09 686.18 333.16 686.17 333.23C686.17 333.33 686.17 333.44 686.19 333.54C686.21 333.67 686.25 333.8 686.29 333.93C686.36 334.14 686.57 334.35 686.62 334.56C686.69 334.88 686.46 335.18 686.5 335.44C686.52 335.53 686.55 335.61 686.61 335.68C686.67 335.75 686.73 335.83 686.79 335.92C687.63 337.13 688.47 339.2 688.65 340.34C688.84 341.46 688.97 342.92 689.05 344.6C689.08 345.2 689.11 345.83 689.13 346.47V346.65C689.15 347.25 689.17 347.87 689.18 348.49C689.18 348.63 689.18 348.76 689.18 348.9C689.18 349.48 689.19 350.08 689.2 350.68C689.2 350.88 689.2 351.08 689.2 351.28C689.2 351.84 689.2 352.4 689.2 352.97C689.2 353.23 689.2 353.49 689.2 353.74C689.2 353.87 689.2 354 689.2 354.13C689.17 356.92 689.1 359.72 689.02 362.22C689.02 362.46 689 362.69 689 362.93C689 363.04 688.96 363.14 688.91 363.23C688.82 363.36 688.77 363.42 688.7 363.46C688.66 363.5 688.66 366.02 688.66 366.02C688.69 366.05 688.71 366.1 688.73 366.14C688.76 366.18 688.79 366.21 688.8 366.26C688.83 366.35 688.85 366.44 688.85 366.54C688.74 369.26 688.64 371.02 688.64 371.02C688.64 372.36 687.55 373.45 686.21 373.45H673.23C671.89 373.45 670.8 372.36 670.8 371.02C670.8 371.02 670.7 369.25 670.59 366.54C670.59 366.44 670.6 366.34 670.64 366.26C670.66 366.21 670.7 366.17 670.73 366.13C670.75 366.1 670.77 366.06 670.79 366.03V363.5C670.79 363.5 670.77 363.47 670.75 363.46L670.79 363.47Z"
        fill="#F4F4F4"
      />
      <path
        d="M760.739 278.41C761.639 279.34 762.179 280.6 762.139 281.99L761.879 290.94C761.879 292.55 760.729 293.85 759.309 293.85H745.549C744.129 293.85 742.979 292.55 742.979 290.94L742.719 281.99C742.679 280.61 743.219 279.34 744.119 278.43V254.67C743.399 253.37 742.719 252.05 742.719 250.45C742.719 246.66 744.889 243.37 748.059 241.77C748.689 241.45 749.099 240.81 749.099 240.1V239.14H748.909C748.809 239.14 748.719 239.05 748.719 238.95C748.719 238.85 748.809 238.76 748.909 238.76H749.099V238.3C748.659 238.3 748.339 237.98 748.339 237.58V234.54C748.339 234.14 748.659 233.82 749.059 233.82H755.819C756.219 233.82 756.539 234.14 756.539 234.54V237.58C756.539 237.98 756.219 238.3 755.819 238.3V238.76H755.969C756.069 238.76 756.159 238.85 756.159 238.95C756.159 239.05 756.069 239.14 755.969 239.14H755.819V239.52L755.779 240.1C755.779 240.81 756.189 241.45 756.819 241.77C759.989 243.37 762.159 246.66 762.159 250.45C762.159 252.05 761.479 253.37 760.759 254.67V278.41H760.739Z"
        fill="#F4F4F4"
      />
      <path
        d="M823.269 414.87C822.709 413.87 822.189 412.85 822.189 411.62C822.189 408.7 823.859 406.18 826.299 404.95C826.789 404.7 827.099 404.21 827.099 403.66V402.92H826.949C826.869 402.92 826.799 402.85 826.799 402.77C826.799 402.69 826.869 402.62 826.949 402.62H827.099V402.27C826.759 402.27 826.519 402.02 826.519 401.72V399.38C826.519 399.07 826.769 398.83 827.069 398.83H832.269C832.579 398.83 832.819 399.08 832.819 399.38V401.72C832.819 402.03 832.569 402.27 832.269 402.27V402.62H832.389C832.469 402.62 832.539 402.69 832.539 402.77C832.539 402.85 832.469 402.92 832.389 402.92H832.269V403.21L832.239 403.66C832.239 404.21 832.549 404.7 833.039 404.95C835.479 406.18 837.149 408.71 837.149 411.62C837.149 412.85 836.629 413.86 836.069 414.87V433.13C836.759 433.84 837.179 434.82 837.149 435.88L836.949 442.76C836.949 443.99 836.059 445 834.969 445H824.389C823.299 445 822.409 444 822.409 442.76L822.209 435.88C822.179 434.82 822.589 433.84 823.289 433.14V414.86L823.269 414.87Z"
        fill="#F4F4F4"
      />
      <path
        d="M818.49 348.84C818.49 348.76 818.49 348.67 818.49 348.59C818.5 347.92 818.52 347.25 818.54 346.62C818.56 345.89 818.59 345.24 818.62 344.62C818.71 342.94 818.84 341.48 819.02 340.36C819.21 339.22 820.04 337.15 820.88 335.94C820.94 335.86 821 335.77 821.06 335.7C821.12 335.62 821.15 335.54 821.17 335.45C821.22 335.19 820.98 334.89 821.05 334.57C821.1 334.36 821.31 334.15 821.38 333.94C821.42 333.81 821.46 333.68 821.48 333.55C821.5 333.45 821.51 333.35 821.5 333.26C821.5 333.2 821.49 333.14 821.47 333.08C821.37 332.82 821.28 332.62 821.19 332.42C820.34 330.63 819.02 329.04 819.02 326.91C819.02 323.42 821.02 323.71 823.93 322.24C824.5 321.95 824.87 321.36 824.87 320.71V319.82H824.7C824.6 319.82 824.53 319.74 824.53 319.65C824.53 319.56 824.61 319.48 824.7 319.48H824.87V319.06C824.47 319.06 824.17 318.76 824.17 318.4V315.61C824.17 315.25 824.47 314.95 824.83 314.95H831.03C831.4 314.95 831.69 315.25 831.69 315.61V318.4C831.69 318.77 831.39 319.06 831.03 319.06C830.99 319.06 830.99 319.48 830.99 319.48H831.16C831.26 319.48 831.33 319.56 831.33 319.65C831.33 319.74 831.25 319.82 831.16 319.82H830.99V320.71C830.99 321.35 831.35 321.94 831.93 322.24C834.84 323.72 836.84 323.43 836.84 326.91C836.84 329.04 835.53 330.64 834.67 332.42C834.58 332.62 834.49 332.82 834.4 333.02C834.37 333.09 834.36 333.16 834.35 333.23C834.35 333.33 834.35 333.44 834.37 333.54C834.39 333.67 834.43 333.8 834.47 333.93C834.54 334.14 834.75 334.35 834.8 334.56C834.87 334.88 834.64 335.18 834.68 335.44C834.7 335.53 834.73 335.61 834.79 335.69C834.85 335.76 834.91 335.84 834.97 335.93C835.81 337.14 836.64 339.21 836.83 340.35C837.02 341.47 837.15 342.93 837.23 344.61C837.26 345.21 837.29 345.85 837.31 346.5C837.31 346.55 837.31 346.6 837.31 346.65C837.33 347.25 837.34 347.88 837.35 348.52C837.35 348.65 837.35 348.78 837.35 348.91C837.35 349.5 837.36 350.09 837.37 350.7C837.37 350.9 837.37 351.1 837.37 351.3C837.37 351.86 837.37 352.41 837.37 352.98C837.37 353.25 837.37 353.51 837.37 353.78C837.37 353.91 837.37 354.03 837.37 354.16C837.34 356.95 837.27 359.75 837.19 362.25C837.19 362.49 837.17 362.72 837.17 362.96C837.17 363.07 837.13 363.17 837.08 363.26C836.99 363.39 836.94 363.45 836.87 363.49C836.83 363.53 836.83 366.05 836.83 366.05C836.92 366.19 836.96 366.23 836.98 366.28C837.01 366.37 837.03 366.46 837.03 366.56C836.92 369.28 836.82 371.04 836.82 371.04C836.82 372.38 835.73 373.47 834.39 373.47H821.41C820.07 373.47 818.98 372.38 818.98 371.04C818.98 371.04 818.88 369.27 818.77 366.56C818.77 366.46 818.78 366.36 818.82 366.28C818.84 366.23 818.88 366.19 818.91 366.14C818.93 366.11 818.95 366.07 818.97 366.04V363.51C818.87 363.43 818.82 363.37 818.78 363.31C818.68 363.15 818.64 363.05 818.64 362.93C818.64 362.7 818.63 362.46 818.62 362.22C818.54 359.72 818.47 356.92 818.45 354.13C818.45 353.96 818.45 353.78 818.45 353.61C818.45 353.42 818.45 353.23 818.45 353.03C818.45 352.41 818.45 351.8 818.45 351.19C818.45 351.04 818.45 350.9 818.45 350.75C818.45 350.1 818.45 349.46 818.47 348.83L818.49 348.84Z"
        fill="#F4F4F4"
      />
      <path
        d="M643.37 422.13C643.37 421.48 643.37 420.83 643.39 420.2V419.94C643.41 419.27 643.42 418.61 643.44 417.97C643.46 417.24 643.49 416.59 643.52 415.97C643.61 414.29 643.74 412.83 643.92 411.71C644.11 410.57 644.94 408.5 645.78 407.29C645.84 407.21 645.9 407.12 645.96 407.05C646.02 406.97 646.05 406.89 646.07 406.8C646.12 406.54 645.88 406.24 645.95 405.92C646 405.71 646.21 405.5 646.28 405.29C646.32 405.16 646.36 405.03 646.38 404.9C646.4 404.8 646.41 404.7 646.4 404.61C646.4 404.55 646.39 404.49 646.37 404.43C646.27 404.17 646.18 403.97 646.09 403.77C645.24 401.98 643.92 400.39 643.92 398.26C643.92 394.77 645.92 395.06 648.83 393.59C649.4 393.3 649.77 392.71 649.77 392.06V391.17H649.59C649.49 391.17 649.42 391.09 649.42 391C649.42 390.91 649.5 390.83 649.59 390.83H649.76V390.41C649.36 390.41 649.06 390.11 649.06 389.75V386.96C649.06 386.59 649.36 386.3 649.72 386.3H655.92C656.29 386.3 656.58 386.6 656.58 386.96V389.75C656.58 390.12 656.28 390.41 655.92 390.41C655.88 390.41 655.88 390.83 655.88 390.83H656.05C656.15 390.83 656.22 390.91 656.22 391C656.22 391.09 656.14 391.17 656.05 391.17H655.88V392.06C655.88 392.7 656.24 393.29 656.82 393.59C659.73 395.07 661.73 394.78 661.73 398.26C661.73 400.39 660.42 401.99 659.56 403.77C659.47 403.97 659.38 404.17 659.29 404.37C659.26 404.44 659.25 404.51 659.24 404.58C659.24 404.68 659.24 404.79 659.26 404.89C659.28 405.02 659.32 405.15 659.36 405.28C659.43 405.49 659.64 405.7 659.69 405.91C659.76 406.23 659.53 406.53 659.57 406.79C659.59 406.88 659.62 406.96 659.68 407.04C659.74 407.11 659.8 407.19 659.86 407.28C660.7 408.49 661.54 410.56 661.72 411.7C661.91 412.82 662.04 414.28 662.12 415.96C662.15 416.56 662.18 417.19 662.2 417.84C662.2 417.9 662.2 417.95 662.2 418C662.22 418.6 662.23 419.22 662.24 419.86C662.24 419.99 662.24 420.12 662.24 420.25C662.24 420.84 662.25 421.44 662.26 422.04C662.26 422.23 662.26 422.42 662.26 422.62C662.26 423.18 662.26 423.75 662.26 424.32C662.26 424.58 662.26 424.83 662.26 425.09C662.26 425.22 662.26 425.35 662.26 425.49C662.23 428.28 662.16 431.08 662.08 433.58C662.08 433.82 662.06 434.05 662.06 434.29C662.06 434.4 662.02 434.5 661.97 434.59C661.88 434.72 661.83 434.78 661.76 434.82C661.72 434.86 661.72 437.38 661.72 437.38C661.81 437.51 661.85 437.56 661.87 437.61C661.9 437.7 661.92 437.79 661.92 437.89C661.81 440.61 661.71 442.37 661.71 442.37C661.71 443.71 660.62 444.8 659.28 444.8H646.3C644.96 444.8 643.87 443.71 643.87 442.37C643.87 442.37 643.77 440.6 643.66 437.89C643.66 437.79 643.67 437.69 643.71 437.61C643.73 437.55 643.77 437.5 643.81 437.46C643.86 437.38 643.86 434.86 643.86 434.86C643.76 434.78 643.71 434.72 643.67 434.66C643.57 434.5 643.53 434.4 643.53 434.28C643.53 434.05 643.52 433.81 643.51 433.57C643.43 431.07 643.36 428.27 643.34 425.48C643.34 425.29 643.34 425.11 643.34 424.92C643.34 424.75 643.34 424.58 643.34 424.4C643.34 423.77 643.34 423.14 643.34 422.52C643.34 422.39 643.34 422.25 643.34 422.12L643.37 422.13Z"
        fill="#F4F4F4"
      />
      <path
        d="M792.239 404.48V404.09H792.049C791.949 404.09 791.859 404.01 791.859 403.9C791.859 403.79 791.939 403.71 792.049 403.71H792.239V403.26C791.809 403.26 791.489 402.94 791.489 402.55V399.54C791.489 399.15 791.809 398.83 792.199 398.83H798.889C799.279 398.83 799.599 399.15 799.599 399.54V402.55C799.599 402.94 799.279 403.26 798.889 403.26C798.849 403.26 798.849 403.71 798.849 403.71H799.039C799.139 403.71 799.229 403.79 799.229 403.9C799.229 404.01 799.149 404.09 799.039 404.09H798.849V406.9C800.079 408.62 805.019 425.28 805.019 431.56C805.019 431.71 805.019 431.87 805.019 432.03C804.929 434.75 804.079 438.39 803.209 441.12C803.109 441.44 803.009 441.75 802.899 442.04C802.649 442.77 802.399 443.41 802.169 443.9C801.859 444.59 801.589 445 801.429 445H799.909C799.609 445 799.329 444.87 799.169 444.66C798.839 444.2 798.019 444.2 797.699 444.66C797.549 444.87 797.269 445 796.959 445H794.109C793.809 445 793.529 444.87 793.369 444.66C793.039 444.2 792.219 444.2 791.899 444.66C791.809 444.79 791.669 444.88 791.499 444.94C791.359 444.98 791.259 445 791.159 445H789.639C789.469 445 789.209 444.59 788.889 443.9C788.669 443.41 788.419 442.77 788.169 442.04C788.069 441.75 787.969 441.44 787.869 441.12C787.009 438.39 786.159 434.76 786.069 432.03C786.069 431.87 786.069 431.71 786.069 431.56C786.069 425.28 791.009 408.62 792.239 406.9V404.48Z"
        fill="#F4F4F4"
      />
      <path
        d="M783.579 358.07C784.029 357.29 784.459 356.57 784.739 355.99C784.829 355.79 784.919 355.59 784.999 355.39C785.039 355.29 785.069 355.17 785.099 355.06C785.129 354.86 785.149 354.65 785.149 354.45C785.149 354.25 785.129 354.04 785.089 353.84C785.059 353.7 785.009 353.57 784.959 353.43C784.909 353.3 784.849 353.17 784.789 353.05C784.729 352.94 784.669 352.82 784.599 352.72C784.339 352.38 782.209 346.12 782.039 343.81C781.619 338 787.269 322.53 788.409 320.94V318.33H788.239C788.139 318.33 788.069 318.25 788.069 318.16C788.069 318.07 788.149 317.99 788.239 317.99H788.409V317.57C788.009 317.57 787.709 317.27 787.709 316.91V314.12C787.709 313.75 788.009 313.46 788.369 313.46H794.569C794.939 313.46 795.229 313.76 795.229 314.12V316.91C795.229 317.27 794.929 317.57 794.569 317.57C794.529 317.57 794.529 317.99 794.529 317.99H794.699C794.799 317.99 794.869 318.07 794.869 318.16C794.869 318.25 794.789 318.33 794.699 318.33H794.529V320.94C795.669 322.54 801.169 338 800.899 343.81C800.789 346.13 799.239 351.57 798.339 352.72C798.269 352.82 798.209 352.93 798.149 353.05C798.089 353.18 798.029 353.3 797.979 353.43C797.929 353.56 797.879 353.7 797.849 353.84C797.809 354.04 797.799 354.24 797.789 354.45C797.789 354.65 797.809 354.86 797.849 355.06C797.869 355.18 797.899 355.29 797.939 355.4C798.019 355.6 798.109 355.81 798.199 356C799.049 357.79 801.259 362.02 801.259 364.08C801.259 365.99 798.249 373.47 796.889 373.47H795.489C795.209 373.47 794.949 373.32 794.809 373.08C794.509 372.56 793.749 372.56 793.449 373.08C793.309 373.32 793.049 373.47 792.769 373.47H790.139C789.859 373.47 789.599 373.32 789.459 373.08C789.159 372.56 788.399 372.56 788.099 373.08C788.019 373.21 787.909 373.32 787.769 373.38C787.649 373.44 787.539 373.47 787.419 373.47H786.019C784.659 373.47 781.649 365.99 781.649 364.08C781.649 362.7 782.639 359.66 783.549 358.08L783.579 358.07Z"
        fill="#F4F4F4"
      />
      <path
        d="M717.79 404.48V404.09H717.6C717.5 404.09 717.41 404.01 717.41 403.9C717.41 403.79 717.49 403.71 717.6 403.71H717.79V403.26C717.36 403.26 717.04 402.94 717.04 402.55V399.54C717.04 399.15 717.36 398.83 717.75 398.83H724.44C724.83 398.83 725.15 399.15 725.15 399.54V402.55C725.15 402.94 724.83 403.26 724.44 403.26C724.4 403.26 724.4 403.71 724.4 403.71H724.59C724.69 403.71 724.78 403.79 724.78 403.9C724.78 404.01 724.7 404.09 724.59 404.09H724.4V406.9C725.63 408.62 730.57 425.28 730.57 431.56C730.57 431.71 730.57 431.87 730.57 432.03C730.48 434.75 729.63 438.39 728.76 441.12C728.66 441.44 728.56 441.75 728.45 442.04C728.2 442.77 727.95 443.41 727.72 443.9C727.41 444.59 727.14 445 726.98 445H725.46C725.16 445 724.88 444.87 724.72 444.66C724.39 444.2 723.57 444.2 723.25 444.66C723.1 444.87 722.82 445 722.51 445H719.66C719.36 445 719.08 444.87 718.92 444.66C718.59 444.2 717.77 444.2 717.45 444.66C717.36 444.79 717.22 444.88 717.05 444.94C716.91 444.98 716.81 445 716.71 445H715.19C715.02 445 714.76 444.59 714.44 443.9C714.22 443.41 713.97 442.77 713.72 442.04C713.62 441.75 713.52 441.44 713.42 441.12C712.56 438.39 711.71 434.76 711.62 432.03C711.62 431.87 711.62 431.71 711.62 431.56C711.62 425.28 716.56 408.62 717.79 406.9V404.48Z"
        fill="#F4F4F4"
      />
      <path
        d="M708.309 358.07C708.759 357.29 709.189 356.57 709.469 355.99C709.559 355.79 709.649 355.59 709.729 355.39C709.769 355.29 709.799 355.17 709.829 355.06C709.859 354.86 709.879 354.65 709.879 354.45C709.879 354.25 709.859 354.04 709.819 353.84C709.789 353.7 709.739 353.57 709.689 353.43C709.639 353.3 709.579 353.17 709.519 353.05C709.459 352.94 709.399 352.82 709.329 352.72C709.069 352.38 706.939 346.12 706.769 343.81C706.349 338 711.999 322.53 713.139 320.94V318.33H712.969C712.869 318.33 712.799 318.25 712.799 318.16C712.799 318.07 712.879 317.99 712.969 317.99H713.139V317.57C712.739 317.57 712.439 317.27 712.439 316.91V314.12C712.439 313.75 712.739 313.46 713.099 313.46H719.299C719.659 313.46 719.959 313.76 719.959 314.12V316.91C719.959 317.27 719.659 317.57 719.299 317.57C719.259 317.57 719.259 317.99 719.259 317.99H719.429C719.529 317.99 719.599 318.07 719.599 318.16C719.599 318.25 719.519 318.33 719.429 318.33H719.259V320.94C720.399 322.54 725.899 338 725.629 343.81C725.519 346.13 723.969 351.57 723.069 352.72C722.999 352.81 722.939 352.93 722.879 353.05C722.819 353.18 722.759 353.31 722.709 353.44C722.659 353.57 722.609 353.71 722.579 353.85C722.539 354.05 722.529 354.25 722.519 354.46C722.519 354.66 722.539 354.87 722.579 355.07C722.599 355.19 722.629 355.3 722.669 355.41C722.749 355.61 722.839 355.82 722.929 356.01C723.779 357.8 725.989 362.03 725.989 364.09C725.989 366 722.979 373.48 721.619 373.48H720.219C719.939 373.48 719.679 373.33 719.539 373.09C719.239 372.57 718.479 372.57 718.179 373.09C718.039 373.33 717.779 373.48 717.499 373.48H714.869C714.589 373.48 714.329 373.33 714.189 373.09C713.889 372.57 713.129 372.57 712.829 373.09C712.749 373.22 712.639 373.33 712.499 373.39C712.379 373.45 712.269 373.48 712.149 373.48H710.749C709.389 373.48 706.379 366 706.379 364.09C706.379 362.71 707.369 359.67 708.279 358.09L708.309 358.07Z"
        fill="#F4F4F4"
      />
      <path
        d="M747.76 434.53C747.76 434.41 747.78 434.29 747.79 434.15C747.81 433.95 747.82 433.8 747.84 433.64C747.87 433.4 747.88 433.23 747.91 433.05C747.94 432.81 747.96 432.61 747.99 432.4C748.02 432.15 748.05 431.93 748.08 431.71C748.12 431.44 748.15 431.23 748.18 431.01L748.2 430.88C748.22 430.77 748.23 430.66 748.25 430.55C748.57 428.42 749 426.13 749.33 424.98C748.73 422.99 748.22 421.99 748.16 420.65C747.87 414.39 753.79 408.61 755.02 406.89V404.08H754.83C754.73 404.08 754.64 404 754.64 403.89C754.64 403.78 754.72 403.7 754.83 403.7H755.02V403.25C754.59 403.25 754.27 402.93 754.27 402.54V399.54C754.27 399.15 754.59 398.83 754.98 398.83H761.66C762.05 398.83 762.37 399.15 762.37 399.54V402.54C762.37 402.93 762.05 403.25 761.66 403.25C761.62 403.25 761.62 403.7 761.62 403.7H761.81C761.91 403.7 762 403.78 762 403.89C762 404 761.92 404.08 761.81 404.08H761.62V406.89C762.85 408.61 768.77 414.39 768.48 420.65C768.42 421.98 767.91 422.98 767.31 424.98C767.65 426.13 768.07 428.43 768.39 430.55C768.4 430.64 768.42 430.72 768.43 430.81C768.44 430.89 768.46 430.98 768.47 431.06C768.49 431.23 768.52 431.39 768.54 431.56C768.54 431.63 768.56 431.7 768.57 431.77C768.59 431.94 768.61 432.1 768.64 432.26C768.64 432.32 768.66 432.39 768.66 432.45C768.68 432.61 768.7 432.75 768.72 432.9C768.72 432.96 768.74 433.03 768.74 433.09C768.76 433.22 768.77 433.34 768.78 433.46C768.78 433.53 768.8 433.61 768.8 433.67C768.81 433.77 768.82 433.86 768.83 433.96C768.83 434.03 768.84 434.1 768.85 434.17C768.85 434.26 768.86 434.33 768.87 434.4C768.87 434.46 768.87 434.53 768.88 434.58C768.88 434.67 768.88 434.74 768.88 434.81C768.88 435.01 768.87 435.15 768.85 435.3C768.85 435.34 768.84 435.39 768.83 435.43C768.81 435.55 768.79 435.69 768.76 435.83C768.76 435.88 768.74 435.92 768.73 435.97C768.69 436.16 768.64 436.36 768.58 436.58C768.51 436.84 768.45 437.04 768.38 437.25C768.36 437.32 768.33 437.39 768.31 437.47C768.26 437.64 768.2 437.82 768.14 438C768.11 438.08 768.09 438.15 768.06 438.23C767.98 438.46 767.9 438.69 767.81 438.92C766.73 441.8 765.1 445.01 764.18 445.01H762.67C762.37 445.01 762.09 444.85 761.94 444.59C761.78 444.31 761.49 444.17 761.21 444.17C760.93 444.17 760.64 444.31 760.48 444.59C760.33 444.85 760.05 445.01 759.75 445.01H756.91C756.61 445.01 756.33 444.85 756.18 444.59C756.02 444.31 755.73 444.17 755.45 444.17C755.17 444.17 754.88 444.31 754.72 444.59C754.67 444.67 754.62 444.73 754.55 444.79C754.47 444.86 754.4 444.9 754.32 444.93C754.17 444.99 754.08 445.01 753.98 445.01H752.47C751.54 445.01 749.91 441.81 748.84 438.92C748.75 438.68 748.66 438.44 748.58 438.21C748.56 438.15 748.54 438.09 748.52 438.03C748.45 437.83 748.39 437.64 748.33 437.45C748.31 437.39 748.29 437.33 748.27 437.27C748.2 437.04 748.13 436.81 748.07 436.59C748.01 436.36 747.96 436.16 747.91 435.96C747.91 435.92 747.89 435.88 747.89 435.84C747.86 435.69 747.83 435.55 747.81 435.42C747.81 435.38 747.8 435.34 747.79 435.3C747.77 435.15 747.76 435 747.76 434.89C747.76 434.8 747.76 434.69 747.77 434.57V434.53H747.76Z"
        fill="#F4F4F4"
      />
      <path
        d="M744.42 336.18C744 330.37 749.65 322.53 750.79 320.93V318.32H750.62C750.52 318.32 750.45 318.24 750.45 318.15C750.45 318.06 750.53 317.98 750.62 317.98H750.79V317.56C750.39 317.56 750.09 317.26 750.09 316.9V314.11C750.09 313.75 750.39 313.45 750.75 313.45H756.95C757.32 313.45 757.61 313.75 757.61 314.11V316.9C757.61 317.26 757.31 317.56 756.95 317.56C756.91 317.56 756.91 317.98 756.91 317.98H757.08C757.18 317.98 757.25 318.06 757.25 318.15C757.25 318.24 757.17 318.32 757.08 318.32H756.91V320.93C758.05 322.53 763.55 330.36 763.28 336.18C763.22 337.53 762.67 339.92 762.04 341.92C763.11 344.21 764.48 347.24 764.48 350.47C764.48 352.67 763.59 355.9 762.54 358.48C763.16 360.4 763.66 362.71 763.66 364.06C763.66 365.97 760.65 373.45 759.29 373.45H757.88C757.6 373.45 757.34 373.3 757.2 373.06C757.05 372.8 756.78 372.67 756.52 372.67C756.26 372.67 755.99 372.8 755.84 373.06C755.7 373.3 755.44 373.45 755.16 373.45H752.52C752.24 373.45 751.98 373.3 751.84 373.06C751.69 372.8 751.42 372.67 751.16 372.67C750.9 372.67 750.63 372.8 750.48 373.06C750.39 373.17 750.37 373.21 750.34 373.24C750.25 373.31 750.22 373.34 750.18 373.36C749.93 373.45 749.87 373.46 749.8 373.46H748.39C747.03 373.46 744.02 365.98 744.02 364.07C744.02 362.71 744.52 360.41 745.14 358.49C744.08 355.91 743.2 352.68 743.2 350.48C743.2 347.13 744.67 344 745.75 341.68C745.13 339.71 744.5 337.4 744.41 336.18H744.42Z"
        fill="#F4F4F4"
      />
      <path
        d="M822.93 182.37V179.56H822.74C822.64 179.56 822.549 179.48 822.549 179.37C822.549 179.26 822.63 179.18 822.74 179.18H822.93V178.73C822.5 178.73 822.18 178.41 822.18 178.02V175.01C822.18 174.62 822.5 174.3 822.89 174.3H829.58C829.97 174.3 830.289 174.62 830.289 175.01V178.02C830.289 178.41 829.97 178.73 829.58 178.73C829.54 178.73 829.539 179.18 829.539 179.18H829.729C829.829 179.18 829.919 179.26 829.919 179.37C829.919 179.48 829.839 179.56 829.729 179.56H829.539V182.37C830.769 184.09 835.71 200.75 835.71 207.03C835.71 207.34 835.7 207.66 835.68 207.99C835.67 208.16 835.66 208.33 835.64 208.5C835.41 211.07 834.66 214.18 833.89 216.59C833.79 216.91 833.69 217.22 833.58 217.51C833.33 218.24 833.079 218.88 832.849 219.37C832.539 220.06 832.269 220.47 832.109 220.47H830.59C830.29 220.47 830.009 220.34 829.849 220.13C829.519 219.67 828.7 219.67 828.38 220.13C828.23 220.34 827.95 220.47 827.64 220.47H824.789C824.489 220.47 824.209 220.34 824.049 220.13C823.719 219.67 822.9 219.67 822.58 220.13C822.49 220.26 822.35 220.35 822.18 220.41C822.04 220.45 821.94 220.47 821.84 220.47H820.32C820.15 220.47 819.89 220.06 819.57 219.37C819.35 218.88 819.099 218.24 818.849 217.51C818.749 217.22 818.649 216.91 818.549 216.59C817.789 214.18 817.04 211.07 816.82 208.5C816.8 208.33 816.79 208.16 816.78 207.99C816.76 207.66 816.75 207.34 816.75 207.03C816.75 200.75 821.689 184.09 822.919 182.37H822.93Z"
        fill="#F4F4F4"
      />
      <path
        d="M674.03 182.37V179.56H673.84C673.74 179.56 673.65 179.48 673.65 179.37C673.65 179.26 673.73 179.18 673.84 179.18H674.03V178.73C673.6 178.73 673.28 178.41 673.28 178.02V175.01C673.28 174.62 673.6 174.3 673.99 174.3H680.68C681.07 174.3 681.39 174.62 681.39 175.01V178.02C681.39 178.41 681.07 178.73 680.68 178.73C680.64 178.73 680.64 179.18 680.64 179.18H680.83C680.93 179.18 681.02 179.26 681.02 179.37C681.02 179.48 680.94 179.56 680.83 179.56H680.64V182.37C681.87 184.09 686.81 200.75 686.81 207.03C686.81 207.34 686.8 207.66 686.78 207.99C686.77 208.16 686.76 208.33 686.74 208.5C686.51 211.07 685.76 214.18 684.99 216.59C684.89 216.91 684.79 217.22 684.68 217.51C684.43 218.24 684.18 218.88 683.95 219.37C683.64 220.06 683.37 220.47 683.21 220.47H681.69C681.39 220.47 681.11 220.34 680.95 220.13C680.62 219.67 679.8 219.67 679.48 220.13C679.33 220.34 679.05 220.47 678.74 220.47H675.89C675.59 220.47 675.31 220.34 675.15 220.13C674.82 219.67 674 219.67 673.68 220.13C673.59 220.26 673.45 220.35 673.28 220.41C673.14 220.45 673.04 220.47 672.94 220.47H671.42C671.25 220.47 670.99 220.06 670.67 219.37C670.45 218.88 670.2 218.24 669.95 217.51C669.85 217.22 669.75 216.91 669.65 216.59C668.89 214.18 668.14 211.07 667.91 208.5C667.9 208.33 667.88 208.16 667.87 207.99C667.85 207.66 667.84 207.34 667.84 207.03C667.84 200.75 672.78 184.09 674.01 182.37H674.03Z"
        fill="#F4F4F4"
      />
      <path
        d="M748.48 182.37V179.56H748.29C748.19 179.56 748.1 179.48 748.1 179.37C748.1 179.26 748.18 179.18 748.29 179.18H748.48V178.73C748.05 178.73 747.73 178.41 747.73 178.02V175.01C747.73 174.62 748.05 174.3 748.44 174.3H755.13C755.52 174.3 755.84 174.62 755.84 175.01V178.02C755.84 178.41 755.52 178.73 755.13 178.73C755.09 178.73 755.09 179.18 755.09 179.18H755.28C755.38 179.18 755.47 179.26 755.47 179.37C755.47 179.48 755.39 179.56 755.28 179.56H755.09V182.37C756.32 184.09 761.26 200.75 761.26 207.03C761.26 207.34 761.25 207.66 761.23 207.99C761.22 208.16 761.21 208.33 761.19 208.5C760.96 211.07 760.21 214.18 759.44 216.59C759.34 216.91 759.24 217.22 759.13 217.51C758.88 218.24 758.63 218.88 758.4 219.37C758.09 220.06 757.82 220.47 757.66 220.47H756.14C755.84 220.47 755.56 220.34 755.4 220.13C755.07 219.67 754.25 219.67 753.93 220.13C753.78 220.34 753.5 220.47 753.19 220.47H750.34C750.04 220.47 749.76 220.34 749.6 220.13C749.27 219.67 748.45 219.67 748.13 220.13C748.04 220.26 747.9 220.35 747.73 220.41C747.59 220.45 747.49 220.47 747.39 220.47H745.87C745.7 220.47 745.44 220.06 745.12 219.37C744.9 218.88 744.65 218.24 744.4 217.51C744.3 217.22 744.2 216.91 744.1 216.59C743.34 214.18 742.59 211.07 742.37 208.5C742.35 208.33 742.34 208.16 742.33 207.99C742.31 207.66 742.3 207.34 742.3 207.03C742.3 200.75 747.24 184.09 748.47 182.37H748.48Z"
        fill="#F4F4F4"
      />
      <path
        d="M778.939 212.73C778.869 212.5 778.799 212.28 778.739 212.06C778.679 211.83 778.629 211.62 778.579 211.43C778.579 211.39 778.559 211.35 778.549 211.31C778.519 211.16 778.489 211.02 778.469 210.9C778.469 210.86 778.459 210.82 778.449 210.78C778.429 210.63 778.419 210.49 778.419 210.37C778.419 210.28 778.419 210.17 778.429 210.05C778.439 209.85 778.449 209.75 778.459 209.63V209.51C778.479 209.39 778.489 209.26 778.509 209.12C778.539 208.86 778.559 208.7 778.579 208.53C778.609 208.28 778.629 208.08 778.659 207.88C778.689 207.63 778.719 207.41 778.749 207.19C778.789 206.93 778.819 206.71 778.849 206.48C778.879 206.26 778.899 206.15 778.919 206.03C779.239 203.9 779.669 201.61 779.999 200.46C779.399 198.47 778.889 197.47 778.829 196.13C778.539 189.87 784.459 184.09 785.689 182.37V179.56H785.499C785.399 179.56 785.309 179.48 785.309 179.37C785.309 179.26 785.389 179.18 785.499 179.18H785.689V178.73C785.259 178.73 784.939 178.41 784.939 178.02V175.02C784.939 174.63 785.259 174.31 785.649 174.31H792.329C792.719 174.31 793.039 174.63 793.039 175.02V178.02C793.039 178.41 792.719 178.73 792.329 178.73C792.289 178.73 792.289 179.18 792.289 179.18H792.479C792.579 179.18 792.669 179.26 792.669 179.37C792.669 179.48 792.589 179.56 792.479 179.56H792.289V182.37C793.519 184.09 799.439 189.87 799.149 196.13C799.089 197.46 798.579 198.46 797.979 200.46C798.319 201.61 798.739 203.91 799.059 206.03C799.069 206.11 799.079 206.18 799.099 206.26C799.109 206.36 799.129 206.46 799.139 206.55C799.159 206.7 799.179 206.85 799.199 207C799.209 207.09 799.219 207.17 799.239 207.25C799.259 207.4 799.279 207.54 799.299 207.69C799.309 207.77 799.319 207.85 799.329 207.93C799.349 208.07 799.359 208.19 799.379 208.32C799.379 208.4 799.399 208.49 799.409 208.56C799.419 208.67 799.429 208.77 799.449 208.88C799.449 208.97 799.469 209.06 799.479 209.14C799.479 209.22 799.489 209.29 799.499 209.37C799.499 209.46 799.519 209.56 799.529 209.64C799.529 209.69 799.529 209.74 799.539 209.79C799.539 209.88 799.549 209.97 799.559 210.05C799.559 210.22 799.569 210.3 799.569 210.36C799.569 210.49 799.559 210.62 799.539 210.77C799.539 210.82 799.529 210.86 799.519 210.91C799.499 211.03 799.479 211.16 799.449 211.3C799.439 211.35 799.429 211.4 799.419 211.45C799.379 211.64 799.329 211.84 799.269 212.05C799.189 212.32 799.139 212.52 799.069 212.72C799.049 212.8 799.019 212.87 798.999 212.95C798.949 213.12 798.889 213.29 798.829 213.46C798.799 213.54 798.779 213.62 798.749 213.7C798.669 213.93 798.589 214.16 798.499 214.39C797.419 217.27 795.789 220.48 794.869 220.48H793.359C793.059 220.48 792.779 220.32 792.629 220.06C792.469 219.78 792.179 219.64 791.899 219.64C791.619 219.64 791.329 219.78 791.169 220.06C791.019 220.32 790.739 220.48 790.439 220.48H787.599C787.299 220.48 787.019 220.32 786.869 220.06C786.709 219.78 786.419 219.64 786.139 219.64C785.859 219.64 785.569 219.78 785.409 220.06C785.359 220.14 785.309 220.2 785.239 220.26C785.159 220.33 785.089 220.37 785.009 220.4C784.859 220.46 784.769 220.48 784.669 220.48H783.159C782.229 220.48 780.599 217.28 779.529 214.39C779.439 214.15 779.349 213.91 779.269 213.68C779.249 213.62 779.229 213.56 779.209 213.5C779.139 213.3 779.079 213.11 779.019 212.92C778.999 212.86 778.979 212.8 778.959 212.74L778.939 212.73Z"
        fill="#F4F4F4"
      />
      <path
        d="M704.5 212.73C704.35 212.25 704.23 211.81 704.15 211.42C704.15 211.38 704.13 211.34 704.13 211.31C704.1 211.16 704.069 211.02 704.049 210.88C704.049 210.84 704.04 210.8 704.03 210.76C704.01 210.61 704 210.46 704 210.35C704 210.26 704 210.15 704.01 210.03C704.01 209.89 704.029 209.76 704.039 209.61C704.059 209.42 704.07 209.27 704.09 209.1C704.11 208.88 704.129 208.7 704.159 208.51C704.189 208.29 704.21 208.08 704.24 207.86C704.27 207.63 704.3 207.41 704.33 207.18C704.37 206.91 704.4 206.69 704.43 206.47C704.46 206.25 704.48 206.14 704.5 206.02C704.82 203.89 705.25 201.6 705.58 200.45C704.98 198.46 704.469 197.46 704.409 196.12C704.119 189.86 710.04 184.08 711.27 182.36V179.55H711.08C710.98 179.55 710.89 179.47 710.89 179.36C710.89 179.25 710.97 179.17 711.08 179.17H711.27V178.72C710.84 178.72 710.52 178.4 710.52 178.01V175.01C710.52 174.62 710.839 174.3 711.229 174.3H717.909C718.299 174.3 718.62 174.62 718.62 175.01V178.01C718.62 178.4 718.299 178.72 717.909 178.72C717.869 178.72 717.87 179.17 717.87 179.17H718.06C718.16 179.17 718.25 179.25 718.25 179.36C718.25 179.47 718.17 179.55 718.06 179.55H717.87V182.36C719.1 184.08 725.019 189.86 724.729 196.12C724.669 197.45 724.16 198.45 723.56 200.45C723.9 201.6 724.32 203.9 724.64 206.02C724.65 206.1 724.659 206.17 724.669 206.25C724.689 206.35 724.7 206.45 724.71 206.55C724.73 206.69 724.75 206.84 724.77 206.98C724.78 207.07 724.8 207.17 724.81 207.26C724.83 207.4 724.85 207.54 724.87 207.67C724.88 207.76 724.89 207.85 724.9 207.93C724.92 208.06 724.93 208.18 724.95 208.31C724.96 208.4 724.969 208.48 724.979 208.57C724.989 208.68 725 208.78 725.02 208.88C725.02 208.97 725.039 209.06 725.049 209.14C725.049 209.22 725.07 209.3 725.07 209.37C725.07 209.46 725.09 209.55 725.09 209.63C725.09 209.69 725.089 209.74 725.099 209.8C725.099 209.88 725.11 209.97 725.12 210.04C725.12 210.09 725.12 210.13 725.12 210.17C725.12 210.23 725.12 210.3 725.12 210.35C725.12 210.47 725.11 210.61 725.09 210.76C725.09 210.81 725.08 210.85 725.07 210.9C725.05 211.02 725.03 211.15 725 211.29C724.99 211.34 724.979 211.39 724.969 211.44C724.929 211.63 724.88 211.83 724.82 212.04C724.74 212.32 724.69 212.51 724.62 212.71C724.6 212.79 724.569 212.87 724.549 212.95C724.5 213.11 724.44 213.28 724.38 213.45C724.35 213.53 724.33 213.61 724.299 213.69C724.219 213.92 724.139 214.15 724.049 214.38C722.969 217.26 721.339 220.47 720.419 220.47H718.909C718.609 220.47 718.33 220.31 718.18 220.05C718.02 219.77 717.73 219.63 717.45 219.63C717.17 219.63 716.879 219.77 716.719 220.05C716.569 220.31 716.29 220.47 715.99 220.47H713.15C712.85 220.47 712.569 220.31 712.419 220.05C712.259 219.77 711.97 219.63 711.69 219.63C711.41 219.63 711.12 219.77 710.96 220.05C710.91 220.13 710.859 220.19 710.789 220.25C710.709 220.32 710.64 220.36 710.56 220.39C710.41 220.45 710.319 220.47 710.219 220.47H708.71C707.78 220.47 706.15 217.27 705.08 214.38C704.99 214.14 704.9 213.9 704.82 213.67C704.8 213.61 704.78 213.55 704.76 213.49C704.69 213.29 704.63 213.1 704.57 212.91C704.55 212.85 704.53 212.79 704.51 212.73H704.5Z"
        fill="#F4F4F4"
      />
      <path
        d="M612.06 151.96V489.51H856.1V151.96H612.06ZM617.98 157.88H850.19V444.99H617.98V157.88Z"
        fill="#F4F4F4"
      />
      <path d="M852.56 301.31V293.19H615.62V301.31H852.56Z" fill="#F4F4F4" />
      <path
        d="M852.55 228.59V220.47L615.61 220.47V228.59H852.55Z"
        fill="#F4F4F4"
      />
      <path d="M852.55 381.76V373.64H615.61V381.76H852.55Z" fill="#F4F4F4" />
      <path
        d="M0.679688 161.96V489.47H292.84V161.96H0.679688ZM7.49969 168.78H286.02V438.16H7.49969V168.78Z"
        fill="#F4F4F4"
      />
      <path d="M288.75 295V285.64H4.78003V295H288.75Z" fill="#F4F4F4" />
      <path
        d="M288.739 230.31V220.95L4.76926 220.95V230.31L288.739 230.31Z"
        fill="#F4F4F4"
      />
      <path d="M288.739 365.29V355.93H4.76926V365.29H288.739Z" fill="#F4F4F4" />
      <path
        d="M211.119 220.95C211.119 220.95 203.519 210.24 206.449 202.98C206.569 202.68 206.719 202.38 206.879 202.1C206.719 202.2 206.529 202.27 206.319 202.27H205.779C205.779 202.27 208.169 197.9 209.299 197.9H209.169V197.06C208.719 197.06 208.409 196.75 208.409 196.37V195.1C208.409 195.01 208.429 194.93 208.459 194.85C208.519 194.73 208.549 194.69 208.589 194.64C208.689 194.54 208.739 194.52 208.789 194.49C208.929 194.43 209.009 194.41 209.099 194.41H232.089C232.469 194.41 232.779 194.72 232.779 195.1V196.37C232.779 196.46 232.759 196.54 232.729 196.61C232.669 196.73 232.639 196.77 232.609 196.81C232.509 196.91 232.459 196.94 232.409 196.97C232.259 197.04 232.179 197.06 232.089 197.06C232.009 197.06 232.009 197.9 232.009 197.9H231.879C233.249 197.9 235.399 202.27 235.399 202.27H234.859C234.649 202.27 234.469 202.2 234.299 202.1C234.469 202.4 234.619 202.72 234.749 203.03C237.619 210.3 230.059 220.95 230.059 220.95H211.139H211.119Z"
        fill="#F4F4F4"
      />
      <path
        d="M98.1897 220.95C98.1897 220.95 90.5897 210.24 93.5197 202.98C93.6397 202.68 93.7897 202.38 93.9497 202.1C93.7897 202.2 93.5997 202.27 93.3897 202.27H92.8497C92.8497 202.27 95.2397 197.9 96.3697 197.9H96.2397V197.06C95.7897 197.06 95.4797 196.75 95.4797 196.37V195.1C95.4797 195.01 95.4997 194.93 95.5297 194.85C95.5897 194.73 95.6197 194.69 95.6597 194.64C95.7597 194.54 95.8097 194.52 95.8597 194.49C95.9997 194.43 96.0797 194.41 96.1697 194.41H119.16C119.54 194.41 119.85 194.72 119.85 195.1V196.37C119.85 196.46 119.83 196.54 119.8 196.61C119.74 196.73 119.71 196.77 119.68 196.81C119.58 196.91 119.53 196.94 119.48 196.97C119.33 197.04 119.25 197.06 119.16 197.06C119.08 197.06 119.08 197.9 119.08 197.9H118.95C120.32 197.9 122.47 202.27 122.47 202.27H121.93C121.72 202.27 121.54 202.2 121.37 202.1C121.54 202.4 121.69 202.72 121.82 203.03C124.69 210.3 117.13 220.95 117.13 220.95H98.2097H98.1897Z"
        fill="#F4F4F4"
      />
      <path
        d="M155.13 220.95H135.58C133.79 220.95 132.35 219.96 132.35 218.02V189.91C132.35 188.95 132.68 188.03 133.25 187.38L135.82 184.45L135.8 183.25C135.85 183.24 134.52 183.24 134.52 183.24C134.33 183.24 134.18 183.09 134.18 182.9V181.21C134.18 181.02 134.33 180.87 134.52 180.87H134.83V180.39C134.83 180.3 134.83 180.22 134.85 180.14C134.96 179.6 135.39 179.19 135.92 179.19H154.8C155.32 179.19 155.76 179.6 155.87 180.14C155.89 180.22 155.89 180.31 155.89 180.39V180.87H156.2C156.39 180.87 156.54 181.02 156.54 181.21V182.9C156.54 183.09 156.39 183.24 156.2 183.24H154.87C154.92 183.25 154.92 184.43 154.92 184.43C154.9 184.46 157.47 187.38 157.47 187.38C158.04 188.04 158.37 188.95 158.37 189.91V218.02C158.37 219.95 156.92 220.95 155.14 220.95H155.13Z"
        fill="#F4F4F4"
      />
      <path
        d="M273.779 202.09C273.949 202.39 274.099 202.71 274.229 203.02C277.099 210.29 269.539 220.94 269.539 220.94H250.619C250.619 220.94 243.019 210.23 245.949 202.97C246.069 202.67 246.219 202.37 246.379 202.09C246.219 202.19 246.029 202.26 245.819 202.26H245.279C245.279 202.26 247.669 197.89 248.799 197.89H248.669V197.05C248.219 197.05 247.909 196.74 247.909 196.36V195.09C247.909 195 247.929 194.92 247.959 194.84C248.019 194.72 248.049 194.68 248.089 194.63C248.189 194.53 248.239 194.51 248.289 194.48C248.429 194.42 248.509 194.4 248.599 194.4H271.589C271.969 194.4 272.279 194.71 272.279 195.09V196.36C272.279 196.45 272.259 196.53 272.229 196.6C272.169 196.72 272.139 196.76 272.109 196.8C272.009 196.9 271.959 196.93 271.909 196.96C271.759 197.03 271.679 197.05 271.589 197.05C271.509 197.05 271.509 197.89 271.509 197.89H271.379C272.749 197.89 274.899 202.26 274.899 202.26H274.359C274.149 202.26 273.969 202.19 273.799 202.09H273.779Z"
        fill="#F4F4F4"
      />
      <path
        d="M192.44 220.95H171.69C169.8 220.95 168.26 220.36 168.26 218.46V198.61C168.26 197.77 168.53 196.96 169.03 196.34C169.09 196.27 169.15 196.19 169.21 196.13L169.44 195.89C169.14 195.61 168.83 195.22 169.02 194.86C169.16 194.6 170.04 194.27 170.3 194.09C171.52 193.26 172.49 192.27 172.49 192.27V191.35C172.15 191.35 171.85 191.06 171.85 190.69V189.11C171.85 188.98 171.9 188.86 171.97 188.76C172.16 188.53 172.29 188.45 172.43 188.45H191.6C191.82 188.45 191.94 188.52 192.03 188.62C192.19 188.82 192.25 188.95 192.25 189.11V190.6C192.25 190.82 192.21 190.93 192.15 191.03C192.11 191.1 192.08 191.14 192.05 191.17C192 191.22 191.95 191.27 191.89 191.3C191.8 191.32 191.71 191.35 191.6 191.35C191.62 191.35 191.62 192.27 191.62 192.27C191.62 192.27 192.45 193.04 192.94 193.57C193.51 194.19 194.5 194.85 195.15 195.23C195.09 195.46 194.87 195.67 194.61 195.83C194.66 195.88 194.89 196.13 194.89 196.13C195 196.24 195.09 196.36 195.18 196.48C195.61 197.08 195.85 197.83 195.85 198.61V218.46C195.85 220.36 194.31 220.95 192.42 220.95H192.44Z"
        fill="#F4F4F4"
      />
      <path
        d="M79.5198 220.95H58.7698C56.8798 220.95 55.3398 220.36 55.3398 218.46V198.61C55.3398 197.77 55.6198 196.96 56.1098 196.34C56.1698 196.27 56.2298 196.19 56.2898 196.13L56.5198 195.89C56.2198 195.61 55.9098 195.22 56.0998 194.86C56.2398 194.6 57.1198 194.27 57.3798 194.09C58.5998 193.26 59.5698 192.27 59.5698 192.27V191.35C59.2298 191.35 58.9298 191.06 58.9298 190.69V189.11C58.9298 188.98 58.9798 188.86 59.0498 188.76C59.2398 188.53 59.3698 188.45 59.5098 188.45H78.6798C78.8998 188.45 79.0198 188.52 79.1098 188.62C79.2698 188.82 79.3298 188.95 79.3298 189.11V190.6C79.3298 190.82 79.2898 190.93 79.2298 191.03C79.1898 191.1 79.1598 191.14 79.1298 191.17C79.0798 191.22 79.0298 191.27 78.9698 191.3C78.8798 191.32 78.7898 191.35 78.6798 191.35C78.6998 191.35 78.6998 192.27 78.6998 192.27C78.6998 192.27 79.5298 193.04 80.0198 193.57C80.5898 194.19 81.5798 194.85 82.2298 195.23C82.1698 195.46 81.9498 195.67 81.6898 195.83C81.7398 195.88 81.9698 196.13 81.9698 196.13C82.0698 196.24 82.1698 196.36 82.2598 196.48C82.6898 197.08 82.9298 197.83 82.9298 198.61V218.46C82.9298 220.36 81.3898 220.95 79.4998 220.95H79.5198Z"
        fill="#F4F4F4"
      />
      <path
        d="M239.86 313.49C240.21 313.25 240.64 313.11 241.1 313.11H267.65C268.88 313.11 269.87 314.11 269.87 315.33V315.66C270.54 315.9 271.03 316.53 271.03 317.28V351.75C271.03 352.5 270.55 353.14 269.87 353.37V353.7C269.87 354.93 268.87 355.92 267.65 355.92H241.1C240.64 355.92 240.21 355.78 239.86 355.54C239.27 355.14 238.88 354.46 238.88 353.7V353.37C238.71 353.31 238.56 353.23 238.42 353.12C238.28 353.02 238.16 352.9 238.06 352.76C237.96 352.62 237.89 352.48 237.83 352.32C237.76 352.07 237.72 351.91 237.72 351.74V317.27C237.72 317.1 237.75 316.94 237.8 316.78C237.88 316.54 237.95 316.39 238.05 316.27C238.16 316.12 238.28 316 238.42 315.9C238.56 315.79 238.72 315.71 238.88 315.65V315.32C238.88 314.55 239.27 313.88 239.86 313.48V313.49Z"
        fill="#F4F4F4"
      />
      <path
        d="M181.51 355.93H154.96C153.73 355.93 152.74 354.93 152.74 353.71V353.38C152.57 353.32 152.42 353.24 152.28 353.13C152.14 353.03 152.02 352.91 151.92 352.77C151.82 352.63 151.75 352.49 151.69 352.33C151.62 352.09 151.58 351.92 151.58 351.75V317.28C151.58 317.11 151.61 316.95 151.66 316.79C151.74 316.55 151.81 316.4 151.91 316.28C152.02 316.13 152.14 316.01 152.28 315.91C152.42 315.8 152.58 315.72 152.74 315.66V315.33C152.74 314.1 153.74 313.11 154.96 313.11H181.51C182.74 313.11 183.73 314.11 183.73 315.33V315.66C184.4 315.9 184.89 316.53 184.89 317.28V351.75C184.89 352.5 184.41 353.14 183.73 353.37V353.7C183.73 354.93 182.73 355.92 181.51 355.92V355.93Z"
        fill="#F4F4F4"
      />
      <path
        d="M227.82 314.54V353.12C227.82 354.67 226.56 355.93 225.01 355.93H197.59C197.2 355.93 196.83 355.85 196.5 355.71C196.16 355.57 195.86 355.36 195.61 355.11C195.1 354.6 194.79 353.9 194.79 353.12V314.54C194.79 314.35 194.81 314.16 194.85 313.97C195.11 312.69 196.25 311.73 197.6 311.73H225.02C226.57 311.73 227.83 312.99 227.83 314.54H227.82Z"
        fill="#F4F4F4"
      />
      <path
        d="M95.3695 355.93H68.8195C67.5895 355.93 66.5994 354.93 66.5994 353.71V353.38C66.4294 353.32 66.2795 353.24 66.1395 353.13C65.9995 353.03 65.8794 352.91 65.7794 352.77C65.6794 352.63 65.6095 352.49 65.5495 352.33C65.4795 352.09 65.4395 351.92 65.4395 351.75V317.28C65.4395 317.11 65.4694 316.95 65.5194 316.79C65.5994 316.55 65.6694 316.4 65.7694 316.28C65.8794 316.13 65.9995 316.01 66.1395 315.91C66.2795 315.8 66.4394 315.72 66.5994 315.66V315.33C66.5994 314.1 67.5995 313.11 68.8195 313.11H95.3695C96.5995 313.11 97.5894 314.11 97.5894 315.33V315.66C98.2594 315.9 98.7495 316.53 98.7495 317.28V351.75C98.7495 352.5 98.2694 353.14 97.5894 353.37V353.7C97.5894 354.93 96.5895 355.92 95.3695 355.92V355.93Z"
        fill="#F4F4F4"
      />
      <path
        d="M90.72 438.16H64.17C62.94 438.16 61.95 437.16 61.95 435.94V435.61C61.78 435.55 61.63 435.47 61.49 435.36C61.35 435.26 61.23 435.14 61.13 435C61.03 434.86 60.96 434.72 60.9 434.56C60.83 434.32 60.79 434.15 60.79 433.98V399.51C60.79 399.34 60.82 399.18 60.87 399.02C60.95 398.78 61.02 398.63 61.12 398.51C61.23 398.36 61.35 398.24 61.49 398.14C61.63 398.03 61.79 397.95 61.95 397.89V397.56C61.95 396.33 62.95 395.34 64.17 395.34H90.72C91.95 395.34 92.94 396.34 92.94 397.56V397.89C93.61 398.13 94.1 398.76 94.1 399.51V433.98C94.1 434.73 93.62 435.37 92.94 435.6V435.93C92.94 437.16 91.94 438.15 90.72 438.15V438.16Z"
        fill="#F4F4F4"
      />
      <path
        d="M141.679 314.54V353.12C141.679 354.67 140.419 355.93 138.869 355.93H111.449C111.059 355.93 110.689 355.85 110.359 355.71C110.019 355.57 109.719 355.36 109.469 355.11C108.959 354.6 108.649 353.9 108.649 353.12V314.54C108.649 314.35 108.669 314.16 108.709 313.97C108.969 312.69 110.109 311.73 111.459 311.73H138.879C140.429 311.73 141.689 312.99 141.689 314.54H141.679Z"
        fill="#F4F4F4"
      />
      <path
        d="M146.33 413.03L147.9 405.43V402.78C147.9 402.85 149.24 403.4 149.24 403.4C149.24 403.4 150.34 402.95 150.55 402.81C150.76 402.95 151.86 403.4 151.86 403.4C151.86 403.4 152.96 402.95 153.17 402.81C153.38 402.95 154.48 403.4 154.48 403.4C154.48 403.4 155.58 402.95 155.79 402.81C156 402.95 157.1 403.4 157.1 403.4C157.1 403.4 158.2 402.95 158.41 402.81C158.62 402.95 159.72 403.4 159.72 403.4C159.72 403.4 160.82 402.95 161.03 402.81C161.24 402.95 162.34 403.4 162.34 403.4C162.34 403.4 163.44 402.95 163.65 402.81C163.86 402.95 164.96 403.4 164.96 403.4C164.96 403.4 166.06 402.95 166.27 402.81C166.48 402.95 167.58 403.4 167.58 403.4C167.58 403.4 168.68 402.95 168.89 402.81C169.1 402.95 170.2 403.4 170.2 403.4C170.2 403.4 171.3 402.95 171.51 402.81C171.72 402.95 172.82 403.4 172.82 403.4C172.82 403.4 173.92 402.95 174.13 402.81C174.34 402.95 175.44 403.4 175.44 403.4C175.44 403.4 176.54 402.95 176.75 402.81C176.96 402.95 178.06 403.4 178.06 403.4C178.06 403.4 179.16 402.95 179.37 402.81C179.58 402.95 180.68 403.4 180.68 403.4C180.68 403.4 182.02 402.85 182.02 402.78V405.43L183.59 413.03C186.44 420.39 186.39 424.6 183.43 431.94L182.02 435.44H165.01L182.02 435.45V438.16C182.02 438.09 180.68 437.54 180.68 437.54C180.68 437.54 179.58 437.99 179.37 438.13C179.16 437.99 178.06 437.54 178.06 437.54C178.06 437.54 176.96 437.99 176.75 438.13C176.54 437.99 175.44 437.54 175.44 437.54C175.44 437.54 174.34 437.99 174.13 438.13C173.92 437.99 172.82 437.54 172.82 437.54C172.82 437.54 171.72 437.99 171.51 438.13C171.3 437.99 170.2 437.54 170.2 437.54C170.2 437.54 169.1 437.99 168.89 438.13C168.68 437.99 167.58 437.54 167.58 437.54C167.58 437.54 166.48 437.99 166.27 438.13C166.06 437.99 164.96 437.54 164.96 437.54C164.96 437.54 163.86 437.99 163.65 438.13C163.44 437.99 162.34 437.54 162.34 437.54C162.34 437.54 161.24 437.99 161.03 438.13C160.82 437.99 159.72 437.54 159.72 437.54C159.72 437.54 158.62 437.99 158.41 438.13C158.2 437.99 157.1 437.54 157.1 437.54C157.1 437.54 156 437.99 155.79 438.13C155.58 437.99 154.48 437.54 154.48 437.54C154.48 437.54 153.38 437.99 153.17 438.13C152.96 437.99 151.86 437.54 151.86 437.54C151.86 437.54 150.76 437.99 150.55 438.13C150.34 437.99 149.24 437.54 149.24 437.54C149.24 437.54 147.9 438.09 147.9 438.16V435.45L146.49 431.94C143.53 424.6 143.48 420.39 146.33 413.03Z"
        fill="#F4F4F4"
      />
      <path
        d="M239.659 394.45V390.91C239.659 391.01 240.909 391.74 240.909 391.74C240.909 391.74 241.939 391.14 242.129 390.95C242.319 391.14 243.349 391.74 243.349 391.74C243.349 391.74 244.379 391.14 244.569 390.95C244.759 391.14 245.789 391.74 245.789 391.74C245.789 391.74 246.819 391.14 247.009 390.95C247.199 391.14 248.229 391.74 248.229 391.74C248.229 391.74 249.259 391.14 249.449 390.95C249.639 391.14 250.669 391.74 250.669 391.74C250.669 391.74 251.699 391.14 251.889 390.95C252.079 391.14 253.109 391.74 253.109 391.74C253.109 391.74 254.139 391.14 254.329 390.95C254.519 391.14 255.549 391.74 255.549 391.74C255.549 391.74 256.579 391.14 256.769 390.95C256.959 391.14 257.989 391.74 257.989 391.74C257.989 391.74 259.019 391.14 259.209 390.95C259.399 391.14 260.429 391.74 260.429 391.74C260.429 391.74 261.459 391.14 261.649 390.95C261.839 391.14 262.869 391.74 262.869 391.74C262.869 391.74 263.899 391.14 264.089 390.95C264.279 391.14 265.309 391.74 265.309 391.74C265.309 391.74 266.339 391.14 266.529 390.95C266.719 391.14 267.749 391.74 267.749 391.74C267.749 391.74 268.779 391.14 268.969 390.95C269.159 391.14 270.189 391.74 270.189 391.74C270.189 391.74 271.439 391.01 271.439 390.91V394.45L272.909 404.6C275.579 414.42 275.529 420.05 272.759 429.85L271.439 434.52H255.499L271.439 434.54V438.16C271.439 438.06 270.189 437.33 270.189 437.33C270.189 437.33 269.159 437.93 268.969 438.12C268.779 437.93 267.749 437.33 267.749 437.33C267.749 437.33 266.719 437.93 266.529 438.12C266.339 437.93 265.309 437.33 265.309 437.33C265.309 437.33 264.279 437.93 264.089 438.12C263.899 437.93 262.869 437.33 262.869 437.33C262.869 437.33 261.839 437.93 261.649 438.12C261.459 437.93 260.429 437.33 260.429 437.33C260.429 437.33 259.399 437.93 259.209 438.12C259.019 437.93 257.989 437.33 257.989 437.33C257.989 437.33 256.959 437.93 256.769 438.12C256.579 437.93 255.549 437.33 255.549 437.33C255.549 437.33 254.519 437.93 254.329 438.12C254.139 437.93 253.109 437.33 253.109 437.33C253.109 437.33 252.079 437.93 251.889 438.12C251.699 437.93 250.669 437.33 250.669 437.33C250.669 437.33 249.639 437.93 249.449 438.12C249.259 437.93 248.229 437.33 248.229 437.33C248.229 437.33 247.199 437.93 247.009 438.12C246.819 437.93 245.789 437.33 245.789 437.33C245.789 437.33 244.759 437.93 244.569 438.12C244.379 437.93 243.349 437.33 243.349 437.33C243.349 437.33 242.319 437.93 242.129 438.12C241.939 437.93 240.909 437.33 240.909 437.33C240.909 437.33 239.659 438.06 239.659 438.16V434.54L238.339 429.85C235.569 420.05 235.519 414.42 238.189 404.6L239.659 394.45Z"
        fill="#F4F4F4"
      />
      <path
        d="M198.229 386.78V382.62C198.229 382.74 199.229 383.6 199.229 383.6C199.229 383.6 200.049 382.89 200.199 382.67C200.349 382.89 201.169 383.6 201.169 383.6C201.169 383.6 201.989 382.89 202.139 382.67C202.289 382.89 203.109 383.6 203.109 383.6C203.109 383.6 203.929 382.89 204.079 382.67C204.229 382.89 205.049 383.6 205.049 383.6C205.049 383.6 205.869 382.89 206.019 382.67C206.169 382.89 206.989 383.6 206.989 383.6C206.989 383.6 207.809 382.89 207.959 382.67C208.109 382.89 208.929 383.6 208.929 383.6C208.929 383.6 209.749 382.89 209.899 382.67C210.049 382.89 210.869 383.6 210.869 383.6C210.869 383.6 211.689 382.89 211.839 382.67C211.989 382.89 212.809 383.6 212.809 383.6C212.809 383.6 213.629 382.89 213.779 382.67C213.929 382.89 214.749 383.6 214.749 383.6C214.749 383.6 215.569 382.89 215.719 382.67C215.869 382.89 216.689 383.6 216.689 383.6C216.689 383.6 217.509 382.89 217.659 382.67C217.809 382.89 218.629 383.6 218.629 383.6C218.629 383.6 219.449 382.89 219.599 382.67C219.749 382.89 220.569 383.6 220.569 383.6C220.569 383.6 221.389 382.89 221.539 382.67C221.689 382.89 222.509 383.6 222.509 383.6C222.509 383.6 223.509 382.74 223.509 382.62V386.78L224.679 398.71C226.809 410.26 226.769 416.87 224.559 428.39L223.509 433.88H210.829L223.509 433.9V438.16C223.509 438.04 222.509 437.18 222.509 437.18C222.509 437.18 221.689 437.89 221.539 438.11C221.389 437.89 220.569 437.18 220.569 437.18C220.569 437.18 219.749 437.89 219.599 438.11C219.449 437.89 218.629 437.18 218.629 437.18C218.629 437.18 217.809 437.89 217.659 438.11C217.509 437.89 216.689 437.18 216.689 437.18C216.689 437.18 215.869 437.89 215.719 438.11C215.569 437.89 214.749 437.18 214.749 437.18C214.749 437.18 213.929 437.89 213.779 438.11C213.629 437.89 212.809 437.18 212.809 437.18C212.809 437.18 211.989 437.89 211.839 438.11C211.689 437.89 210.869 437.18 210.869 437.18C210.869 437.18 210.049 437.89 209.899 438.11C209.749 437.89 208.929 437.18 208.929 437.18C208.929 437.18 208.109 437.89 207.959 438.11C207.809 437.89 206.989 437.18 206.989 437.18C206.989 437.18 206.169 437.89 206.019 438.11C205.869 437.89 205.049 437.18 205.049 437.18C205.049 437.18 204.229 437.89 204.079 438.11C203.929 437.89 203.109 437.18 203.109 437.18C203.109 437.18 202.289 437.89 202.139 438.11C201.989 437.89 201.169 437.18 201.169 437.18C201.169 437.18 200.349 437.89 200.199 438.11C200.049 437.89 199.229 437.18 199.229 437.18C199.229 437.18 198.229 438.04 198.229 438.16V433.9L197.179 428.39C194.969 416.87 194.929 410.26 197.059 398.71L198.229 386.78Z"
        fill="#F4F4F4"
      />
      <path
        d="M238.969 285.64H216.21C216.21 285.64 216.199 285.42 216.179 285.1C216.089 283.57 215.849 279.23 215.669 275.19C215.619 273.94 215.569 272.83 215.539 271.82V271.67C215.529 271.49 215.52 271.32 215.52 271.16C215.51 270.67 215.5 270.31 215.49 269.96C215.49 269.6 215.479 269.32 215.479 269.05C215.479 268.86 215.479 268.67 215.479 268.51C215.499 264.39 216.219 251.4 216.219 251.4C216.219 251.37 227.46 251.37 227.46 251.37H238.969C238.969 251.37 239.69 264.39 239.71 268.51C239.73 272.79 238.969 285.62 238.969 285.65V285.64Z"
        fill="#F4F4F4"
      />
      <path
        d="M163.75 285.64H140.99C140.99 285.64 140.98 285.42 140.96 285.1C140.87 283.57 140.63 279.23 140.45 275.19C140.4 273.94 140.35 272.83 140.32 271.82V271.67C140.31 271.49 140.3 271.32 140.3 271.16C140.29 270.67 140.28 270.31 140.27 269.96C140.27 269.6 140.26 269.32 140.26 269.05C140.26 268.86 140.26 268.67 140.26 268.51C140.28 264.39 141 251.4 141 251.4C141 251.37 152.24 251.37 152.24 251.37H163.75C163.75 251.37 164.47 264.39 164.49 268.51C164.51 272.79 163.75 285.62 163.75 285.65V285.64Z"
        fill="#F4F4F4"
      />
      <path
        d="M44.8594 220.95H26.9294C26.9294 220.95 26.9294 220.8 26.9094 220.57C26.8394 219.49 26.6494 216.42 26.5094 213.56C26.4694 212.68 26.4294 211.89 26.4094 211.18C26.4094 210.95 26.3994 210.83 26.3894 210.71C26.3794 210.37 26.3694 210.11 26.3694 209.86C26.3694 209.61 26.3694 209.41 26.3594 209.22C26.3594 209.08 26.3594 208.95 26.3594 208.84C26.3794 205.93 26.9394 196.74 26.9394 196.74C26.9394 196.72 35.7994 196.72 35.7994 196.72H44.8694C44.8694 196.72 45.4394 205.93 45.4494 208.84C45.4694 211.87 44.8694 220.93 44.8694 220.96L44.8594 220.95Z"
        fill="#F4F4F4"
      />
      <path
        d="M277.049 247.82L280.809 285.64H256.409H249.609L252.659 247.82H277.049Z"
        fill="#F4F4F4"
      />
      <path
        d="M85.5193 247.82L89.2693 285.64H64.8693H58.0693L61.1193 247.82H85.5193Z"
        fill="#F4F4F4"
      />
      <path
        d="M174.39 285.64L177.43 238.59H201.83L205.58 285.64H181.19H174.39Z"
        fill="#F4F4F4"
      />
      <path
        d="M23.5898 285.64L25.9898 238.59H45.2198L48.1698 285.64H28.9498H23.5898Z"
        fill="#F4F4F4"
      />
      <path
        d="M99.1602 285.64L102.21 263.66H126.61L130.36 285.64H105.96H99.1602Z"
        fill="#F4F4F4"
      />
      <path d="M103.99 438.16H134.34V403.86H103.99V438.16Z" fill="#F4F4F4" />
      <path
        d="M20.5396 438.16H50.8896L50.8896 378.83H20.5396L20.5396 438.16Z"
        fill="#F4F4F4"
      />
      <path
        d="M25.19 355.93H55.54L55.54 321.63H25.19L25.19 355.93Z"
        fill="#F4F4F4"
      />
      <path
        d="M576.74 165.55C576.74 165.55 567.16 164.2 562 170.74C556.83 177.27 551.37 231.6 551.37 231.6C551.37 231.6 552.37 257.13 554.96 257.99C557.55 258.85 564.28 246.84 565.65 243.55C566.32 241.94 577.13 204.09 577.08 202.85C577.03 201.61 576.75 165.56 576.75 165.56L576.74 165.55Z"
        fill="#F7D4AB"
      />
      <path
        d="M647.39 162.32C647.39 162.32 659.74 165.07 661.14 166.39C666.57 171.51 667.29 200.2 667.76 202.11C668.23 204.02 674.78 228.59 674.88 230.86C674.98 233.13 673.78 257.42 671.44 257.32C669.1 257.22 653.47 236.55 652.84 235.39C652.21 234.23 649.78 195.06 649.78 195.06L647.39 162.32Z"
        fill="url(#paint0_linear_1974_24988)"
      />
      <path
        d="M581.82 140.18C581.82 140.18 591.6 158.36 606.93 170.44C606.93 170.44 573.7 152.5 574.38 114.83L581.82 140.18Z"
        fill="url(#paint1_linear_1974_24988)"
      />
      <path
        d="M632.57 124.1C628.54 104.41 619.81 88.7802 618.66 69.4802C618.12 69.4302 617.82 69.4102 617.82 69.4102C568.04 61.1802 574.38 144.63 602.63 163.1C605.48 163.83 609.11 180.35 615.57 182.16C608.35 154.31 638.11 151.14 632.57 124.1Z"
        fill="url(#paint2_linear_1974_24988)"
      />
      <path
        d="M628.64 70.4202C628.64 70.4202 630.85 65.8002 639.46 79.2402C650.31 96.1902 649.42 112.92 648.99 119.92C647.85 138.09 644.71 142.13 638.89 150.02C635.31 154.86 626.9 162.26 626.88 164.12C626.86 165.98 618.1 162.92 617.41 160.8C598.28 101.65 628.64 70.4302 628.64 70.4302V70.4202Z"
        fill="url(#paint3_linear_1974_24988)"
      />
      <path
        d="M607.85 78.2702C607.85 78.2702 587.08 87.3902 588.19 121.69C588.86 142.42 603.68 153.28 603.68 153.28C603.68 153.28 607.94 163.73 602.63 163.1C584.06 150.69 574.63 130.82 574.4 118.37C573.7 80.2102 588.59 68.3602 599.3 68.4502L607.85 78.2702Z"
        fill="url(#paint4_linear_1974_24988)"
      />
      <path
        d="M663.39 168.63C661.33 164.35 651.46 161.66 650.25 161.54C646.01 161.13 628.85 159.79 627.08 154.13C624.88 147.08 627.5 138.05 627.5 138.05L601.04 136.73C604.02 141.69 603.91 146.97 603.78 152.33C603.64 158.21 585.84 162.35 579.73 163.03C576.39 163.4 564.6 167.29 562.97 173.04C560.68 181.12 560.86 183.82 561.54 194.43L668.04 184.22C667.39 178.31 667.31 176.81 663.39 168.64V168.63Z"
        fill="#F7D4AB"
      />
      <path
        d="M640.08 160.54C641 160.17 641.9 159.61 642.83 159.06C632.55 157.73 629.45 155.97 628.7 155.47C627.91 154.93 627.14 152.37 626.86 149.37C626.74 148.07 626.55 144.79 626.5 143.09C626.14 143.53 603.58 142.71 602.71 141.42L600.09 141.44C600.09 141.44 600.86 149.74 599.63 155.68C599.38 156.89 592.07 158.6 587.27 159.6C587.61 159.87 588.84 160.7 589.12 160.84C593.23 161.24 596.76 161.73 598.43 161.44C600.48 161.08 603.93 159.52 606.43 158.37C619.96 152.17 624.18 150.12 624.18 150.12C624.82 155.88 629.08 159.7 628.85 159.64C632.25 160.47 636.4 160.62 640.08 160.52V160.54Z"
        fill="url(#paint5_linear_1974_24988)"
      />
      <path
        d="M618.54 168.92C618.54 168.92 617.13 165.04 612.39 166.55C612.39 166.55 617.26 167.41 618.54 168.92Z"
        fill="url(#paint6_linear_1974_24988)"
      />
      <path
        d="M618.7 165.6C618.7 165.6 620.06 162.08 621.95 161.61C623.84 161.14 644.79 160.44 647.25 159.96C647.25 159.96 637.93 162 632.54 162.62C627.15 163.25 622.93 162.31 618.7 165.6Z"
        fill="url(#paint7_linear_1974_24988)"
      />
      <path
        d="M612.01 165.57C612.01 165.57 610.7 162.87 608.37 162.09C606.04 161.31 588.24 160.2 585.03 160.52C585.03 160.52 607.49 162.77 612.01 165.57Z"
        fill="url(#paint8_linear_1974_24988)"
      />
      <path
        d="M600.16 151.86C600.16 151.86 600.29 141.52 599.43 137.89C599.43 137.89 625.95 138.85 627.15 138.95C626.66 141.93 626.63 145.65 626.63 145.65C626.63 145.65 615.69 156.8 600.15 151.86H600.16Z"
        fill="url(#paint9_linear_1974_24988)"
      />
      <path
        d="M564.73 167.48C564.73 167.48 566.62 166.45 568 165.96C568 165.96 577.32 213 577.76 215.37C577.79 215.51 575.86 227.96 575.86 227.96C575.86 227.96 574.27 218.7 574.11 217.43C573.48 212.28 570.58 188.85 564.73 167.48Z"
        fill="url(#paint10_linear_1974_24988)"
      />
      <path
        d="M646.43 266.23C649.12 264.59 652.58 261.5 652.58 256.24C652.58 245.35 655.1 222.29 656.76 210.42C655.65 196.19 662.53 164.58 662.53 164.58L641.17 159.32C612.74 188.46 588.79 158.89 588.79 158.89L566.25 167.11C573.28 193.94 575.78 215.18 575.78 217.35C575.78 219.52 572.99 232.27 571.25 251.09C570.98 253.98 570.3 260.77 573.11 262.77C598.2 273.61 618.88 268.95 646.43 266.24V266.23Z"
        fill="#27AE60"
      />
      <path
        d="M583.74 214.38C590.98 216 643.83 216.86 647.08 215.24C650.33 213.62 647.55 176.67 647.55 176.67H575.77C575.77 176.67 579.38 213.41 583.74 214.38Z"
        fill="#30B265"
      />
      <path
        d="M648.91 278.52L628.44 305.35L657.71 345.39C654.32 331.21 648.91 278.52 648.91 278.52Z"
        fill="#23252C"
      />
      <path
        d="M570.96 255.29C570.96 255.29 570.59 261.19 573.11 262.75C573.11 262.75 589.2 268.53 610.14 268.74C627.61 268.92 647.19 266.16 647.19 266.16C647.19 266.16 652.83 263.19 652.68 255.78C652.68 255.78 651.22 265.4 635.84 265.71C618.23 266.07 619.21 265.39 619.21 265.39C619.21 265.39 624.89 261.62 628.63 250.79C628.63 250.79 613.71 264.85 599.8 264.36C599.29 264.34 591.22 259.92 589.83 253.61C589.83 253.61 588.59 259.44 590.15 262.2C590.15 262.2 573.3 265.63 570.96 255.28V255.29Z"
        fill="#27AE60"
      />
      <path
        d="M648.91 278.52L646.43 266.23C646.43 266.23 603.37 268.56 571.67 258.48C571.67 258.48 561.49 321.87 557.72 345.23H657.82C655.83 337.57 651.03 289.29 648.92 278.52H648.91Z"
        fill="#23252C"
      />
      <path
        d="M607.91 272.23C608.93 273.26 608.93 274.93 607.91 275.96C606.89 276.99 605.22 276.99 604.2 275.96C603.18 274.93 603.18 273.26 604.2 272.23C605.22 271.2 606.89 271.2 607.91 272.23Z"
        fill="url(#paint11_linear_1974_24988)"
      />
      <path
        d="M607.859 273.78C607.859 275.01 606.869 276 605.649 276C604.429 276 603.439 275 603.439 273.78C603.439 272.56 604.429 271.56 605.649 271.56C606.869 271.56 607.859 272.56 607.859 273.78Z"
        fill="url(#paint12_linear_1974_24988)"
      />
      <path
        d="M603.81 273.78C603.81 273.78 603.84 275.54 605.42 275.65C607 275.76 608.19 273.96 607.02 272.51C607.02 272.51 607.34 274.46 606.06 274.83C604.93 275.16 604.04 274.58 603.82 273.78H603.81Z"
        fill="#5C5D63"
      />
      <path
        d="M630.04 279.03C630.04 279.03 629.5 288.15 635.54 292.02C641.59 295.89 650.53 295.48 650.53 295.48L648.91 278.52L630.03 279.04L630.04 279.03Z"
        fill="url(#paint13_linear_1974_24988)"
      />
      <path
        d="M571.25 271.92C576.98 275.4 583.82 276.6 583.82 276.6C583.82 276.6 582.34 288.26 574.09 289.32C565.84 290.38 567.42 290.02 567.42 290.02C567.42 290.02 568.11 278.48 571.25 271.92Z"
        fill="url(#paint14_linear_1974_24988)"
      />
      <path
        d="M610.54 279.11L630.04 279.03C630.04 279.03 629.85 283.95 630.58 287.12L609.96 286.73L610.54 279.11Z"
        fill="url(#paint15_linear_1974_24988)"
      />
      <path
        d="M583.41 276.66C583.41 276.66 608.81 280.22 609.55 280.47C610.29 280.72 610.33 286.29 608.51 286.26C606.49 286.22 583.26 283.59 581.85 283.79C581.85 283.79 583.92 280.25 583.41 276.66Z"
        fill="url(#paint16_linear_1974_24988)"
      />
      <path
        d="M610.09 297.57C610.19 296.7 610.3 281.22 611.24 280.59C612.18 279.96 612.07 278.11 612.07 278.11L612.24 268.32L610.13 268.25C610.13 268.25 610.93 274.61 610.82 275.3C610.72 275.99 610.61 279.72 609.78 279.85L608.95 279.98C608.95 279.98 608.22 288.59 608.22 297.4C608.22 300.17 608.41 302.88 608.67 305.33H610.19C610.11 301.46 610.04 297.98 610.09 297.56V297.57Z"
        fill="url(#paint17_linear_1974_24988)"
      />
      <path
        d="M569.67 272.48C569.67 272.48 581.72 276.28 583.82 276.6C585.92 276.92 594.58 277.75 604.19 279.62C604.19 279.62 585.92 278.88 583.82 278.52C581.72 278.16 569.67 272.49 569.67 272.49V272.48Z"
        fill="url(#paint18_linear_1974_24988)"
      />
      <path
        d="M610.04 279.11C610.04 279.11 629.31 278.38 629.65 278.52C629.99 278.66 644.59 277.39 648.92 278.52C648.92 278.52 632.4 280.09 629.65 280.18C626.9 280.27 610.04 279.12 610.04 279.12V279.11Z"
        fill="url(#paint19_linear_1974_24988)"
      />
      <path
        d="M629.98 279.74C629.98 279.74 630.36 285.64 632.95 288.83C635.54 292.02 637.39 295.26 651.14 295.48C651.14 295.48 643.07 298.92 634.9 294.13C628.05 290.12 629.99 279.73 629.99 279.73L629.98 279.74Z"
        fill="url(#paint20_linear_1974_24988)"
      />
      <path
        d="M583.64 277.1C583.64 277.1 582.83 282.41 580.24 285.6C577.65 288.79 574.93 293.22 566.82 292.45C566.82 292.45 571.18 293.56 578.38 289.52C585.3 285.63 583.64 277.11 583.64 277.11V277.1Z"
        fill="url(#paint21_linear_1974_24988)"
      />
      <path
        d="M601.25 267.83C601.25 267.83 610.16 268.05 611.15 268.34C612.14 268.63 611.69 275.45 611.64 276.54C611.59 277.63 611.65 281.32 610.05 281.06C608.45 280.8 604.19 279.61 604.19 279.61C604.19 279.61 608.46 279.77 609.46 279.12C610.46 278.47 610.59 269.85 609.97 269.86C609.35 269.87 601.25 267.82 601.25 267.82V267.83Z"
        fill="url(#paint22_linear_1974_24988)"
      />
      <path
        d="M608.51 293.32C608.39 291.9 608.86 281.08 608.86 281.08C608.86 281.08 606.9 289.8 607 290.97C607.08 291.94 607.73 301.45 608.22 305.35H609.47C609.03 299.74 608.58 294.02 608.52 293.32H608.51Z"
        fill="url(#paint23_linear_1974_24988)"
      />
      <path
        d="M619.5 268.32C619.5 268.32 620.61 271.1 620.61 271.96C620.61 272.82 621.6 284.59 621.6 285.03C621.6 285.47 622.22 286.73 622.22 286.73L623.08 270.62L621.72 268.3L619.51 268.32H619.5Z"
        fill="url(#paint24_linear_1974_24988)"
      />
      <path
        d="M625.08 278.52H628.18L626.74 268.08L625.63 268.13L625.08 278.52Z"
        fill="url(#paint25_linear_1974_24988)"
      />
      <path
        d="M586.37 265.99L587.32 266.15L587.3 277.22L583.5 276.6L586.37 265.99Z"
        fill="url(#paint26_linear_1974_24988)"
      />
      <path
        d="M591.33 266.78L592.96 267L590.51 275.85L590.49 281.08L589.16 283.79L587.28 281.57L591.33 266.78Z"
        fill="url(#paint27_linear_1974_24988)"
      />
      <path
        d="M591.55 266.81C591.55 266.81 590.08 269.98 589.99 270.89C589.9 271.8 588.32 277.46 589.16 283.79L584.81 283.56C584.81 283.56 584.72 277.3 585.37 274.69C586.02 272.09 587.3 266.15 587.3 266.15L591.56 266.81H591.55Z"
        fill="url(#paint28_linear_1974_24988)"
      />
      <path
        d="M591.53 266.82C591.53 266.82 589.04 275.04 589.09 276.6C589.13 278.16 589.16 283.79 589.16 283.79L584.81 283.56L587.28 281.57C587.28 281.57 588.23 275 588.19 274.41C588.15 273.82 591.53 266.83 591.53 266.83V266.82Z"
        fill="url(#paint29_linear_1974_24988)"
      />
      <path
        d="M621.01 268.3L625.63 268.13C625.63 268.13 626.74 273.44 626.83 276.96C626.95 281.11 627.21 286.04 627.21 286.72C626.91 286.58 622.21 286.72 622.21 286.72C622.21 286.72 622.77 277.19 622.58 274.49C622.39 271.79 621.01 268.29 621.01 268.29V268.3Z"
        fill="url(#paint30_linear_1974_24988)"
      />
      <path
        d="M621.01 268.3C621.01 268.3 622.67 275.95 622.42 279.73C622.14 283.89 622.21 286.72 622.21 286.72H627.21C627.21 286.72 623.2 286.58 623.32 285.09C623.44 283.6 624.83 272.95 621.01 268.29V268.3Z"
        fill="url(#paint31_linear_1974_24988)"
      />
      <path
        d="M601.87 303.74C601.97 302.09 601.69 280.48 601.69 280.48C601.69 280.48 600.37 296.25 600.38 305.35H601.84C601.82 304.62 601.84 304.05 601.86 303.74H601.87Z"
        fill="url(#paint32_linear_1974_24988)"
      />
      <path
        d="M588.8 158.88C588.8 158.88 599.79 171.37 614.4 171.62C627.53 171.84 637.85 163.67 641.18 158.6L645.64 159.7C645.64 159.7 637.78 175.51 614.4 174.9C594.33 174.38 584.9 160.31 584.9 160.31L588.8 158.89V158.88Z"
        fill="url(#paint33_linear_1974_24988)"
      />
      <path
        d="M582.7 109.45L587.37 110.91L586.71 95.7202L582.7 109.45Z"
        fill="url(#paint34_linear_1974_24988)"
      />
      <path
        d="M587.55 111.32C588.69 119.97 589.64 126.54 589.64 126.54C585.94 126.54 584.59 122.83 583.14 119.57C580.93 114.58 579.63 109.22 584.65 108.94C585.63 108.88 587.54 111.32 587.54 111.32H587.55Z"
        fill="#F0C499"
      />
      <path
        d="M586.88 123.64C586.88 123.64 585.07 121.72 585.63 117.96C586.95 109.07 580.93 108.46 582.3 114.53C582.3 114.53 583.13 111.67 583.9 112.52C584.84 113.57 582.89 114.15 583.89 118.74C584.41 121.12 586.89 123.64 586.89 123.64H586.88Z"
        fill="url(#paint35_linear_1974_24988)"
      />
      <path
        d="M639.29 111.32C638.15 119.97 637.2 126.54 637.2 126.54C640.9 126.54 642.25 122.83 643.7 119.57C645.91 114.58 647.21 109.22 642.19 108.94C641.21 108.88 639.3 111.32 639.3 111.32H639.29Z"
        fill="#F0C499"
      />
      <path
        d="M639.96 123.64C639.96 123.64 641.77 121.72 641.21 117.96C639.89 109.07 645.91 108.46 644.54 114.53C644.54 114.53 643.71 111.67 642.94 112.52C642 113.57 643.95 114.15 642.95 118.74C642.43 121.12 639.95 123.64 639.95 123.64H639.96Z"
        fill="url(#paint36_linear_1974_24988)"
      />
      <path
        d="M638.85 82.7701C635.63 75.4101 626.17 68.4201 614.98 67.7101C614.98 67.7101 613.97 67.6501 613.46 67.6501C612.96 67.6501 611.94 67.7101 611.94 67.7101C600.75 68.4201 591.29 75.4101 588.07 82.7701C584.56 90.7901 585.57 102.05 586.57 109.42C587.57 116.79 589.58 128.74 591.42 132.12C593.26 135.5 602.55 144.23 604.55 145.74C606.43 147.15 608.07 149.44 613.49 149.68C618.59 149.91 620.89 147.17 622.72 145.74C624.69 144.19 633.67 135.51 635.5 132.12C637.34 128.74 639.34 116.79 640.35 109.42C641.35 102.05 642.36 90.7901 638.85 82.7701Z"
        fill="url(#paint37_linear_1974_24988)"
      />
      <path
        d="M636.06 102.73C634.19 101.27 631.48 100.05 627.82 100.42C616.08 101.61 616.26 113.32 615.16 119.98C629.57 125.69 637.95 115.29 637.95 115.29C637.95 115.29 640.41 106.14 636.06 102.73Z"
        fill="url(#paint38_linear_1974_24988)"
      />
      <path
        d="M598.06 100.93C594.39 100.68 591.96 101.6 590.1 103.12C585.77 106.66 588.94 116.61 588.94 116.61C588.94 116.61 597.4 126.65 611.77 120.48C610.62 113.91 609.81 101.71 598.06 100.93Z"
        fill="url(#paint39_linear_1974_24988)"
      />
      <path
        d="M602.85 112.66C599.55 111.67 586.78 108.99 587.39 113.23C588.74 122.61 589.96 129.06 591.59 131.98C593.3 135.04 598.32 139.85 600.49 140.22C603.85 140.79 607.4 128.44 607.48 124.21C607.59 118.29 606.14 113.65 602.84 112.67L602.85 112.66Z"
        fill="url(#paint40_radial_1974_24988)"
      />
      <path
        d="M624.11 112.66C627.41 111.67 640.18 108.99 639.57 113.23C638.22 122.61 637 129.06 635.37 131.98C633.66 135.04 628.64 139.85 626.47 140.22C623.11 140.79 619.56 128.44 619.48 124.21C619.37 118.29 620.82 113.65 624.12 112.67L624.11 112.66Z"
        fill="url(#paint41_radial_1974_24988)"
      />
      <path
        d="M614.08 141.22C611.73 141.33 609.84 142.18 609.85 143.11C609.86 144.05 611.77 144.72 614.12 144.61C616.47 144.5 618.36 143.65 618.35 142.72C618.34 141.79 616.42 141.12 614.08 141.23V141.22Z"
        fill="url(#paint42_linear_1974_24988)"
      />
      <path
        d="M586.71 110.36C586.71 110.36 589.06 127.42 591.25 132.17C591.96 133.71 598.27 140.17 602.26 143.89C602.26 143.89 594.24 135.91 592.12 130.47C590.3 125.8 586.71 110.37 586.71 110.37V110.36Z"
        fill="#F0C499"
      />
      <path
        d="M640.25 110.36C640.25 110.36 637.9 127.42 635.71 132.17C635 133.71 628.73 140.22 624.73 143.94C624.73 143.94 632.71 135.91 634.83 130.47C636.65 125.8 640.24 110.37 640.24 110.37L640.25 110.36Z"
        fill="#F0C499"
      />
      <path
        d="M637.81 117.09C637.81 117.09 651.25 67.6502 613.47 67.6602C575.69 67.6602 588.2 116.18 588.2 116.18C588.2 116.18 593.7 81.7702 608.44 80.3102C608.44 80.3102 636.37 86.7501 637.81 117.09Z"
        fill="url(#paint43_linear_1974_24988)"
      />
      <path
        d="M628.29 102.08C628.29 102.08 631.81 99.8302 637.02 103.14C639.79 104.9 637.71 111.62 637.71 111.62C637.71 111.62 638.97 101.34 628.3 102.09L628.29 102.08Z"
        fill="url(#paint44_linear_1974_24988)"
      />
      <path
        d="M639.22 105.79C639.22 105.79 633.44 82.0002 614.44 80.4402C614.44 80.4402 633.29 91.1802 635.85 106.81C636.11 108.95 636.2 111.36 635.95 113.92C634.45 129.4 624.41 138.41 623.88 144.9L632.08 136.73C632.08 136.73 642.07 118.74 639.23 105.8L639.22 105.79Z"
        fill="url(#paint45_linear_1974_24988)"
      />
      <path
        d="M600 141.73C600 141.73 606.38 147.28 607.07 147.67C608.44 148.45 609.85 149.46 613.4 149.57C616.87 149.69 618.95 148.36 619.93 147.71C620.95 147.02 626.66 142.11 627.16 141.64C627.16 141.64 622.56 146.92 620.98 148.23C618.4 150.36 615.37 151.48 613.47 151.48C611.08 151.48 609.12 150.01 607.07 148.86C604.84 147.6 600 141.74 600 141.74V141.73Z"
        fill="url(#paint46_linear_1974_24988)"
      />
      <path
        d="M630.78 99.8902C628.72 99.6702 623.44 100.89 621.84 101.47C621.09 101.84 620.67 102.49 620.8 103.72C620.45 102.99 620.61 102.47 620.92 101.99C619.66 103.04 619.82 104.8 621.25 104.31C622.88 103.75 629.27 101.95 630.59 101.92C632.63 101.87 635.47 102.61 636.26 103.12C636.26 103.12 633.03 100.13 630.79 99.8902H630.78Z"
        fill="url(#paint47_linear_1974_24988)"
      />
      <path
        d="M595.37 99.8902C597.43 99.6702 602.7 100.89 604.3 101.47C605.04 101.84 605.47 102.49 605.34 103.72C605.69 102.99 605.53 102.47 605.22 101.99C606.47 103.04 606.32 104.8 604.89 104.31C603.27 103.75 596.88 101.95 595.57 101.92C593.53 101.87 590.7 102.61 589.91 103.12C589.91 103.12 593.13 100.13 595.37 99.8902Z"
        fill="url(#paint48_linear_1974_24988)"
      />
      <path
        d="M566.25 166.39C566.25 166.39 558.98 168.91 557.49 174.96C556 181.01 540.16 217.28 540.16 217.28L573.52 234.47L577.35 204.36L566.25 166.4V166.39Z"
        fill="#27AE60"
      />
      <path
        d="M571.25 234.1C571.25 234.1 572.62 213.73 572.59 213.35C572.56 212.97 565.23 229.66 565.23 229.66L571.25 234.1Z"
        fill="#2EBC67"
      />
      <path
        d="M573.44 232.77C573.62 231.3 576.06 217.59 576.24 217.06C576.58 216.1 572.25 189.71 572.12 188.85C572 187.99 571.75 211.44 572.12 214.24C572.49 217.04 570.27 233.39 570.27 233.39L573.43 232.78L573.44 232.77Z"
        fill="#2EBC67"
      />
      <path
        d="M572.98 235.99L573.44 232.77L542.29 209.23L536.56 218.26L572.98 235.99Z"
        fill="#2EBC67"
      />
      <path
        d="M582.7 161.11C582.7 161.11 566.249 166.12 564.729 166.76C563.939 167.09 560.28 168.95 558.02 173.44C555.75 177.94 546.979 201.43 546.979 201.43C546.979 201.43 559.599 177.55 564.159 172.77C567.569 169.2 582.7 161.11 582.7 161.11Z"
        fill="#27AE60"
      />
      <path
        d="M661.15 163.86C661.15 163.86 668.42 166.38 669.91 172.43C671.4 178.48 685.58 214.99 685.58 214.99L652.13 229.17L650.05 201.83L661.15 163.87V163.86Z"
        fill="#27AE60"
      />
      <path
        d="M662.46 216.72L654.59 204.9L653.29 215.19L657.35 224.72L662.56 226.18C664.34 225.06 666.19 223.95 668.25 223.32L662.46 216.71V216.72Z"
        fill="#27AE60"
      />
      <path
        d="M668.18 223.26C666.12 223.89 664.34 225.08 662.56 226.19L673.42 229.24L668.18 223.26Z"
        fill="url(#paint49_linear_1974_24988)"
      />
      <path
        d="M656.15 231.56C656.15 231.56 654.78 211.19 654.81 210.81C654.84 210.43 662.17 227.12 662.17 227.12L656.15 231.56Z"
        fill="url(#paint50_linear_1974_24988)"
      />
      <path
        d="M652.02 260.16C646.91 253.84 633.8 213.83 633.03 213.28C632.26 212.73 624.96 207.68 624.61 207.46C624.25 207.24 621.25 208.4 620.01 208.64C618.77 208.88 612.62 205.07 612.02 205.16C611.42 205.25 602.99 181.79 602.99 181.79C602.99 181.79 617.28 183.54 628.48 177.73C628.48 177.73 645.07 192.42 645.86 193.19C646.64 193.96 654.21 204.9 654.21 204.9C654.21 204.9 656.7 245.17 656.05 245.67C655.4 246.17 652.96 251.35 652.96 251.35C652.96 251.35 653.01 258.04 652.03 260.15L652.02 260.16Z"
        fill="#30B767"
      />
      <path
        d="M653.73 236.79C653.73 236.79 653.98 213.9 653.73 212.91C653.48 211.93 655.57 188.88 655.69 188.02C655.81 187.16 656.04 208.64 655.95 211.74C655.87 214.56 657.13 230.84 657.13 230.84L653.74 236.79H653.73Z"
        fill="#27AE60"
      />
      <path
        d="M653.21 228.72L652.68 225.69L684.32 207.16L686.32 216.65L653.21 228.72Z"
        fill="#27AE60"
      />
      <path
        d="M644.23 159.96C644.23 159.96 661.15 163.58 662.67 164.22C663.46 164.55 667.12 166.41 669.38 170.9C671.65 175.4 679.41 198.89 679.41 198.89C679.41 198.89 667.8 175.01 663.24 170.23C659.83 166.66 644.23 159.96 644.23 159.96Z"
        fill="#27AE60"
      />
      <path
        d="M558.92 221.62C555.5 211.07 552.01 196.39 552.01 196.39C552.01 196.39 549.17 215.39 549.17 216.65C549.21 219.61 550.11 222.94 551.4 226.22C555.26 228.05 559 230.62 562.71 232.78C561.31 228.71 559.6 223.73 558.92 221.63V221.62Z"
        fill="#2EBC67"
      />
      <path
        d="M619.309 163.08C619.309 163.08 608.009 188.34 630.539 208.65C630.539 208.65 621.239 193.95 624.649 176.25L619.309 163.08Z"
        fill="url(#paint51_linear_1974_24988)"
      />
      <path
        d="M602.039 69.3703C602.039 69.3703 592.039 73.9003 607.859 78.2703C630.879 84.6403 637.109 97.0703 639.769 105.88C648.659 135.33 603.139 159.54 620.849 191.61C628.929 206.23 643.829 212.91 643.829 212.91C643.829 212.91 633.869 203.02 637.999 180.67C641.749 160.39 665.479 134.16 655.469 100.13C646.499 69.6303 622.869 56.3103 602.049 69.3703H602.039Z"
        fill="url(#paint52_linear_1974_24988)"
      />
      <path
        d="M607.449 78.2602C607.449 78.2602 660.369 63.8801 647.979 150.37C656.729 125.55 653.879 88.9102 634.779 78.7002C627.579 74.8502 620.039 74.4102 607.439 78.2702L607.449 78.2602Z"
        fill="url(#paint53_linear_1974_24988)"
      />
      <path
        d="M599.3 68.4502C599.3 68.4502 611.56 68.4502 607.81 78.2702C607.81 78.2702 585.42 74.0802 584.13 110.39C584.13 110.39 571.27 80.6502 599.3 68.4402V68.4502Z"
        fill="url(#paint54_linear_1974_24988)"
      />
      <path
        d="M607.809 78.2702C607.809 78.2702 586.879 82.4802 588.209 119.36C586.029 113.21 583.479 98.3002 588.799 89.5402C592.529 83.4002 597.659 75.8102 607.809 78.2702Z"
        fill="url(#paint55_linear_1974_24988)"
      />
      <path
        d="M642.94 93.1602C642.94 93.1602 657.66 113.07 651.72 138.38C645.83 163.45 643.54 161.93 638.99 177.59C634.44 193.25 640.65 208.21 640.65 208.21C640.65 208.21 623.34 190.37 630.2 173.63C637.07 156.89 639.76 155.37 644.81 142.58C651.49 125.64 649.44 110.43 642.95 93.1602H642.94Z"
        fill="url(#paint56_linear_1974_24988)"
      />
      <path
        d="M607.81 78.2603C607.81 78.2603 639.96 86.6203 637.98 118C637.17 130.79 630.15 139.12 626.57 145.65C622.99 152.18 618.13 166.65 624.89 182.74C624.89 182.74 619.97 163.12 633.19 144.32C647.98 123.29 645.6 112.76 641.93 103.87C636.05 89.6203 628.29 81.2103 607.81 78.2603Z"
        fill="url(#paint57_linear_1974_24988)"
      />
      <path
        d="M607.81 78.2702C607.81 78.2702 586.84 77.6002 583.81 116.41C582.01 139.44 596.73 155.23 596.73 155.23C596.73 155.23 580.87 141.99 580.27 116.58C579.83 98.0502 591.56 71.5802 607.81 78.2702Z"
        fill="url(#paint58_linear_1974_24988)"
      />
      <path
        d="M602.66 68.9102C604.56 69.3002 605.87 70.1802 605.87 70.1802C613.31 63.6102 622.5 65.0302 629.65 66.8002C614.81 58.9202 602.66 68.9102 602.66 68.9102Z"
        fill="url(#paint59_linear_1974_24988)"
      />
      <path
        d="M608.44 73.8503C608.44 73.8503 604.86 68.3803 595.39 72.6203C594.03 73.2303 582.74 80.6503 578.31 101.18C578.31 101.18 592.33 67.5703 608.44 73.8503Z"
        fill="url(#paint60_linear_1974_24988)"
      />
      <path
        d="M654.349 93.5202C654.349 93.5202 664.069 123.91 656.009 145.36C651.599 157.08 642.939 164.72 638.619 178.94C638.619 178.94 638.489 169.94 644.799 160.58C656.939 142.58 659.909 123.55 654.349 93.5103V93.5202Z"
        fill="url(#paint61_linear_1974_24988)"
      />
      <path
        d="M608.52 73.8301C608.52 73.8301 651.17 52.9401 657.2 121.26C657.2 121.26 662.14 78.9801 630.46 66.7701C619.09 62.3901 608.51 73.8301 608.51 73.8301H608.52Z"
        fill="url(#paint62_linear_1974_24988)"
      />
      <path
        d="M553.559 217.24C553.559 217.24 551.209 207.88 551.189 207.22C551.139 204.73 552.919 197.39 552.409 195.99C551.899 194.59 546.059 183.35 545.859 182.74C545.649 182.13 541.799 174.66 543.229 169.97C543.229 169.97 542.849 167.44 540.749 169.44C538.649 171.44 537.849 171.74 538.319 178.72C538.319 178.72 533.059 174.67 531.259 172.75C529.449 170.83 521.429 161.39 519.719 161.88C518.709 162.17 518.179 162.8 518.629 164.78C519.079 166.76 531.379 182.09 531.379 182.09C531.379 182.09 527.689 184.97 527.349 185.54C527.009 186.11 527.089 187.73 527.229 189.28C527.229 189.28 526.669 191.66 526.819 191.94C527.449 193.1 528.229 193.7 528.229 193.7C528.229 193.7 527.849 195.43 527.879 196.06C527.909 196.69 531.939 201.83 532.239 202.43C532.539 203.04 536.199 207.65 537.649 210.19C540.089 214.47 540.239 223.26 540.239 223.26L553.559 217.24Z"
        fill="#F7D5AB"
      />
      <path
        d="M531.39 182.09L533.02 180.6C533.02 180.6 518.72 165.61 518.64 162.68C518.64 162.68 518.14 163.23 518.48 164.89C518.82 166.55 524.15 172.8 524.71 173.61C525.19 174.3 531.39 182.08 531.39 182.08V182.09Z"
        fill="url(#paint63_linear_1974_24988)"
      />
      <path
        d="M542.979 171.21C542.979 171.21 542.979 176.8 546.159 183.39C546.159 183.39 542.869 180.62 541.109 179.97C541.109 179.97 541.379 172.87 542.979 171.22V171.21Z"
        fill="url(#paint64_linear_1974_24988)"
      />
      <path
        d="M527.24 189.27C527.24 189.27 537.71 184.27 538.78 183.87C539.85 183.46 543.74 187.47 544.74 187.4C547.5 187.22 546.82 184.71 546.82 184.71C546.82 184.71 546.08 186.88 544.19 185.8C541.27 184.14 538.15 182.33 537.75 181.92C537.09 181.25 527.25 189.27 527.25 189.27H527.24Z"
        fill="url(#paint65_linear_1974_24988)"
      />
      <path
        d="M532.51 191.63C532.51 191.63 540.23 189.32 540.97 189.76C541.72 190.2 544.75 193.64 545.54 193.92C547.5 194.62 548.92 193.68 549.17 192.09C549.17 192.09 547.59 195.47 541.55 188.58C540.88 187.82 532.5 191.63 532.5 191.63H532.51Z"
        fill="url(#paint66_linear_1974_24988)"
      />
      <path
        d="M519.44 161.97C519.44 161.97 520.33 161.4 522.19 162.95C523.04 163.65 526.99 168.08 530.76 171.8C534.64 175.62 538.32 178.72 538.32 178.72L535.16 178.85C535.16 178.85 521.42 162.4 519.43 161.98L519.44 161.97Z"
        fill="url(#paint67_linear_1974_24988)"
      />
      <path
        d="M538.33 178.72C538.33 178.72 540.9 170.69 543.12 169.56C543.12 169.56 542.92 168.56 541.85 168.56C540.67 168.56 538.5 172 538.39 172.44C537.93 174.36 538.33 178.72 538.33 178.72Z"
        fill="url(#paint68_linear_1974_24988)"
      />
      <path
        d="M528.169 193.6C528.169 193.6 526.67 192.41 526.64 191.62C526.61 190.99 526.819 189.44 527.359 189.18C528.489 188.63 529.999 187.97 529.999 187.97C529.999 187.97 528.209 189.29 527.969 189.57C527.529 190.07 527.379 191.4 527.429 191.96C527.469 192.43 528.169 193.6 528.169 193.6Z"
        fill="url(#paint69_linear_1974_24988)"
      />
      <path
        d="M531.75 187.12C531.75 187.12 538.16 183.36 539.53 183.66C540.91 183.97 545.93 189.02 545.93 189.02C545.93 189.02 540.24 185.52 539.42 185.42C538.6 185.33 531.74 187.11 531.74 187.11L531.75 187.12Z"
        fill="url(#paint70_linear_1974_24988)"
      />
      <path
        d="M527.24 189.27C527.14 188.45 526.91 185.97 527.24 185.5C527.88 184.57 529.71 183.43 529.71 183.43C529.71 183.43 528.24 184.94 527.76 186.46C527.44 187.47 527.33 188.55 527.25 189.27H527.24Z"
        fill="url(#paint71_linear_1974_24988)"
      />
      <path
        d="M529.77 198.98C529.6 198.83 527.96 196.61 527.81 196.16C527.71 195.87 528.14 194.22 528.19 193.89C528.31 193.07 530.52 192.57 530.52 192.57C530.52 192.57 529.14 193.8 529.05 194.01C528.89 194.42 528.74 195.78 528.71 196.04C528.63 196.59 529.77 198.98 529.77 198.98Z"
        fill="url(#paint72_linear_1974_24988)"
      />
      <path
        d="M535.34 190.83C535.34 190.83 539.81 189.37 540.97 189.77C541.86 190.08 546.61 194.7 546.61 194.7C546.61 194.7 541.07 191.11 540 190.85C538.93 190.58 535.34 190.84 535.34 190.84V190.83Z"
        fill="url(#paint73_linear_1974_24988)"
      />
      <path
        d="M536.09 198.89C536.09 198.89 539.86 194.8 540.31 194.6C540.76 194.4 547.1 198.26 547.1 198.26C547.1 198.26 544.37 201.29 545.11 203.7C545.85 206.11 539.86 200.18 536.1 198.89H536.09Z"
        fill="url(#paint74_linear_1974_24988)"
      />
      <path
        d="M534.35 205.36C534.35 205.36 539.28 209.85 541.28 210.04C543.29 210.22 546.27 209.83 546.27 209.83C546.27 209.83 541.33 219.24 540.03 219.9C539.99 218.68 539.17 213.73 538.28 211.95C537.39 210.17 534.34 205.37 534.34 205.37L534.35 205.36Z"
        fill="url(#paint75_linear_1974_24988)"
      />
      <path
        d="M544.219 182.25C544.219 182.25 547.159 184.22 547.239 184.41C547.319 184.59 546.739 186.02 545.659 185.98C544.589 185.94 543.379 184.08 543.219 183.65C543.059 183.22 543.479 181.75 544.209 182.25H544.219Z"
        fill="#FFE2BD"
      />
      <path
        d="M546.3 189.27C546.3 189.27 549.1 191.15 549.18 191.32C549.25 191.49 548.7 192.85 547.68 192.81C546.66 192.77 545.51 191 545.36 190.6C545.21 190.19 545.6 188.8 546.31 189.27H546.3Z"
        fill="#FFE2BD"
      />
      <path
        d="M546.609 194.69C546.609 194.69 548.649 196.29 548.689 196.43C548.739 196.57 548.229 197.57 547.449 197.48C546.669 197.39 545.889 195.97 545.799 195.65C545.709 195.33 546.089 194.28 546.599 194.69H546.609Z"
        fill="#FFE2BD"
      />
      <path
        d="M545.45 208.3C546.92 206.69 534.53 198.63 533.27 198.45C532.02 198.28 535.59 204.54 538.88 207.29C542.16 210.04 544.25 209.6 545.45 208.3Z"
        fill="url(#paint76_linear_1974_24988)"
      />
      <path
        d="M530.939 181.53L531.379 182.08L535.449 178.99L538.319 178.71C538.319 178.71 536.799 177.48 536.009 177.39C535.219 177.29 530.939 181.53 530.939 181.53Z"
        fill="url(#paint77_linear_1974_24988)"
      />
      <path
        d="M538.33 178.72L542.88 180.93L546.15 183.38C546.15 183.38 544.97 180.67 544.76 180.06C544.76 180.06 539.07 179.03 538.32 178.71L538.33 178.72Z"
        fill="url(#paint78_linear_1974_24988)"
      />
      <path
        d="M531.39 182.09C531.39 182.09 535.19 178.16 536.24 178.05C537.3 177.95 542.88 180.93 542.88 180.93C542.88 180.93 536.9 179.34 536.23 179.32C535.56 179.3 531.39 182.08 531.39 182.08V182.09Z"
        fill="url(#paint79_linear_1974_24988)"
      />
      <path
        d="M536.09 198.89L540.13 197.8L545.57 198.34L539.97 194.16L536.09 198.89Z"
        fill="url(#paint80_linear_1974_24988)"
      />
      <path
        d="M535.94 198.99C535.94 198.99 539.51 196 540.11 195.15C542.01 197.75 545.8 198.87 547.04 198.62C548.03 198.42 548.69 197.49 548.69 197.49C548.69 197.49 546.57 198.91 540.3 193.76C539.93 193.45 535.93 198.98 535.93 198.98L535.94 198.99Z"
        fill="url(#paint81_linear_1974_24988)"
      />
      <path
        d="M565.65 238.66C564.4 236.27 555.86 223.53 554.45 219.48C554.07 218.4 553.56 217.25 553.05 215.18C547.33 218.27 542.32 221.62 540.22 222.44C540.34 226.27 540.61 235.39 540.71 236.65C541.54 247.25 548.1 260.4 553.42 260.4C558.43 260.4 564.53 244.4 565.66 238.66H565.65Z"
        fill="#F7D4AB"
      />
      <path
        d="M564.21 242C562.17 247.54 557.97 255.33 553.23 257.03C550.16 258.13 543.88 249.31 543.88 249.31C547.77 259.45 552.81 260.98 554.22 260.76C555.49 260.56 558.5 259.23 561.16 254.09C565.28 246.15 566.71 240.07 567.06 238.89C567.15 238.57 567.5 237.4 568 235.68C567.22 235.29 566.6 234.91 565.77 234.45C564.91 238.8 564.26 241.84 564.21 241.99V242Z"
        fill="url(#paint82_linear_1974_24988)"
      />
      <path
        d="M559.24 229.3L568.54 233.82L567.93 235.93L559.9 231.46L559.24 229.3Z"
        fill="url(#paint83_linear_1974_24988)"
      />
      <path
        d="M615.1 201.76C615.1 201.76 619.85 203.24 620.71 203.39C621.57 203.54 624.75 201.08 624.75 201.08C624.75 201.08 621.58 199.12 620.61 199.63C619.64 200.14 615.1 201.75 615.1 201.75V201.76Z"
        fill="url(#paint84_linear_1974_24988)"
      />
      <path
        d="M621.94 201.48C621.61 201.48 618.41 200.71 618.99 200.44C620.14 199.91 625.1 199.56 625.1 199.56C625.1 199.56 622.27 201.48 621.94 201.48Z"
        fill="url(#paint85_linear_1974_24988)"
      />
      <path
        d="M602.8 183.59C603.49 181.72 606.04 182.13 607.18 182.27C608.32 182.41 615.49 184.84 615.49 184.84L610.8 189.85C610.8 189.85 601.53 187.03 602.8 183.58V183.59Z"
        fill="url(#paint86_linear_1974_24988)"
      />
      <path
        d="M602.9 185.13C602.9 185.13 602.53 184.38 602.76 183.63C602.99 182.88 603.82 181.9 606.2 182.1C608.74 182.31 615.1 184.38 615.1 184.38L613.76 185.27C613.76 185.27 611.31 184.4 607.91 183.83C604.51 183.25 602.9 185.14 602.9 185.14V185.13Z"
        fill="#F7D5AB"
      />
      <path
        d="M654.59 210.38C654.59 210.38 644.85 196.53 643.87 195.63C642.89 194.73 624.88 177 622.95 176.04C621.02 175.08 614.68 174.5 611.52 173.41C608.36 172.32 598.12 169.47 597.74 170.88C597.13 173.13 600.79 174.25 607.32 177.08C613.85 179.92 618.67 180.93 618.67 180.93C618.67 180.93 609.16 186.84 609.36 189.41C609.56 191.98 612.01 193.59 612.01 193.59C612.01 193.59 611.43 196.33 613.32 198.43C613.32 198.43 612.74 202.6 616.66 201.69C620.58 200.77 622.34 199.94 622.34 199.94C622.34 199.94 632.7 204.95 634.86 206.02C637.02 207.09 640.92 219.54 640.92 219.54L654.57 210.39L654.59 210.38Z"
        fill="#F7D5AB"
      />
      <path
        d="M617.42 181.9C617.42 181.9 608.33 177.64 605.13 176.27C602.75 175.25 597.24 173.66 597.69 171.11C598.86 173.39 612.85 178.37 620.01 180.43L617.41 181.89L617.42 181.9Z"
        fill="url(#paint87_linear_1974_24988)"
      />
      <path
        d="M612.02 193.59C612.02 193.59 618.74 187.15 619.84 186.34C620.94 185.54 625.33 186.53 625.33 186.53C625.33 186.53 620.97 183.87 620.62 184.01C618.59 184.79 613.64 190.03 612.87 190.82C612.59 191.1 612.03 193.59 612.03 193.59H612.02Z"
        fill="url(#paint88_linear_1974_24988)"
      />
      <path
        d="M613.33 198.42C613.33 198.42 620.9 192.29 621.75 192.23C622.6 192.18 626.13 193.36 626.13 193.36C626.13 193.36 622.44 189.92 621.73 190.2C619.64 191 615.09 195.39 614.38 196.13C614.1 196.42 613.33 198.43 613.33 198.43V198.42Z"
        fill="url(#paint89_linear_1974_24988)"
      />
      <path
        d="M639.77 216.04C639.77 216.04 640.97 207.35 641.3 206.11C641.63 204.87 631.86 203.3 628.25 202.78C628.25 202.78 635.01 206.85 635.99 207.85C636.98 208.85 639.77 216.04 639.77 216.04Z"
        fill="url(#paint90_linear_1974_24988)"
      />
      <path
        d="M597.85 170.71C597.85 170.71 598.33 170.07 600.42 170.43C602.51 170.78 620.95 175.47 622.4 175.6C623.85 175.73 627.87 180.29 627.87 180.29C627.87 180.29 622.84 177.25 620.68 176.76C618.52 176.27 598.71 170.49 597.84 170.72L597.85 170.71Z"
        fill="url(#paint91_linear_1974_24988)"
      />
      <path
        d="M615.1 190.66C615.1 190.66 619.04 186.49 620.2 185.81C621.37 185.13 626.13 186.8 626.13 186.8C626.13 186.8 621.32 186.83 620.45 187.19C619.58 187.54 615.1 190.66 615.1 190.66Z"
        fill="url(#paint92_linear_1974_24988)"
      />
      <path
        d="M616.8 195.68C616.8 195.68 620.53 192.05 621.77 192.05C622.65 192.05 628.25 194.16 628.25 194.16C628.25 194.16 622.8 193.36 621.74 193.49C620.67 193.62 616.81 195.68 616.81 195.68H616.8Z"
        fill="url(#paint93_linear_1974_24988)"
      />
      <path
        d="M631.01 183.23C631.01 183.23 643.37 194.15 643.77 194.76C644.17 195.37 649.14 202.71 649.14 202.71C649.14 202.71 636.65 196 635.42 195.11C634.19 194.22 630.17 189.8 629.95 189.05C629.73 188.3 630.31 182.94 631.01 183.23Z"
        fill="url(#paint94_linear_1974_24988)"
      />
      <path
        d="M614.1 201.27C614.1 201.27 614.6 201.68 615.33 201.79C616.47 201.97 618.63 201.5 622.36 199.93L627.23 202.29C627.23 202.29 622.9 198.42 622.35 198.43C621.69 198.43 618.87 200.98 614.1 201.28V201.27Z"
        fill="url(#paint95_linear_1974_24988)"
      />
      <path
        d="M617.42 181.9L615.97 181.22C615.97 181.22 621.38 178.38 622.26 178.35C623.14 178.31 628.13 182.32 628.13 182.32C628.13 182.32 622.72 179.78 622.36 179.76C622 179.74 617.43 181.9 617.43 181.9H617.42Z"
        fill="url(#paint96_linear_1974_24988)"
      />
      <path
        d="M615.96 182.73C615.96 182.73 620.92 179.23 622.37 179.24C623.82 179.24 628.74 182.75 628.74 182.75C628.74 182.75 623.93 180.63 622.49 180.62C621.04 180.62 615.96 182.73 615.96 182.73Z"
        fill="url(#paint97_linear_1974_24988)"
      />
      <path
        d="M602.74 170.96C603.04 171.09 602.93 172.9 600.77 172.58C598.61 172.26 598.11 171.83 597.96 171.6C597.81 171.37 597.67 169.38 598.83 169.62C600.21 169.91 601.84 170.57 602.75 170.95L602.74 170.96Z"
        fill="#FFE2BD"
      />
      <path
        d="M674.59 230.57C673.54 228.67 664.32 222.06 661.07 218.7C659.45 217.03 656.1 212.43 653.22 208.44C652.07 211.82 649.2 213.14 646.04 215.36C643.92 216.73 642.64 218.66 640.56 218.38C644.29 228.89 650.03 246.69 651.09 250.08C652.25 253.81 665.93 261.54 671.12 259.38C676.07 257.31 675.62 232.46 674.57 230.56L674.59 230.57Z"
        fill="#F7D4AB"
      />
      <path
        d="M652.31 207.16C652.31 207.16 660.01 217.69 661.07 218.71C662.13 219.73 674.44 228.61 674.84 230.65C675.24 232.69 675.96 242.17 674.51 251.17C674.51 251.17 671.33 234.9 669.14 232.27C666.95 229.64 661.89 225.18 659.92 221.01C657.95 216.84 652.33 207.16 652.33 207.16H652.31Z"
        fill="url(#paint98_linear_1974_24988)"
      />
      <path
        d="M640.29 217.56C640.29 217.56 650.09 248.19 651.13 250.69C652.26 253.41 664.39 261.46 670.8 259.57C672.41 259.09 673.07 257.24 673.39 256.07C673.07 256.36 671.21 258.46 667.26 257.32C663.31 256.18 656.68 252.44 653.29 247.73C648.52 241.1 640.29 217.56 640.29 217.56Z"
        fill="url(#paint99_linear_1974_24988)"
      />
      <path
        d="M553.17 215.66C553.17 215.66 556.21 224.46 561.47 231.6C565.46 237.01 558.58 248.63 556.06 247.12C553.54 245.61 550.29 219.95 550.29 219.95C550.29 219.95 552.58 218.05 553.18 215.66H553.17Z"
        fill="url(#paint100_linear_1974_24988)"
      />
      <path
        d="M628.09 106.17C620.16 106.17 619.43 111.02 619.26 114.51C619.86 114.64 620.49 114.76 621.67 115.12C623.26 115.61 625.13 116.4 627.82 116.37C629.94 116.35 634.5 115.39 634.56 110.84C634.61 107.24 630 106.32 628.09 106.16V106.17Z"
        fill="url(#paint101_linear_1974_24988)"
      />
      <path
        d="M619.62 114.24C621.35 114.49 622.51 115.08 623.71 115.4C622.77 114.54 622.23 113.76 622.3 112.33C622.36 111.1 623.3 109.76 624.1 109.01C621.29 110.67 619.62 114.23 619.62 114.23V114.24Z"
        fill="url(#paint102_linear_1974_24988)"
      />
      <path
        d="M619.62 114.24C620.12 113.76 621 112.77 622.37 111.95C622.54 110.99 623.09 110.14 623.87 109.54C621.3 110.79 619.62 114.24 619.62 114.24Z"
        fill="#DDDDDD"
      />
      <path
        d="M630.24 112.74C630.16 114.22 629.39 115.15 628.3 115.86C632.93 115.26 634.24 111.58 634.24 111.58C631.38 109.21 629.32 108.46 627.37 108.29C629.11 108.88 630.34 110.68 630.23 112.73L630.24 112.74Z"
        fill="url(#paint103_linear_1974_24988)"
      />
      <path
        d="M622.37 111.84C622.34 112.02 622.32 112.14 622.31 112.33C622.21 113.71 622.74 114.57 623.72 115.4C624.05 115.56 626.95 116.15 628.72 115.86C629.85 115.16 630.67 114.27 630.76 112.84C630.8 112.09 630.65 111.38 630.34 110.75C628.09 109.97 625.12 109.99 622.37 111.85V111.84Z"
        fill="url(#paint104_linear_1974_24988)"
      />
      <path
        d="M628.7 109.17C629.59 109.66 630.26 110.46 630.57 111.41C632.19 112.09 633.26 112.96 633.26 112.96L634.04 111.38C632.91 109.95 630.76 109.55 628.7 109.16V109.17Z"
        fill="#DDDDDD"
      />
      <path
        d="M628.7 109.17C627.46 108.94 626.17 108.92 624.97 109.15C624.59 109.22 624.22 109.35 623.87 109.53C623.09 110.13 622.5 110.96 622.35 111.94C623.37 111.33 624.68 110.82 626.29 110.67C627.89 110.52 629.41 110.92 630.6 111.42C630.32 110.45 629.59 109.67 628.71 109.17H628.7Z"
        fill="url(#paint105_linear_1974_24988)"
      />
      <path
        d="M626.65 109.43C625.18 109.32 623.91 110.38 623.81 111.8C623.7 113.22 624.81 114.45 626.27 114.56C627.74 114.67 629.01 113.61 629.12 112.19C629.23 110.77 628.12 109.54 626.66 109.43H626.65Z"
        fill="url(#paint106_radial_1974_24988)"
      />
      <path
        d="M627.11 110.94C626.76 110.74 626.31 110.87 626.09 111.22C625.88 111.58 625.99 112.03 626.33 112.23C626.68 112.43 627.13 112.3 627.35 111.95C627.57 111.59 627.46 111.14 627.11 110.94Z"
        fill="white"
      />
      <path
        d="M629.5 112.01C629.02 111.73 628.42 111.88 628.14 112.35C627.87 112.82 628.03 113.44 628.51 113.71C628.99 113.99 629.59 113.84 629.87 113.37C630.14 112.9 629.98 112.29 629.51 112L629.5 112.01Z"
        fill="white"
      />
      <path
        d="M636.01 108.07C636.01 108.07 635.24 109.69 631.37 108.3C623.92 105.89 619.77 110.23 619.62 114.24C619.62 114.24 621.86 109.84 626.09 109.42C628.66 109.17 630.89 110.23 633.11 111.43C633.14 113.21 630.76 115.4 628.19 115.92C630.39 115.94 635.27 113.68 635.63 111.82C635.49 112.05 635.03 112.21 634.43 111.99C634.43 111.99 636.53 111.15 636.01 108.06V108.07Z"
        fill="url(#paint107_linear_1974_24988)"
      />
      <path
        d="M624.29 106.54C621.71 107.42 620.59 109.29 620.59 109.29C620.59 109.29 621.76 107.76 624.53 106.93C627.41 106.07 631.39 106.91 631.39 106.91C629.64 106.09 626.89 105.66 624.3 106.54H624.29Z"
        fill="url(#paint108_linear_1974_24988)"
      />
      <path
        d="M625.78 109.03C620.94 109.85 619.63 114.23 619.63 114.23C619.63 114.23 621.49 110.46 625.89 109.68C628.39 109.23 631.22 110.46 633.12 111.43C633.12 111.43 630.14 108.29 625.78 109.03Z"
        fill="#391B13"
      />
      <path
        d="M598.64 106.17C606.57 106.17 607.3 111.02 607.47 114.51C606.87 114.64 606.24 114.76 605.06 115.12C603.47 115.61 601.6 116.4 598.91 116.37C596.79 116.35 592.23 115.39 592.17 110.84C592.12 107.24 596.73 106.32 598.64 106.16V106.17Z"
        fill="url(#paint109_linear_1974_24988)"
      />
      <path
        d="M607.11 114.24C605.38 114.49 604.22 115.08 603.02 115.4C603.96 114.54 604.5 113.76 604.43 112.33C604.37 111.1 603.43 109.76 602.63 109.01C605.44 110.67 607.11 114.23 607.11 114.23V114.24Z"
        fill="url(#paint110_linear_1974_24988)"
      />
      <path
        d="M607.11 114.24C606.61 113.76 605.73 112.77 604.36 111.95C604.19 110.99 603.64 110.14 602.86 109.54C605.43 110.79 607.11 114.24 607.11 114.24Z"
        fill="#DDDDDD"
      />
      <path
        d="M596.49 112.74C596.57 114.22 597.34 115.15 598.43 115.86C593.8 115.26 592.49 111.58 592.49 111.58C595.35 109.21 597.41 108.46 599.36 108.29C597.62 108.88 596.39 110.68 596.5 112.73L596.49 112.74Z"
        fill="url(#paint111_linear_1974_24988)"
      />
      <path
        d="M604.36 111.84C604.39 112.02 604.41 112.14 604.42 112.33C604.52 113.71 603.99 114.57 603.01 115.4C602.68 115.56 599.78 116.15 598.01 115.86C596.88 115.16 596.06 114.27 595.97 112.84C595.93 112.09 596.08 111.38 596.39 110.75C598.64 109.97 601.61 109.99 604.36 111.85V111.84Z"
        fill="url(#paint112_linear_1974_24988)"
      />
      <path
        d="M598.03 109.17C597.14 109.66 596.47 110.46 596.16 111.41C594.54 112.09 593.47 112.96 593.47 112.96L592.69 111.38C593.82 109.95 595.97 109.55 598.03 109.16V109.17Z"
        fill="#DDDDDD"
      />
      <path
        d="M598.03 109.17C599.27 108.94 600.56 108.92 601.76 109.15C602.14 109.22 602.51 109.35 602.86 109.53C603.64 110.13 604.23 110.96 604.38 111.94C603.36 111.33 602.05 110.82 600.44 110.67C598.84 110.52 597.32 110.92 596.13 111.42C596.41 110.45 597.14 109.67 598.02 109.17H598.03Z"
        fill="url(#paint113_linear_1974_24988)"
      />
      <path
        d="M600.08 109.43C601.55 109.32 602.82 110.38 602.92 111.8C603.03 113.22 601.92 114.45 600.46 114.56C598.99 114.67 597.72 113.61 597.61 112.19C597.5 110.77 598.61 109.54 600.07 109.43H600.08Z"
        fill="url(#paint114_radial_1974_24988)"
      />
      <path
        d="M600.66 110.94C600.31 110.74 599.86 110.87 599.64 111.22C599.43 111.58 599.54 112.03 599.88 112.23C600.23 112.43 600.68 112.3 600.9 111.95C601.12 111.59 601.01 111.14 600.66 110.94Z"
        fill="white"
      />
      <path
        d="M603.05 112.01C602.57 111.73 601.97 111.88 601.69 112.35C601.42 112.82 601.58 113.44 602.06 113.71C602.54 113.99 603.14 113.84 603.42 113.37C603.69 112.9 603.53 112.29 603.06 112L603.05 112.01Z"
        fill="white"
      />
      <path
        d="M590.72 108.07C590.72 108.07 591.49 109.69 595.36 108.3C602.81 105.89 606.96 110.23 607.11 114.24C607.11 114.24 604.87 109.84 600.64 109.42C598.07 109.17 595.84 110.23 593.62 111.43C593.59 113.21 595.97 115.4 598.54 115.92C596.34 115.94 591.46 113.68 591.1 111.82C591.24 112.05 591.7 112.21 592.3 111.99C592.3 111.99 590.2 111.15 590.72 108.06V108.07Z"
        fill="url(#paint115_linear_1974_24988)"
      />
      <path
        d="M602.44 106.54C605.02 107.42 606.14 109.29 606.14 109.29C606.14 109.29 604.97 107.76 602.2 106.93C599.32 106.07 595.34 106.91 595.34 106.91C597.09 106.09 599.84 105.66 602.43 106.54H602.44Z"
        fill="url(#paint116_linear_1974_24988)"
      />
      <path
        d="M600.95 109.03C605.79 109.85 607.1 114.23 607.1 114.23C607.1 114.23 605.24 110.46 600.84 109.68C598.34 109.23 595.51 110.46 593.61 111.43C593.61 111.43 596.59 108.29 600.95 109.03Z"
        fill="#391B13"
      />
      <path
        d="M600.27 130.85C599.59 130.62 599.55 129.62 599.83 129.1C600.08 128.64 603.05 131.16 604.15 132.73C602.67 131.63 600.95 131.07 600.27 130.84V130.85Z"
        fill="url(#paint117_linear_1974_24988)"
      />
      <path
        d="M626.15 130.86C627.08 130.29 627.11 129.48 626.79 128.98C626.51 128.54 623.69 131.11 622.72 132.76C624.12 131.56 625.49 131.13 626.15 130.86Z"
        fill="url(#paint118_linear_1974_24988)"
      />
      <path
        d="M606.79 136.21C608.07 138.94 615.1 142.75 620.29 136.14C620.29 136.14 612.92 139.43 606.79 136.21Z"
        fill="url(#paint119_linear_1974_24988)"
      />
      <path
        d="M612.73 131.54C606.11 131.46 602.25 130.46 600.68 130.14V130.16C600.73 130.22 600.75 130.26 600.79 130.33C601.62 130.7 602.58 130.94 603.8 131.82C604.64 132.42 605.46 136.5 613.69 136.4C618.19 136.35 620.9 134.81 623.56 131.73C624.39 130.77 625.18 130.47 625.83 130.09C625.85 130.01 625.88 129.98 625.9 129.9C624.1 130.41 620.48 131.63 612.72 131.55L612.73 131.54Z"
        fill="#961B27"
      />
      <path
        d="M620.14 132.26C615.52 133.3 609.23 133.18 606.96 132.76C605.64 132.18 605.77 133.86 605.77 133.86C608.67 136.83 610.99 136.27 613.32 136.32C615.62 136.38 619.05 135.45 621.08 133.64C621.28 133.09 620.79 132.12 620.14 132.26Z"
        fill="url(#paint120_linear_1974_24988)"
      />
      <path
        d="M622.19 130.54C622.19 130.54 620.68 131.27 617.14 131.65C613.57 132.03 612.06 131.82 608.86 131.67C607.39 131.6 606.49 131.38 604.64 130.95C604.64 130.95 604.98 131.37 605.2 131.87C605.48 132.52 606.88 134.71 613.5 134.62C618.49 134.56 621.11 132.78 621.47 131.7C621.68 131.05 622.15 130.76 622.19 130.54Z"
        fill="url(#paint121_linear_1974_24988)"
      />
      <path
        d="M614.13 136.08C604 136.08 607.52 131.94 600.79 130.31C600.84 130.32 602.34 131.13 604.11 133.18C606.07 135.44 607.76 139 613.43 138.95C618.55 138.9 621.37 135.17 623 133.12C624.87 130.78 625.8 130.08 625.85 130.07C620.35 131.58 622.18 135.82 614.13 136.08Z"
        fill="#F86D78"
      />
      <path
        d="M608.14 135.15C606.58 134.35 605.19 132.66 604.9 132.44C605.27 132.94 607.46 138.3 613.17 138.17C619.76 138.02 620.95 133.6 622.13 132.28C621.57 132.87 620.18 134.45 618.46 135.04C617.33 135.43 615.42 135.9 613.29 135.99C611.93 136.05 609.66 135.77 608.15 135.14L608.14 135.15Z"
        fill="url(#paint122_linear_1974_24988)"
      />
      <path
        d="M618.25 135.71C618.34 135.94 617.7 136.71 616.36 137.09C614.63 137.58 613.26 137.11 613.17 136.88C613.08 136.65 615.38 136.49 616.04 136.26C616.71 136.03 618.16 135.49 618.25 135.72V135.71Z"
        fill="#FF9AA2"
      />
      <path
        d="M600.9 130.71C601.3 130.89 601.61 130.59 603.2 131.16C603.2 131.16 600.49 129.75 600.32 129.83C600.19 129.89 600.32 130.43 600.91 130.7L600.9 130.71Z"
        fill="#961B27"
      />
      <path
        d="M625.86 130.47C625.46 130.66 625.02 130.37 623.63 130.99C623.63 130.99 626.21 129.43 626.43 129.58C626.54 129.66 626.45 130.18 625.86 130.47Z"
        fill="#961B27"
      />
      <path
        d="M604.79 131.11L605.22 131.9C605.22 131.9 608.09 133.44 613.98 133.42C618.23 133.4 621.45 131.78 621.45 131.78L621.79 131L604.79 131.12V131.11Z"
        fill="url(#paint123_linear_1974_24988)"
      />
      <path
        d="M617.17 130.53C615.2 130.38 614.98 130.7 613.57 130.71C612.19 130.72 611.08 130.32 609.38 130.47C607.16 130.67 604.45 130.84 601.23 130.17C601.23 130.17 602.43 130.91 608.36 132.05C610.13 132.39 611.69 132.73 613.51 132.68C615.68 132.68 617.48 132.24 619.17 131.95C622.02 131.46 625.4 130.04 625.41 129.98C623.89 130.41 619.35 130.68 617.18 130.52L617.17 130.53Z"
        fill="#F86D78"
      />
      <path
        d="M607.03 131.11C607.09 130.9 610.03 130.64 610.52 130.64C611 130.64 612.62 130.92 613.2 130.92C613.78 130.92 615.56 130.81 616.04 130.7C616.52 130.59 620.11 130.9 620.07 131.15C620.04 131.4 614.84 132.03 614.22 132.08C613.61 132.14 606.86 131.7 607.02 131.09L607.03 131.11Z"
        fill="url(#paint124_linear_1974_24988)"
      />
      <path
        d="M607.89 125.53C607.89 125.53 612.41 128.54 613.41 128.41C614.42 128.28 618.61 125.54 618.61 125.54H607.89V125.53Z"
        fill="url(#paint125_linear_1974_24988)"
      />
      <path
        d="M613.26 121.05C610.42 121.13 609.61 121.85 609.82 122.61C610.33 124.46 611.54 124.8 613.31 124.8C615.18 124.8 616.64 124.38 616.93 122.39C617.02 121.8 616.11 120.97 613.26 121.05Z"
        fill="url(#paint126_linear_1974_24988)"
      />
      <path
        d="M615.17 126.01C615.17 126.01 618.14 123.79 618.71 124.37C620.4 126.09 615.17 126.01 615.17 126.01Z"
        fill="url(#paint127_linear_1974_24988)"
      />
      <path
        d="M611.66 126C611.66 126 608.51 124.07 607.9 124.59C606.15 126.08 611.66 126 611.66 126Z"
        fill="url(#paint128_linear_1974_24988)"
      />
      <path
        d="M607.89 125.53C607.89 125.53 607.59 124.77 608.77 124.85C609.63 124.91 610.32 126.73 613.37 126.64C616.64 126.55 617.08 124.91 617.92 124.86C618.68 124.82 618.6 125.53 618.6 125.53C618.6 125.53 620.15 124.73 619.56 124.01C618.5 122.71 618.17 125.38 613.3 125.31C608.01 125.23 607.4 122.65 606.68 124.31C606.38 124.99 606.95 125.19 607.88 125.52L607.89 125.53Z"
        fill="#F0C499"
      />
      <g style={{ mixBlendMode: 'multiply' }}>
        <g style={{ mixBlendMode: 'multiply' }}>
          <path
            d="M3.30957 250.89C3.30957 250.89 11.8596 252.35 11.3496 258.69C11.3496 258.69 17.8296 254.18 22.4996 260.03C22.4996 260.03 20.5596 255.64 14.0796 255.46C14.0796 255.46 12.2696 251.13 3.31957 250.89H3.30957Z"
            fill="#A9D8DB"
          />
        </g>
      </g>
      <path
        d="M438.13 292.25H380.72L383.14 220.64H435.71L438.13 292.25Z"
        fill="#DECDAF"
      />
      <path
        d="M409 252.61C400.07 252.61 392.8 242.75 392.8 230.64C392.8 230.19 393.16 229.83 393.61 229.83C394.06 229.83 394.42 230.19 394.42 230.64C394.42 241.86 400.96 251 409 251C417.04 251 423.58 241.87 423.58 230.64C423.58 230.19 423.94 229.83 424.39 229.83C424.84 229.83 425.2 230.19 425.2 230.64C425.2 242.75 417.93 252.61 409 252.61Z"
        fill="white"
      />
      <path
        d="M708.139 292.64H306.939V538.83H708.139V292.64Z"
        fill="url(#paint129_diamond_1974_24988)"
        stroke="#8A9298"
        strokeWidth="2.2"
        strokeMiterlimit={10}
      />
      <path
        d="M741.21 292.96H176.88V380.12H741.21V292.96Z"
        fill="#008E2F"
        stroke="white"
        strokeWidth="2.95"
        strokeMiterlimit={10}
      />
      <path
        d="M483.67 292.25H415.05L417.94 206.67H480.78L483.67 292.25Z"
        fill="#E0B660"
      />
      <path
        d="M448.85 244.87C443.62 244.87 438.72 242.1 435.06 237.07C431.47 232.13 429.49 225.58 429.49 218.62C429.49 218.09 429.92 217.66 430.45 217.66C430.98 217.66 431.41 218.09 431.41 218.62C431.41 232.03 439.23 242.95 448.84 242.95C458.45 242.95 466.27 232.04 466.27 218.62C466.27 218.09 466.7 217.66 467.23 217.66C467.76 217.66 468.19 218.09 468.19 218.62C468.19 225.58 466.21 232.13 462.62 237.07C458.96 242.1 454.06 244.87 448.83 244.87H448.85Z"
        fill="white"
      />
      <path d="M161.78 276.82H13.2197V281.99H161.78V276.82Z" fill="#542413" />
      <path
        d="M98.9089 253.8C98.5189 253.8 98.2089 253.49 98.2089 253.1C98.0189 237.11 99.9689 228.7 104.169 227.4C108.339 226.11 112.729 232.59 112.919 232.87C113.139 233.19 113.049 233.63 112.729 233.85C112.409 234.07 111.969 233.98 111.749 233.66C110.649 232.02 107.219 227.94 104.589 228.75C102.629 229.36 99.3789 233.33 99.6189 253.09C99.6189 253.48 99.3089 253.8 98.9189 253.8H98.9089Z"
        fill="#542413"
      />
      <path
        d="M60.1892 309.17C59.8492 309.17 59.5492 308.93 59.4992 308.58C58.0592 300 56.1292 293.09 54.4292 286.99C51.3292 275.88 49.2892 268.54 53.4692 261.93C61.9492 248.53 70.4192 241.69 78.6392 241.6C82.8292 241.55 89.0092 243.32 94.9992 251.76C95.0392 248.18 94.5992 239.49 92.9492 230.26C91.1492 220.21 87.5592 207.56 80.6292 204.43C77.4692 203 73.7992 203.74 69.7092 206.62C64.9192 210.01 59.5092 216.37 53.6492 225.53C53.4392 225.86 52.9992 225.95 52.6792 225.74C52.3492 225.53 52.2592 225.09 52.4692 224.77C57.9492 216.21 63.0692 210.02 67.6892 206.38C71.9392 203.03 75.8792 201.73 79.4092 202.53C89.9092 204.91 93.9392 225.2 95.4092 237.08C96.0692 242.44 96.2992 246.69 96.3692 248.75C96.5592 253.99 96.2392 254.15 95.8492 254.35C95.5692 254.49 95.2392 254.44 95.0092 254.23C94.9092 254.13 94.8292 254.01 94.5792 253.64C88.7092 244.78 82.6792 242.97 78.6592 243.01C70.9492 243.09 62.8792 249.71 54.6692 262.68C50.8192 268.77 52.7992 275.86 55.7992 286.61C57.5092 292.74 59.4492 299.7 60.8992 308.35C60.9592 308.73 60.7092 309.1 60.3192 309.16C60.2792 309.16 60.2392 309.16 60.1992 309.16L60.1892 309.17Z"
        fill="#542413"
      />
      <path
        d="M64.2898 210.69C64.2898 210.69 65.8098 205.76 61.0698 202.77C60.7198 202.55 57.3098 200.73 55.7198 203C61.8798 205.28 59.8498 208.71 54.2898 204.25C51.4798 208.61 50.0298 213.33 50.4298 214.73C50.9398 216.55 51.7998 217.1 52.5998 219.71C53.1798 221.62 51.4898 226.96 51.4898 226.96C51.4898 226.96 56.3598 223.82 59.1698 225.32C64.0398 227.92 69.2898 226.1 71.0798 220.61C74.6298 209.65 64.2998 210.69 64.2998 210.69H64.2898Z"
        fill="#37767A"
      />
      <path
        d="M122.259 240.74C124.539 241.27 126.539 242.77 127.999 244.57C128.759 237.81 125.989 229.43 118.139 232.33C119.179 229.17 124.469 230.88 126.299 232.81C124.309 227.54 120.189 223.83 112.089 225.21C108.979 225.74 112.319 233.26 112.319 233.26C106.999 227.86 95.8491 235.69 99.6891 240.67C100.419 237.73 106.009 235.15 105.909 236.45C102.119 241.01 97.2691 241.58 107.699 247.05C108.589 241.62 119.699 235.26 109.629 245.1C106.749 249.96 121.019 249.58 121.269 252.87C120.829 247.1 128.109 252.44 128.109 252.44C128.109 252.44 128.859 244.19 121.959 241.79C121.269 241.61 121.569 240.55 122.249 240.74H122.259Z"
        fill="#053837"
      />
      <path
        d="M93.6395 221.37C94.7995 222.42 96.3095 224.12 95.2695 226.82C94.8695 227.86 92.4995 226.17 92.4995 226.17C93.9895 228.39 90.4995 231.69 89.0495 230.02C90.1195 229.97 91.3995 228.22 90.9495 228.16C89.1095 229.15 88.9995 230.64 87.4095 226.79C85.8495 223.02 86.9795 219.35 86.9795 219.35C86.9795 219.35 92.9495 220.73 93.6395 221.36V221.37Z"
        fill="#053837"
      />
      <path
        d="M58.7593 328.42C56.9893 331.74 56.6993 335.75 57.3393 339.43C48.3393 333.21 41.0993 321 52.9093 314.54C47.9793 312.47 44.4593 320.69 44.8693 324.94C40.5793 316.95 40.4393 308.04 50.6693 299.67C54.5993 296.45 60.1893 308.46 60.1893 308.46C59.2693 296.3 80.5393 291.04 82.5193 300.96C78.1793 298.75 69.1393 302.79 70.8193 304.05C80.3493 304.28 86.1693 298.99 81.7893 317.42C74.2593 312.77 54.8093 319.52 77.3793 317.7C86.3193 319.34 70.7693 336.25 74.4993 340.03C67.9593 333.4 66.7593 347.88 66.7593 347.88C66.7593 347.88 55.9493 340.07 60.3493 329.17C60.8593 328.15 59.2593 327.39 58.7693 328.41L58.7593 328.42Z"
        fill="#37767A"
      />
      <path
        d="M105.17 277.75H90.4496C85.9896 277.75 82.2996 275.98 82.0396 273.71L79.5996 252.53H115.87L113.59 273.69C113.34 275.96 109.65 277.74 105.18 277.74L105.17 277.75Z"
        fill="#F68A5C"
      />
      <path
        d="M246.549 278.25C238.769 255.19 230.609 213.42 230.609 213.42L235.959 212.03C235.959 212.03 246.569 264.38 251.559 276.83C251.559 276.83 248.339 278.89 246.559 278.24L246.549 278.25Z"
        fill="#127869"
      />
      <path
        d="M266.17 242.23C263.68 229.28 258.17 212.41 257.62 210.09C251.52 184.58 254.26 174.1 243.83 172.26C241.32 171.82 235.34 181.73 235.41 187.69C235.47 193.65 237.22 198.98 238.52 206.38C239.8 213.71 242.85 227.48 246.46 238.62C246.46 238.62 259.73 238.63 266.18 242.24L266.17 242.23Z"
        fill="#C57D4E"
      />
      <path
        d="M269.63 527.92C269.63 527.92 271.59 536.77 271.68 538.66C271.77 540.55 272.61 554.12 272.61 554.12H256.81C256.81 554.12 255.94 541.02 254.64 534.53L269.63 527.92Z"
        fill="url(#paint130_linear_1974_24988)"
      />
      <path
        d="M174.009 550.5V535.19L187.509 532.9C187.509 532.9 190.309 539.63 190.429 541.7C190.549 543.76 190.209 552.05 190.209 552.05L173.999 550.5H174.009Z"
        fill="url(#paint131_linear_1974_24988)"
      />
      <path
        d="M194.689 569.76V578.35C194.689 579.46 193.009 582 189.499 582C188.639 582 173.209 582.58 171.579 582C169.949 581.42 168.579 579.38 168.579 578.35V570.51L194.699 569.76H194.689Z"
        fill="url(#paint132_linear_1974_24988)"
      />
      <path
        d="M174.089 550.06C174.089 550.06 171.799 559.68 171.569 561.32C171.339 562.96 168.829 567.86 168.599 570.9C168.369 573.94 168.799 577.48 173.949 577.19C178.749 576.92 188.159 577.05 190.569 576.13C192.979 575.22 194.899 572.66 194.669 568.72C194.439 564.78 190.759 561.8 190.429 548.2C190.429 548.2 188.939 544.09 181.629 544.37C174.319 544.66 174.089 550.05 174.089 550.05V550.06Z"
        fill="url(#paint133_linear_1974_24988)"
      />
      <path
        d="M175.409 548.99C175.739 548.53 175.629 547.6 177.239 546.54C179.619 544.97 185.689 545.83 186.399 546.2C187.139 546.59 189.039 547.97 189.329 548.2C189.619 548.43 186.709 560.14 187.819 565.54C187.999 566.42 173.229 566.24 173.159 565.79C173.099 565.35 176.379 552.59 176.449 551.58C176.509 550.57 175.469 549.25 175.409 549V548.99Z"
        fill="url(#paint134_linear_1974_24988)"
      />
      <path
        d="M176.679 549.95C176.679 549.95 177.369 549.45 177.679 549.64C177.989 549.83 179.429 552.55 179.429 552.55C179.429 552.55 176.219 561.59 173.009 566.77C173.069 565.52 174.439 561.47 174.509 561.16C174.569 560.85 176.689 549.95 176.689 549.95H176.679Z"
        fill="url(#paint135_linear_1974_24988)"
      />
      <path
        d="M174.009 550.5C174.009 550.5 177.149 549.45 177.399 549.26C177.649 549.07 178.739 551.05 178.739 552.42C178.739 553.79 172.999 566.76 172.999 566.76L173.999 550.49L174.009 550.5Z"
        fill="url(#paint136_linear_1974_24988)"
      />
      <path
        d="M185.79 549.25L185.31 549.41C185.31 549.41 184.92 552.25 185.04 552.66C185.29 553.55 185.8 562.45 187.54 566.86L185.79 549.25Z"
        fill="url(#paint137_linear_1974_24988)"
      />
      <path
        d="M190.429 549.64C190.429 549.64 185.529 548.83 185.349 548.95C185.159 549.07 185.599 551.67 185.599 552.36C185.599 553.05 186.979 567.02 187.909 567.7C188.839 568.39 190.429 549.64 190.429 549.64Z"
        fill="url(#paint138_linear_1974_24988)"
      />
      <path
        d="M175.229 560.82C178.459 562.61 182.299 562.81 185.419 564.8C186.229 565.32 186.989 564.02 186.179 563.51C183.039 561.51 179.209 561.32 175.989 559.53C175.149 559.06 174.389 560.36 175.229 560.82Z"
        fill="url(#paint139_linear_1974_24988)"
      />
      <path
        d="M174.509 565.18C176.499 564.36 178.479 563.44 180.509 562.74C182.209 562.16 184.049 562.11 185.649 561.28C186.509 560.84 185.749 559.55 184.889 559.99C183.229 560.85 181.129 560.9 179.369 561.57C177.599 562.24 175.859 563.01 174.109 563.74C173.229 564.1 173.619 565.55 174.509 565.18Z"
        fill="url(#paint140_linear_1974_24988)"
      />
      <path
        d="M177.299 556.91C179.369 558.6 181.309 559.98 183.969 560.57C184.909 560.78 185.309 559.34 184.369 559.13C181.969 558.59 180.239 557.38 178.359 555.85C177.619 555.25 176.549 556.3 177.299 556.91Z"
        fill="url(#paint141_linear_1974_24988)"
      />
      <path
        d="M176.909 560.6C178.259 559.79 179.789 559.51 181.249 558.96C182.539 558.48 183.599 557.55 184.879 557.08C185.779 556.75 185.389 555.31 184.479 555.64C183.019 556.17 181.849 557.18 180.359 557.69C178.909 558.18 177.469 558.51 176.149 559.31C175.329 559.81 176.079 561.1 176.909 560.6Z"
        fill="url(#paint142_linear_1974_24988)"
      />
      <path
        d="M178.629 553.11C179.549 553.79 180.449 554.27 181.509 554.68C182.579 555.1 183.479 555.89 184.599 556.15C185.539 556.37 185.939 554.93 184.999 554.71C184.029 554.48 183.219 553.76 182.289 553.38C181.219 552.95 180.319 552.5 179.389 551.81C178.619 551.24 177.869 552.53 178.629 553.1V553.11Z"
        fill="url(#paint143_linear_1974_24988)"
      />
      <path
        d="M177.999 556.32C180.359 555.72 182.549 554.71 184.519 553.28C185.289 552.72 184.549 551.42 183.759 551.99C181.879 553.35 179.849 554.31 177.599 554.88C176.669 555.12 177.059 556.56 177.999 556.32Z"
        fill="url(#paint144_linear_1974_24988)"
      />
      <path
        d="M172.949 564.76C175.409 565.43 177.899 566.1 180.459 566.08C182.989 566.07 185.499 565.41 187.969 564.92C188.909 564.73 188.509 563.29 187.569 563.48C185.229 563.94 182.849 564.57 180.459 564.58C178.029 564.59 175.669 563.94 173.339 563.31C172.409 563.06 172.009 564.5 172.939 564.75L172.949 564.76Z"
        fill="#2264A5"
      />
      <path
        d="M174.879 560.61C177.239 561.03 179.599 561.43 182.009 561.26C183.599 561.14 185.749 561.53 187.139 560.75C187.979 560.28 187.229 558.98 186.379 559.46C185.689 559.85 184.949 559.57 184.219 559.57C183.329 559.57 182.449 559.75 181.569 559.79C179.449 559.9 177.359 559.54 175.279 559.17C174.339 559 173.929 560.45 174.879 560.61Z"
        fill="#2264A5"
      />
      <path
        d="M176.609 556.25C179.859 557.2 183.159 557.84 186.319 556.27C187.179 555.84 186.429 554.55 185.559 554.98C182.799 556.35 179.819 555.63 176.999 554.81C176.069 554.54 175.679 555.98 176.599 556.25H176.609Z"
        fill="#2264A5"
      />
      <path
        d="M185.519 551.34C185.519 551.34 185.029 549.19 185.349 548.94C185.659 548.69 190.429 549.63 190.429 549.63C190.429 549.63 186.029 549.12 185.779 549.25C185.529 549.38 185.519 551.34 185.519 551.34Z"
        fill="url(#paint145_linear_1974_24988)"
      />
      <path
        d="M174.009 550.5C174.009 550.5 177.249 549.14 177.479 549.25C177.879 549.44 178.309 550.58 178.309 550.58C178.309 550.58 177.149 549.65 176.869 549.76C176.589 549.86 174.009 550.5 174.009 550.5Z"
        fill="url(#paint146_linear_1974_24988)"
      />
      <path
        d="M177.739 553.01C179.249 552.83 180.759 552.74 182.289 552.79C183.579 552.83 184.789 552.92 186.039 552.55C186.959 552.27 186.569 550.83 185.639 551.11C184.329 551.5 183.019 551.3 181.679 551.29C180.359 551.27 179.049 551.36 177.739 551.52C176.799 551.64 176.779 553.13 177.739 553.02V553.01Z"
        fill="#2264A5"
      />
      <path
        d="M168.669 578.87C168.669 578.87 169.399 581.46 171.389 581.97C172.779 582.33 173.219 582.36 179.429 582.23C185.639 582.1 190.029 582.24 191.659 581.72C193.289 581.19 194.549 580.08 194.699 578.65C194.699 578.65 193.869 580.79 190.629 581.17C188.049 581.47 174.029 581.78 171.899 581.41C170.669 581.2 169.139 579.89 168.669 578.87Z"
        fill="url(#paint147_linear_1974_24988)"
      />
      <path
        d="M168.599 572.34C168.599 572.34 168.619 576.05 171.359 576.36C174.099 576.68 190.099 577.11 191.729 575.37C193.359 573.63 194.689 572.22 194.689 569.17C194.689 569.17 195.339 575.37 190.869 576.69C187.659 577.64 173.629 577.6 171.239 577.23C167.809 576.69 168.599 572.34 168.599 572.34Z"
        fill="url(#paint148_linear_1974_24988)"
      />
      <path
        d="M194.949 322.83C194.949 322.83 196.629 320.38 201.099 344.81C205.569 369.23 210.879 418.43 216.739 437.55C222.609 456.66 227.589 464.92 241.879 499.49C245.309 507.78 254.639 536.66 254.639 536.66C254.639 536.66 266.449 538.12 270.919 531.4C270.919 531.4 265.169 488.26 261.339 475.1C254.639 452.07 246.529 438.25 244.299 426.92C242.069 415.59 244.789 347.87 243.109 317.43L194.949 322.84V322.83Z"
        fill="#5988AD"
      />
      <path
        d="M194.949 322.83C194.949 322.83 195.269 368.93 195.169 385.63C195.069 402.33 193.449 425.4 191.839 434.63C190.219 443.86 188.199 449.4 188.199 452.17C188.199 454.94 189.819 482.16 190.219 490.47C190.619 498.78 190.219 539.38 190.219 539.38C190.219 539.38 180.519 543.07 173.239 539.38C173.239 539.38 162.089 483.08 161.919 477.55C161.539 465.02 164.749 436.94 164.349 430.02C163.949 423.1 150.109 348.05 148.499 333.75C146.879 319.45 147.379 308.94 148.999 294.35L194.949 322.83Z"
        fill="#5988AD"
      />
      <path
        d="M245.949 171.98C244.019 167.96 234.719 165.87 233.579 165.76C229.599 165.38 213.509 163.68 211.849 158.36C209.779 151.74 210.879 142.3 210.879 142.3L187.399 142.02C190.199 146.68 190.089 151.64 189.979 156.66C189.849 162.18 173.139 166.07 167.399 166.7C164.259 167.05 153.189 170.7 151.659 176.1C149.509 183.69 149.679 186.22 150.319 196.19L250.319 186.61C249.709 181.06 249.639 179.65 245.959 171.98H245.949Z"
        fill="#C57D4E"
      />
      <path
        d="M224.85 164.95C225.71 164.6 225.62 163.85 226.49 163.34C218.29 161.58 214.08 160.1 213.38 159.63C212.63 159.12 211.919 156.72 211.649 153.9C211.529 152.68 211.349 149.6 211.309 148C210.969 148.41 189.789 147.64 188.969 146.44L186.509 146.46C186.509 146.46 187.239 154.25 186.079 159.83C185.849 160.97 178.979 162.58 174.479 163.51C174.799 163.76 175.959 164.54 176.219 164.68C180.079 165.06 183.389 165.51 184.969 165.24C186.899 164.91 190.129 163.44 192.479 162.36C205.179 156.54 209.139 154.62 209.139 154.62C209.739 160.03 214.99 165.33 214.77 165.28C217.959 166.06 221.4 165.05 224.85 164.96V164.95Z"
        fill="url(#paint149_linear_1974_24988)"
      />
      <path
        d="M203.83 172.25C203.83 172.25 202.51 168.61 198.06 170.03C198.06 170.03 202.63 170.84 203.83 172.25Z"
        fill="url(#paint150_linear_1974_24988)"
      />
      <path
        d="M227.529 164.41C221.639 164.75 208.509 165.03 207.039 165.4C205.259 165.84 203.989 169.15 203.989 169.15C207.959 166.06 211.919 166.94 216.979 166.35C220.229 165.97 224.729 165.19 227.539 164.67C227.539 164.58 227.539 164.5 227.529 164.41Z"
        fill="url(#paint151_linear_1974_24988)"
      />
      <path
        d="M197.699 169.11C197.699 169.11 196.469 166.58 194.279 165.84C192.089 165.11 175.369 164.07 172.359 164.36C172.359 164.36 193.449 166.48 197.689 169.11H197.699Z"
        fill="url(#paint152_linear_1974_24988)"
      />
      <path
        d="M186.579 156.24C186.579 156.24 186.699 146.53 185.899 143.12C185.899 143.12 210.989 139.52 212.119 139.62C211.659 142.42 211.429 150.5 211.429 150.5C211.429 150.5 201.169 160.87 186.589 156.24H186.579Z"
        fill="url(#paint153_linear_1974_24988)"
      />
      <path
        d="M154.81 170.18C154.81 170.18 149.54 172.84 147.19 178.31C144.84 183.78 145.31 202.61 145.92 208.29C146.53 213.97 144.7 247.75 144.43 251.41C144.16 255.07 138.92 266.39 138.5 274.17C138.36 276.72 135.93 323.84 135.93 323.84L145.33 322.9C145.33 322.9 158.48 265.92 159.11 260.57C159.74 255.22 160.94 247.12 161.55 243.94C161.99 241.64 165.82 211.86 165.82 211.86L154.82 170.18H154.81Z"
        fill="#C57D4E"
      />
      <path
        d="M145.199 306.03C145.349 313.8 145.589 322.54 145.589 322.54L149.169 306.43C147.869 306.36 146.559 305.78 145.199 306.03Z"
        fill="url(#paint154_linear_1974_24988)"
      />
      <path
        d="M230.14 264.18C230.14 264.18 231.63 255.97 233.14 247.65C235.4 235.25 239.31 214.14 240.86 203C244.61 189.92 246.56 169.14 246.56 169.14L233.11 165.28L225.08 162.83C224.28 168.4 208.63 171.52 201.51 171.68C186.57 172.01 175.89 162.83 175.89 162.83L154.72 169.88C161.32 195.08 163.67 215.02 163.67 217.05C163.67 219.08 163.79 223.08 162.15 240.75C161.9 243.46 160.81 252.07 161.16 260.37C184.72 270.55 204.26 266.73 230.13 264.19L230.14 264.18Z"
        fill="#27AE60"
      />
      <path
        d="M142.94 359.19C137.25 358.26 135.29 355.76 135.15 354.42C135.01 353.08 137.38 345.03 137.38 345.03C137.38 345.03 137.76 350.25 138.54 351.18C139.32 352.12 142.15 354.87 142.87 355.3C143.59 355.73 149.4 356.14 149.54 357.48C149.68 358.82 148.63 360.12 142.94 359.19Z"
        fill="url(#paint155_linear_1974_24988)"
      />
      <path
        d="M145.189 323.21C145.459 324.91 147.369 330.41 147.409 335.66C147.449 340.91 148.369 357.6 147.359 357.71C146.349 357.82 143.959 359.25 142.919 349.36C141.879 339.47 141.369 339.52 140.519 339.44C139.659 339.36 137.819 342.78 137.639 345.85C137.449 348.92 137.159 354.21 137.589 355.01C138.009 355.81 145.629 358.91 146.729 359.64C147.819 360.37 151.189 362.38 149.719 363.9C148.569 365.1 135.019 359.63 131.779 357.69C130.389 356.86 130.309 346.96 130.249 343.24C130.199 339.52 135.099 324.93 135.949 320.09C136.799 315.25 138.069 311.22 138.069 311.22L145.269 308.62C145.099 310.91 144.759 320.39 145.199 323.21H145.189Z"
        fill="#C57D4E"
      />
      <path
        d="M142.819 348.42C142.819 348.42 142.549 339.07 140.569 339.11C138.589 339.15 137.699 344.99 137.699 344.99C137.699 344.99 141.329 339.87 142.809 348.42H142.819Z"
        fill="url(#paint156_linear_1974_24988)"
      />
      <path
        d="M146.759 353.64C146.909 352.56 147.809 352.62 147.809 352.62C147.809 352.62 148.259 355.54 147.649 357.86C146.679 358.06 146.429 355.99 146.769 353.64H146.759Z"
        fill="#D59C74"
      />
      <path
        d="M144.52 362.88C144.52 362.88 144.73 362.01 145.81 362.18C148.15 362.56 150.06 363.4 149.58 364.27C147.18 364.17 144.52 362.87 144.52 362.87V362.88Z"
        fill="#D59C74"
      />
      <path
        d="M137.739 319.34C136.829 320.17 129.719 341.67 133.179 340.97C135.509 340.49 143.489 314.05 137.739 319.34Z"
        fill="url(#paint157_linear_1974_24988)"
      />
      <path
        d="M145.249 308.62L145.589 322.54C146.119 324.64 147.569 329.47 147.419 336.78C147.419 336.78 143.949 324.15 142.989 321.08L145.239 308.62H145.249Z"
        fill="url(#paint158_linear_1974_24988)"
      />
      <path
        d="M171.16 214.94C177.96 216.46 227.59 217.27 230.64 215.75C233.69 214.23 231.08 179.53 231.08 179.53H163.68C163.68 179.53 167.07 214.03 171.16 214.94Z"
        fill="#2CB563"
      />
      <path
        d="M144.329 195.07L145.919 208.3C145.919 208.3 154.009 214.47 163.679 217.06V214.81L144.329 195.07Z"
        fill="url(#paint159_linear_1974_24988)"
      />
      <path
        d="M159.909 209.38C158.969 226.22 157.159 255.61 156.269 257.5C154.749 260.72 146.219 275.83 145.139 293.22C145.029 295.02 145.089 300.11 145.199 306.04C147.069 306.27 147.819 306.76 149.119 306.83L159.109 261.71C159.109 261.71 163.029 233.16 163.099 232.66C163.169 232.16 164.109 213.11 164.109 213.11L163.809 212.67C162.899 211.43 161.609 208.72 159.909 209.38Z"
        fill="url(#paint160_linear_1974_24988)"
      />
      <path
        d="M161.23 251.93C161.23 251.93 160.35 259.23 161.17 260.37C161.17 260.37 176.28 265.8 195.94 266C212.35 266.17 230.78 263.74 230.78 263.74C230.78 263.74 230.76 261.9 231.22 253.24C231.22 253.24 230.78 262.71 220.07 263.15C203.58 263.84 200.45 263.55 186.54 262.65C186.06 262.62 163.43 261.64 161.23 251.92V251.93Z"
        fill="#2CB563"
      />
      <path
        d="M243.059 316.28C241.509 300.29 237.429 290.55 232.349 275.17L230.019 263.63C230.019 263.63 190.949 269.84 161.169 260.37C161.169 260.37 145.069 287.95 145.359 313.01C145.499 325.31 154.769 369.79 159.149 390.77C172.309 391.06 180.279 392.93 192.209 398.49C192.169 377.75 194.429 330.7 194.779 322.91C198.469 309.15 203.009 361.22 206.969 381.85C220.989 377.75 227.769 371.06 242.299 368.97C242.309 361.02 243.479 320.67 243.059 316.28Z"
        fill="#5988AD"
      />
      <path
        d="M193.849 269.27C194.809 270.24 194.809 271.8 193.849 272.77C192.889 273.74 191.329 273.74 190.369 272.77C189.409 271.8 189.409 270.24 190.369 269.27C191.329 268.3 192.889 268.3 193.849 269.27Z"
        fill="url(#paint161_linear_1974_24988)"
      />
      <path
        d="M193.8 270.72C193.8 271.87 192.87 272.81 191.72 272.81C190.57 272.81 189.64 271.88 189.64 270.72C189.64 269.56 190.57 268.63 191.72 268.63C192.87 268.63 193.8 269.56 193.8 270.72Z"
        fill="url(#paint162_linear_1974_24988)"
      />
      <path
        d="M189.999 270.72C189.999 270.72 190.029 272.38 191.509 272.48C192.989 272.58 194.109 270.89 193.009 269.53C193.009 269.53 193.309 271.36 192.099 271.71C191.039 272.02 190.209 271.48 189.989 270.72H189.999Z"
        fill="#A6BFD4"
      />
      <path
        d="M194.539 405.23C193.719 400.09 176.699 315.23 170.879 307.94C170.879 307.94 179.819 316.28 205.419 314.52C205.419 314.52 205.359 350.31 206.979 383.44C206.979 383.44 198.339 320.6 194.949 322.84C195.549 334.56 195.549 390.01 194.539 405.24V405.23Z"
        fill="url(#paint163_linear_1974_24988)"
      />
      <path
        d="M195.18 381.27C195.18 381.27 195.65 334.39 194.94 322.83C197.92 321.8 204.84 368.8 204.84 368.8C204.84 368.8 201.22 329.43 200.88 322.7C200.8 321.12 201.34 319.61 200.99 319.61C200.64 319.61 191.35 319.31 184.01 316.28C184.01 316.28 188.59 322.25 189.17 323.41C189.75 324.57 195.17 381.27 195.17 381.27H195.18Z"
        fill="url(#paint164_linear_1974_24988)"
      />
      <path
        d="M214.629 275.65C214.629 275.65 214.119 284.21 219.799 287.84C225.479 291.47 237.729 291.23 237.729 291.23L232.349 275.16L214.629 275.64V275.65Z"
        fill="url(#paint165_linear_1974_24988)"
      />
      <path
        d="M156.909 268.67C162.289 271.94 171.229 273.36 171.229 273.36C171.229 273.36 169.839 284.31 162.089 285.31C154.349 286.31 150.339 285.03 150.339 285.03C150.339 285.03 153.739 274.82 156.899 268.67H156.909Z"
        fill="url(#paint166_linear_1974_24988)"
      />
      <path
        d="M203.22 313.98C203.22 313.98 229.26 308.4 241.28 312.8L203.22 313.98Z"
        fill="url(#paint167_linear_1974_24988)"
      />
      <path
        d="M196.319 275.72L214.629 275.65C214.629 275.65 214.449 280.27 215.139 283.25L195.779 282.88L196.329 275.72H196.319Z"
        fill="url(#paint168_linear_1974_24988)"
      />
      <path
        d="M170.839 273.43C170.839 273.43 194.689 276.78 195.379 277.01C196.079 277.24 196.109 282.48 194.399 282.44C192.499 282.4 170.689 279.94 169.369 280.12C169.369 280.12 171.309 276.8 170.839 273.43Z"
        fill="url(#paint169_linear_1974_24988)"
      />
      <path
        d="M195.939 265.53C195.939 265.53 196.689 271.51 196.589 272.15C196.489 272.8 196.389 276.3 195.609 276.42L194.829 276.54C194.829 276.54 194.149 284.63 194.149 292.9C194.149 301.17 195.939 308.81 196.099 310.36C196.209 307.35 195.809 293.88 195.909 293.06C196.009 292.24 196.109 277.71 196.989 277.12C197.869 276.53 197.769 274.79 197.769 274.79L197.929 265.6L195.949 265.53H195.939Z"
        fill="url(#paint170_linear_1974_24988)"
      />
      <path
        d="M157.949 269.5C157.949 269.5 169.259 273.07 171.239 273.36C173.209 273.66 181.349 274.44 190.369 276.2C190.369 276.2 173.209 275.5 171.239 275.17C169.269 274.83 157.949 269.5 157.949 269.5Z"
        fill="url(#paint171_linear_1974_24988)"
      />
      <path
        d="M195.85 275.72C195.85 275.72 213.95 275.03 214.27 275.16C214.59 275.29 228.3 274.1 232.36 275.16C232.36 275.16 216.85 276.63 214.27 276.72C211.69 276.81 195.85 275.72 195.85 275.72Z"
        fill="url(#paint172_linear_1974_24988)"
      />
      <path
        d="M214.579 276.31C214.579 276.31 214.929 281.85 217.369 284.85C219.799 287.85 224.829 291.02 237.739 291.23C237.739 291.23 226.869 294.32 219.199 289.83C212.769 286.06 214.589 276.31 214.589 276.31H214.579Z"
        fill="url(#paint173_linear_1974_24988)"
      />
      <path
        d="M171.06 273.84C171.06 273.84 170.3 278.82 167.87 281.82C165.44 284.82 157.97 285.76 150.35 285.03C150.35 285.03 159.36 289.29 166.12 285.49C172.62 281.84 171.06 273.83 171.06 273.83V273.84Z"
        fill="url(#paint174_linear_1974_24988)"
      />
      <path
        d="M187.599 265.14C187.599 265.14 195.959 265.35 196.889 265.62C197.819 265.89 197.399 272.3 197.349 273.32C197.309 274.34 197.349 277.81 195.849 277.56C194.349 277.31 190.349 276.2 190.349 276.2C190.349 276.2 194.359 276.35 195.299 275.74C196.239 275.13 196.359 267.03 195.779 267.05C195.199 267.07 187.589 265.14 187.589 265.14H187.599Z"
        fill="url(#paint175_linear_1974_24988)"
      />
      <path
        d="M194.74 277.57C194.74 277.57 194.29 287.73 194.41 289.06C194.53 290.39 196.15 311.11 196.15 311.11C196.15 311.11 194.85 302.91 194.4 301.83C193.95 300.74 193.08 287.96 192.99 286.86C192.9 285.76 194.74 277.58 194.74 277.58V277.57Z"
        fill="url(#paint176_linear_1974_24988)"
      />
      <path
        d="M204.729 265.59C204.729 265.59 205.77 268.2 205.77 269.01C205.77 269.82 206.699 280.87 206.699 281.28C206.699 281.69 207.279 282.88 207.279 282.88L208.089 267.76L206.809 265.58L204.729 265.6V265.59Z"
        fill="url(#paint177_linear_1974_24988)"
      />
      <path
        d="M209.97 275.17H212.88L211.53 265.36L210.49 265.41L209.97 275.17Z"
        fill="url(#paint178_linear_1974_24988)"
      />
      <path
        d="M173.63 263.4L174.52 263.55L174.5 273.95L170.93 273.37L173.63 263.4Z"
        fill="url(#paint179_linear_1974_24988)"
      />
      <path
        d="M178.279 264.14L179.809 264.35L177.52 272.66L177.49 277.57L176.24 280.12L174.479 278.03L178.279 264.14Z"
        fill="url(#paint180_linear_1974_24988)"
      />
      <path
        d="M178.489 264.17C178.489 264.17 177.109 267.14 177.019 268C176.929 268.86 175.459 274.17 176.239 280.11L172.149 279.89C172.149 279.89 172.059 274.01 172.669 271.56C173.279 269.12 174.489 263.54 174.489 263.54L178.489 264.16V264.17Z"
        fill="#5988AD"
      />
      <path
        d="M178.469 264.18C178.469 264.18 176.139 271.9 176.179 273.36C176.219 274.82 176.249 280.11 176.249 280.11L172.159 279.89L174.479 278.03C174.479 278.03 175.369 271.86 175.329 271.31C175.289 270.76 178.469 264.19 178.469 264.19V264.18Z"
        fill="url(#paint181_linear_1974_24988)"
      />
      <path
        d="M206.149 265.58L210.489 265.42C210.489 265.42 211.529 270.41 211.619 273.72C211.729 277.61 211.979 282.24 211.979 282.88C211.699 282.75 207.289 282.88 207.289 282.88C207.289 282.88 207.809 273.93 207.639 271.4C207.469 268.87 206.159 265.58 206.159 265.58H206.149Z"
        fill="#5988AD"
      />
      <path
        d="M206.149 265.58C206.149 265.58 207.709 272.76 207.479 276.31C207.219 280.22 207.279 282.88 207.279 282.88H211.969C211.969 282.88 208.199 282.75 208.319 281.35C208.439 279.95 209.739 269.95 206.149 265.58Z"
        fill="url(#paint182_linear_1974_24988)"
      />
      <path
        d="M188.01 277C188.01 277 188.27 297.3 188.18 298.84C188.08 300.38 187.79 308.69 195.12 310.48C195.12 310.48 187.49 310.86 186.91 304.05C186.32 297.24 188.02 277 188.02 277H188.01Z"
        fill="url(#paint183_linear_1974_24988)"
      />
      <path
        d="M241.719 317.42C241.719 317.42 234.169 313.43 216.439 316.95L241.719 317.42Z"
        fill="url(#paint184_linear_1974_24988)"
      />
      <path
        d="M175.899 162.83C175.899 162.83 185.42 170.14 199.13 170.38C211.46 170.59 220.149 167.9 225.079 162.83L228.719 163.95C228.719 163.95 221.399 174.25 199.449 173.68C180.609 173.19 172.229 164.05 172.229 164.05L175.899 162.83Z"
        fill="url(#paint185_linear_1974_24988)"
      />
      <path
        d="M169.749 423.27C173.009 436.74 186.969 430.67 186.619 418.78C186.489 414.27 173.429 318.35 172.719 315.49C169.639 303.14 149.359 309.42 150.379 316.56C151.039 321.18 168.339 417.44 169.749 423.26V423.27Z"
        fill="url(#paint186_linear_1974_24988)"
      />
      <path
        d="M189.51 437.14C189.51 437.14 187.19 444.53 169.6 446.66C169.6 446.66 193.88 445.35 189.51 437.14Z"
        fill="url(#paint187_linear_1974_24988)"
      />
      <path
        d="M172.77 449.49C172.77 449.49 180.92 449 186.6 443.84C186.6 443.84 189.89 449.33 172.77 449.49Z"
        fill="url(#paint188_linear_1974_24988)"
      />
      <path
        d="M209.7 329.09C210.51 318.13 233.87 316.5 237.76 325.07C241.65 333.64 238.49 412.57 235.87 424.15C232.04 441.05 219.15 435.94 218.41 428.12C216.43 407.09 207.99 352.26 209.7 329.08V329.09Z"
        fill="url(#paint189_linear_1974_24988)"
      />
      <path
        d="M138.799 271.49C138.499 275.13 136.989 303.56 136.319 316.28C136.459 316.23 142.329 260.95 144.329 252.39C144.329 252.39 139.259 265.85 138.799 271.49Z"
        fill="url(#paint190_linear_1974_24988)"
      />
      <path
        d="M229.359 446.63C229.359 446.63 240.919 443.26 245.669 437.25C245.669 437.25 246.729 444.36 229.359 446.63Z"
        fill="url(#paint191_linear_1974_24988)"
      />
      <path
        d="M243.18 431.89C243.18 431.89 241.65 437.05 232.56 439.51C232.56 439.51 245.13 438.2 243.18 431.89Z"
        fill="url(#paint192_linear_1974_24988)"
      />
      <path
        d="M229.969 85.1001C231.269 85.5201 232.749 85.4501 233.959 84.7701C235.129 84.1101 236.339 83.7101 236.359 82.2701C236.399 79.6501 234.149 79.0501 232.849 78.9501C232.249 78.9101 231.609 79.0401 231.139 79.4401C231.059 79.0801 230.959 78.6801 230.849 78.2401C232.049 77.4401 232.919 76.1001 233.429 74.7501C233.759 73.8701 234.419 73.4501 234.389 72.5001C234.359 71.5901 233.629 70.0401 232.879 69.4701C232.279 69.0201 231.469 68.9001 230.749 68.9401C230.419 68.9601 230.089 69.0101 229.769 69.0901C229.839 69.0401 229.919 68.9801 229.989 68.9301C230.639 68.4101 231.509 66.4901 230.889 65.9501C230.379 65.5101 230.239 65.2401 229.319 64.8201C229.639 65.0701 230.069 65.4401 229.979 66.2601C229.939 66.6501 229.539 67.3201 228.869 67.6001C228.179 67.9001 227.269 67.9101 226.519 67.8001C226.179 67.7501 225.909 67.6601 225.909 67.6601C226.609 66.2001 226.629 64.7301 226.039 63.6801C225.729 63.1201 224.899 62.2501 224.359 62.3201C224.509 62.0901 224.109 60.8101 224.179 60.5401C224.569 58.9001 223.969 57.1301 222.869 55.9201C221.699 54.6301 220.039 53.9501 218.329 54.0501C217.399 54.1101 216.499 54.3801 215.679 54.8301C215.939 54.4301 216.129 53.9701 216.229 53.4901C216.389 52.6901 216.739 52.3901 216.559 51.6001C216.389 50.8101 215.779 49.3201 215.089 48.9201C212.079 47.1501 210.649 50.3801 210.219 51.1201C209.619 50.9301 208.609 50.3201 207.999 50.3401C208.149 50.2401 208.289 50.1401 208.419 50.0201C208.829 49.6801 209.169 49.2901 209.489 48.8601C210.609 47.3201 211.159 46.0901 210.539 44.3301C210.479 44.1601 210.399 43.9601 210.299 43.7501C210.199 43.5401 210.239 43.9501 210.109 43.7201C209.709 42.8301 208.919 41.8401 208.099 41.4801C206.739 40.8001 204.859 40.9901 203.699 42.0001C203.509 42.1701 203.329 42.3601 203.189 42.5801C202.369 43.8401 202.369 45.0201 203.099 46.2901C203.099 45.4701 203.189 44.5601 203.709 43.8801C203.859 43.6501 204.029 43.4501 204.209 43.2801C204.959 42.5901 205.999 42.3801 207.099 43.2001C208.639 44.2901 208.549 46.6501 207.279 48.0201C206.279 49.0201 204.919 49.2901 203.649 49.7501C203.789 49.4601 203.859 49.1701 203.889 48.8901C203.909 48.6101 203.889 48.3301 203.809 48.0601C203.189 45.6601 200.379 45.9301 198.739 44.5701C198.099 44.0201 197.649 42.5701 198.559 42.2101C199.559 41.8501 200.469 43.3901 200.379 44.4801C201.379 43.2101 200.159 41.5601 200.059 41.3901C199.639 40.6901 198.569 40.4401 197.929 40.5701C197.009 40.7701 196.429 41.3901 196.159 42.1701C196.069 42.4301 196.009 42.7101 195.989 43.0001C195.479 46.5701 198.939 46.8401 201.569 48.3901C202.209 48.7501 201.569 49.9301 201.209 50.6801C201.089 50.9301 200.979 51.1901 200.869 51.4401C200.849 51.4801 200.839 51.5101 200.819 51.5501C200.169 51.7601 200.099 51.7001 199.619 52.0501C199.599 51.7601 199.579 51.4801 199.539 51.2301C199.389 48.5801 196.759 45.9401 194.039 47.2301C193.829 47.3401 193.629 47.4801 193.449 47.6401C192.909 48.1101 192.529 48.7801 192.429 49.5501C192.319 50.3601 192.609 51.9901 193.219 52.5301C193.739 52.9901 194.889 53.3801 195.369 52.7701C194.829 52.9201 193.739 52.2601 193.829 51.0601C193.869 50.4801 193.829 49.8901 194.229 49.4801C194.399 49.3001 194.609 49.1801 194.829 49.1201C195.049 49.0601 195.289 49.0501 195.519 49.1101C196.029 49.1101 196.299 49.5701 196.459 49.9401C196.579 50.1701 196.679 50.4201 196.749 50.6701C196.819 50.9201 196.879 51.1801 196.919 51.4401C197.009 51.9801 197.049 52.5301 196.989 53.0801C196.939 53.5801 196.809 54.0801 196.539 54.5001C196.289 54.8801 195.939 55.1701 195.559 55.3901C194.349 55.3901 192.559 55.1801 190.789 55.1501C190.879 54.5401 191.109 53.9301 191.569 53.5201C192.159 52.9901 193.139 53.4601 193.859 53.7301C193.479 53.1001 192.869 52.3201 191.869 52.2101C191.119 52.1301 190.399 52.5101 189.839 53.0301C189.389 53.4501 189.059 53.9901 188.829 54.5701C188.749 54.7801 188.679 55.0001 188.629 55.2301C188.319 55.2701 188.449 55.2801 188.159 55.3501C188.029 55.3801 187.899 55.4101 187.769 55.4501C187.799 55.3501 187.829 55.2401 187.849 55.1401C188.029 54.2201 187.369 53.2601 186.839 52.5001C186.329 51.7601 185.539 51.2601 184.669 51.1001C182.879 50.7701 181.059 51.8001 180.409 53.5501C180.059 54.4801 180.179 55.7601 180.089 55.0201C179.969 54.0401 179.739 53.0801 178.929 52.4601C178.159 51.8701 177.109 51.6801 176.169 51.6201C175.659 51.5901 175.149 51.6201 174.649 51.6901C174.169 51.7601 173.669 51.8901 173.269 52.1901C172.469 52.7601 172.369 54.7401 172.879 55.5701C173.359 56.3501 174.279 56.6101 175.129 56.6601C174.929 56.5601 173.499 55.8701 173.649 54.4801C173.689 54.1301 173.489 53.6201 173.859 53.4501C174.199 53.2901 174.659 53.3501 175.019 53.3801C175.469 53.4201 175.919 53.5101 176.359 53.6401C176.739 53.7501 177.159 53.8801 177.479 54.1101C177.769 54.3201 177.769 54.7401 177.799 55.0701C177.819 55.2901 177.839 55.5201 177.839 55.7401C177.839 55.8801 177.839 56.0701 177.769 56.2001C177.719 56.3001 177.549 56.3401 177.449 56.3801C177.239 56.4701 177.019 56.5601 176.819 56.6601C175.499 57.3501 174.459 58.5901 174.009 60.0501C173.709 60.2001 173.399 60.3501 173.079 60.5001C172.959 60.4701 172.839 60.4401 172.719 60.4201C171.879 60.2601 170.979 60.2401 170.129 60.3501C168.509 60.5701 166.949 61.3801 166.149 62.9001C165.789 63.5901 165.609 64.3601 165.609 65.1401C165.609 65.7501 165.969 66.6501 166.189 67.1601C166.349 65.9001 166.569 64.3501 167.529 63.5201C167.979 63.1301 168.499 62.9001 169.039 62.7601C167.599 63.9201 166.489 65.5201 166.339 68.0601C165.589 68.0501 164.829 68.2501 164.149 68.5801C162.849 69.2201 161.489 70.3701 161.619 72.0001C161.679 72.7201 161.959 73.4401 162.339 74.0401C162.619 74.4901 162.969 74.9101 163.399 75.2301C163.109 74.4801 162.959 73.6701 162.959 72.8601C162.959 72.5001 162.959 72.1101 163.139 71.7801C163.289 71.4901 163.559 71.2901 163.829 71.1301C164.379 70.8001 165.019 70.5501 165.659 70.4501C165.959 70.4001 166.239 70.4301 166.539 70.4501C166.649 70.4601 166.619 70.4901 166.599 70.6001C166.389 71.8201 166.869 73.0401 167.789 73.8301C167.189 73.8101 166.579 73.8501 165.989 73.9801C165.009 74.2001 163.909 74.7501 163.569 75.8001C163.309 76.6401 163.819 78.1701 164.609 78.6601C164.309 78.8501 164.019 79.0701 163.749 79.3201C162.369 80.5801 161.349 82.6201 161.809 84.5401C162.039 85.4901 162.579 86.3301 163.209 87.0401C163.759 87.6601 164.419 88.1801 165.169 88.5101C165.199 88.6401 165.239 88.7701 165.279 88.9001C164.859 89.1501 164.459 89.4601 164.149 89.8601C163.699 90.4301 163.449 91.8401 163.459 92.5801C163.459 93.2901 163.909 94.1301 164.279 94.7201C164.659 95.3301 165.309 95.5701 165.999 95.5901C166.599 95.6101 167.369 95.4701 167.709 94.8901C168.049 94.3101 168.029 93.7201 167.629 93.2701C166.939 95.4701 164.749 92.2801 165.639 91.5901C165.839 91.4401 165.979 91.2201 166.189 91.0901C166.219 91.0701 166.259 91.0501 166.289 91.0301C167.079 92.1201 168.319 92.9701 170.289 93.1301C174.929 93.5001 205.179 97.9801 218.509 98.2901C219.469 96.9001 230.749 95.7101 232.069 90.7501C232.469 89.2501 232.539 86.7001 229.959 85.1001H229.969ZM231.449 81.5601C231.449 81.2001 231.439 81.2401 231.349 80.7701C231.409 80.7501 231.459 80.7301 231.519 80.7201C232.019 80.6001 232.499 80.3801 232.899 80.6601C233.109 80.8001 233.309 80.9601 233.479 81.1501C233.589 81.2701 233.729 81.4301 233.699 81.6001C233.649 81.9401 233.379 82.2601 233.139 82.4801C232.569 82.9801 231.769 83.2101 231.009 83.2501C231.549 82.4701 231.409 82.6401 231.439 81.5701L231.449 81.5601ZM228.909 71.1301C229.509 70.9401 230.149 70.8601 230.769 70.9601C230.979 70.9901 231.199 71.0501 231.399 71.1401C231.439 71.1601 231.499 71.1701 231.519 71.2101C231.549 71.2601 231.569 71.3901 231.579 71.4501C231.709 72.0601 231.579 72.7501 231.429 73.3501C231.279 73.9701 231.059 74.5701 230.779 75.1401C230.639 75.4301 230.479 75.7201 230.289 75.9901C230.149 75.3701 230.009 74.6901 229.859 73.9301C229.589 72.5301 229.259 71.7201 228.799 71.1701C228.829 71.1601 228.869 71.1501 228.899 71.1401L228.909 71.1301ZM167.739 77.7401C166.719 77.7301 165.709 78.0201 164.819 78.5401C164.529 77.9501 164.289 76.8001 164.639 76.4301C165.019 76.0201 165.739 76.0201 166.249 76.0201C167.409 76.0201 168.519 76.3501 169.659 76.4901C169.109 76.8701 168.439 77.2801 167.749 77.7301L167.739 77.7401ZM184.169 57.4601C184.029 57.3801 183.899 57.2901 183.769 57.2001C183.289 56.8601 182.869 56.4401 182.619 55.8901C182.369 55.3201 182.359 54.6401 182.609 54.0701C183.119 52.8801 184.679 52.4901 185.739 53.1201C186.599 53.6301 187.489 54.5201 187.609 55.5001C186.219 55.9201 184.809 56.7501 184.169 57.4601ZM214.029 52.4201C213.999 52.9701 213.869 53.4501 213.509 53.8601C213.469 53.9001 213.439 53.9401 213.399 53.9701C212.349 51.9401 211.629 51.7601 210.349 51.3701C210.529 51.1801 212.589 49.5401 213.119 49.7501C213.529 49.9201 213.749 50.3101 213.879 50.7301C214.039 51.2701 214.069 51.8601 214.039 52.4201H214.029ZM216.069 57.8401C216.349 56.9001 217.489 56.2601 218.489 56.3201C219.669 56.3901 220.749 56.9401 221.539 57.8401C221.899 58.2601 222.999 59.3801 223.179 59.9101C223.269 60.1801 223.079 61.4201 223.049 61.5601C222.939 61.1501 222.259 59.4601 221.919 59.0601C220.099 56.9601 218.339 58.4201 216.069 57.8301V57.8401ZM222.999 67.9401C221.769 66.4701 222.669 65.0601 222.879 63.2101C222.939 63.2401 222.999 63.2801 223.059 63.3201C223.379 63.5601 223.459 63.9901 223.469 64.3701C223.489 65.2601 223.089 66.0501 222.989 66.9101C222.949 67.2501 222.959 67.6001 223.009 67.9401H222.999Z"
        fill="url(#paint193_linear_1974_24988)"
      />
      <path
        d="M230.459 86.0401C231.759 86.4601 233.239 86.3901 234.449 85.7101C235.619 85.0501 236.579 83.6901 236.359 82.2701C236.129 80.8401 234.639 79.9901 233.339 79.8901C232.739 79.8501 232.099 79.9801 231.629 80.3801C231.549 80.0201 231.449 79.6201 231.339 79.1801C232.539 78.3801 233.409 77.0401 233.919 75.6901C234.249 74.8101 234.449 73.8501 234.419 72.9001C234.389 71.9901 234.119 70.9801 233.369 70.4101C232.769 69.9601 231.959 69.8401 231.239 69.8801C230.909 69.9001 230.579 69.9501 230.259 70.0301C230.329 69.9801 230.409 69.9201 230.479 69.8701C231.129 69.3501 231.699 68.6301 231.869 67.7901C232.039 66.9601 231.759 66.1501 231.129 65.6001C230.619 65.1601 229.969 64.9301 229.319 64.8201C229.909 65.2601 230.699 65.9201 230.739 66.7501C230.769 67.5901 229.909 68.1601 229.249 68.4401C228.559 68.7401 227.769 68.8501 227.019 68.7401C226.679 68.6901 226.359 68.6001 226.049 68.4601C225.819 68.3601 225.679 68.2301 225.619 67.9701C225.469 67.3101 225.759 66.6401 225.829 66.0001C225.919 65.2101 225.869 64.3801 225.569 63.6401C225.329 63.0501 224.909 62.5501 224.369 62.2501C224.519 62.0201 224.619 61.7601 224.689 61.4801C225.079 59.8401 224.479 58.0701 223.379 56.8601C222.209 55.5701 220.549 54.8901 218.839 54.9901C217.909 55.0501 217.009 55.3201 216.189 55.7701C216.449 55.3701 216.639 54.9101 216.739 54.4301C216.899 53.6301 216.849 52.7801 216.679 51.9901C216.509 51.2001 216.169 50.4201 215.599 49.8601C215.039 49.3001 214.279 49.0001 213.499 49.0701C212.779 49.1401 212.129 49.5001 211.569 49.9501C211.269 50.2001 210.979 50.4801 210.719 50.7801C210.539 50.9801 210.349 51.2201 210.329 51.5101C209.729 51.3201 209.119 51.2601 208.499 51.2801C208.649 51.1801 208.789 51.0801 208.919 50.9601C209.329 50.6201 209.669 50.2301 209.989 49.8001C211.109 48.2601 211.169 46.0901 210.549 44.3301C210.459 44.0701 210.349 43.8201 210.219 43.5801C209.649 42.4801 208.469 41.5801 207.199 41.6701C206.109 41.8101 204.879 42.0601 204.029 42.8601C203.819 43.0601 203.629 43.2801 203.469 43.5201C203.019 44.2101 202.749 45.4801 203.109 46.3001C203.199 45.5701 203.469 45.1201 204.009 44.6901C204.259 44.5001 204.539 44.3501 204.839 44.2301C205.749 43.8901 206.839 43.8901 207.659 44.2101C208.929 44.7601 208.839 46.5701 208.479 47.7501C208.029 48.8401 207.029 49.6601 205.939 50.0301C205.739 50.1101 205.539 50.1901 205.339 50.2601C204.939 50.4101 204.529 50.5401 204.129 50.7001C204.169 50.6001 204.199 50.5101 204.229 50.4101C204.289 50.2001 204.339 49.9801 204.359 49.7701C204.429 49.1601 204.279 48.6401 203.999 48.1901C203.859 47.9701 203.679 47.7601 203.479 47.5701C202.409 46.5601 200.949 46.2901 199.679 45.6501C199.319 45.4701 198.949 45.2001 198.769 44.9201C198.409 44.2801 198.219 43.2801 198.949 43.1001C200.129 42.7401 200.309 44.2801 200.219 45.1901C200.949 44.0101 201.129 42.2801 199.859 41.2801C198.589 40.3701 197.039 41.1901 196.499 42.4601C194.959 46.3701 199.859 47.5501 202.319 49.4601C202.409 49.5501 202.319 49.8201 202.299 50.1301C202.239 50.3801 202.139 50.6201 202.059 50.8301C201.849 51.3501 201.609 51.8501 201.379 52.3601L201.329 52.4701C200.679 52.6801 200.129 52.9701 199.649 53.3201C199.709 52.6701 199.679 52.0001 199.559 51.3701C199.519 51.1601 199.469 50.9501 199.419 50.7501C199.049 48.9101 197.139 47.1901 195.229 47.8801C194.989 47.9401 194.769 48.0301 194.559 48.1401C193.709 48.5901 193.079 49.4301 192.949 50.4601C192.839 51.2701 193.079 52.1601 193.689 52.7001C194.209 53.1601 195.119 53.3201 195.599 52.7101C195.059 52.8601 194.509 52.5101 194.349 51.9701C194.179 51.4201 194.349 50.8001 194.749 50.3901C195.089 50.0401 195.579 49.9101 196.039 50.0201C196.469 50.1301 196.779 50.4601 196.979 50.8501C197.219 51.3101 197.349 51.8401 197.439 52.3601C197.529 52.9001 197.569 53.4501 197.509 53.9901C197.459 54.4901 197.329 54.9901 197.059 55.4101C196.809 55.7901 196.459 56.0801 196.079 56.3001C194.869 56.3001 193.079 56.0901 191.309 56.0601C191.399 55.4501 191.629 54.8401 192.089 54.4301C192.679 53.9001 193.469 53.8101 194.189 54.0701C193.809 53.4401 193.079 53.1301 192.389 53.1101C191.629 53.0901 190.919 53.4101 190.359 53.9301C189.909 54.3501 189.579 54.8901 189.349 55.4701C189.269 55.6801 189.199 55.9001 189.149 56.1301C188.839 56.1701 188.529 56.2101 188.239 56.2701C188.109 56.3001 187.979 56.3301 187.849 56.3701C187.879 56.2701 187.909 56.1601 187.929 56.0601C188.109 55.1401 187.879 54.1601 187.359 53.4001C186.849 52.6601 186.059 52.1601 185.189 52.0001C183.399 51.6701 181.579 52.7001 180.929 54.4501C180.579 55.3801 180.549 56.4301 180.879 57.3701C181.019 57.7601 181.199 58.1301 181.429 58.4601C181.099 58.3201 180.749 58.2001 180.389 58.1101C180.689 57.4401 180.699 56.6501 180.609 55.9201C180.489 54.9401 180.259 53.9801 179.449 53.3601C178.679 52.7701 177.629 52.5801 176.689 52.5201C176.179 52.4901 175.669 52.5201 175.169 52.5901C174.689 52.6601 174.189 52.7901 173.789 53.0901C172.989 53.6601 172.829 54.7501 173.349 55.5801C173.829 56.3601 174.749 56.6201 175.599 56.6701C175.399 56.5701 175.209 56.4601 175.019 56.3301C174.679 56.1001 174.319 55.7901 174.169 55.3901C174.039 55.0601 174.009 54.5301 174.379 54.3601C174.719 54.2001 175.179 54.2601 175.539 54.2901C175.989 54.3301 176.439 54.4201 176.879 54.5501C177.259 54.6601 177.679 54.7901 177.999 55.0201C178.289 55.2301 178.289 55.6501 178.319 55.9801C178.339 56.2001 178.359 56.4301 178.359 56.6501C178.359 56.7901 178.359 56.9801 178.289 57.1101C178.239 57.2101 178.069 57.2501 177.969 57.2901C177.759 57.3801 177.539 57.4701 177.339 57.5701C176.019 58.2601 174.979 59.5001 174.529 60.9601C174.229 61.1101 173.919 61.2601 173.599 61.4101C173.479 61.3801 173.359 61.3501 173.239 61.3301C172.399 61.1701 171.499 61.1501 170.649 61.2601C169.029 61.4801 167.469 62.2901 166.669 63.8101C166.309 64.5001 166.139 65.2701 166.129 66.0501C166.129 66.6501 166.199 67.3001 166.439 67.8601C166.599 66.6101 167.099 65.2701 168.059 64.4301C168.509 64.0401 169.029 63.8101 169.569 63.6701C168.129 64.8301 167.019 66.4301 166.869 68.9701C166.119 68.9601 165.359 69.1601 164.679 69.4901C163.379 70.1301 162.019 71.2801 162.149 72.9101C162.209 73.6301 162.489 74.3501 162.869 74.9501C163.149 75.4001 163.499 75.8201 163.929 76.1401C163.639 75.3901 163.489 74.5801 163.489 73.7701C163.489 73.4101 163.489 73.0201 163.669 72.6901C163.819 72.4001 164.089 72.2001 164.359 72.0401C164.909 71.7101 165.549 71.4601 166.189 71.3601C166.489 71.3101 166.769 71.3401 167.069 71.3601C167.179 71.3701 167.149 71.4001 167.129 71.5101C166.919 72.7301 167.399 73.9501 168.319 74.7401C167.719 74.7201 167.109 74.7601 166.519 74.8901C165.539 75.1101 164.439 75.6601 164.099 76.7101C163.799 77.6801 164.389 78.7401 165.389 78.8701C165.049 78.4901 164.759 77.7701 165.179 77.3301C165.559 76.9201 166.279 76.9201 166.789 76.9201C167.949 76.9201 169.059 77.2501 170.199 77.3901C169.649 77.7701 168.979 78.1801 168.289 78.6301C166.829 78.6101 165.399 79.2101 164.289 80.2201C162.909 81.4801 161.889 83.5201 162.349 85.4401C162.579 86.3901 163.119 87.2301 163.749 87.9401C164.299 88.5601 164.959 89.0801 165.709 89.4101C165.739 89.5401 165.779 89.6701 165.819 89.8001C165.399 90.0501 164.999 90.3601 164.689 90.7601C164.229 91.3301 163.979 92.0301 163.989 92.7701C163.989 93.4801 164.249 94.1501 164.629 94.7401C165.019 95.3501 165.659 95.5901 166.349 95.6101C166.959 95.6301 167.719 95.4901 168.059 94.9101C168.399 94.3301 168.079 93.6801 167.689 93.2301C167.739 93.5401 167.789 93.9301 167.589 94.2001C167.419 94.4301 167.139 94.4301 166.889 94.3601C166.669 94.2901 166.079 94.0201 166.019 93.3001C165.999 93.0201 166.029 92.7301 166.179 92.4901C166.319 92.2801 166.519 92.1201 166.729 91.9901C166.759 91.9701 166.799 91.9501 166.829 91.9301C167.619 93.0201 168.859 93.8701 170.829 94.0301C176.679 94.5001 227.199 95.6101 227.199 95.6101C227.199 95.6101 233.829 92.1301 230.499 86.0001L230.459 86.0401ZM231.809 81.2601C231.869 81.2401 231.919 81.2201 231.979 81.2101C232.479 81.0901 232.979 81.3201 233.389 81.6001C233.599 81.7401 233.799 81.9001 233.969 82.0901C234.079 82.2101 234.219 82.3701 234.189 82.5401C234.139 82.8801 233.869 83.2001 233.629 83.4201C233.059 83.9201 232.259 84.1501 231.499 84.1901C232.039 83.4101 231.889 81.7401 231.799 81.2701L231.809 81.2601ZM229.399 72.0701C229.999 71.8801 230.639 71.8001 231.259 71.9001C231.469 71.9301 231.689 71.9901 231.889 72.0801C231.929 72.1001 231.989 72.1101 232.009 72.1501C232.039 72.2001 232.059 72.3301 232.069 72.3901C232.199 73.0001 232.069 73.6901 231.919 74.2901C231.769 74.9101 231.549 75.5101 231.269 76.0801C231.129 76.3701 230.969 76.6601 230.779 76.9301C230.919 76.4601 230.799 75.5701 230.659 74.8201C230.389 73.4201 229.749 72.6601 229.289 72.1101C229.319 72.1001 229.359 72.0901 229.389 72.0801L229.399 72.0701ZM184.659 58.4001C184.519 58.3201 184.389 58.2301 184.259 58.1401C183.779 57.8001 183.359 57.3801 183.109 56.8301C182.859 56.2601 182.849 55.5801 183.099 55.0101C183.609 53.8201 185.169 53.4301 186.229 54.0601C187.089 54.5701 187.549 55.4901 187.669 56.4701C186.279 56.8901 185.309 57.6901 184.659 58.4001ZM214.519 53.3601C214.489 53.9101 214.359 54.3901 213.999 54.8001C213.959 54.8401 213.929 54.8801 213.889 54.9101C212.839 52.8801 211.619 51.9101 210.329 51.5101C210.509 51.3201 210.759 51.2301 210.999 51.1301C211.309 51.0101 211.609 50.9001 211.929 50.8001C212.449 50.6401 213.079 50.4701 213.609 50.6901C214.019 50.8601 214.239 51.2501 214.369 51.6701C214.529 52.2101 214.559 52.8001 214.529 53.3601H214.519ZM216.069 57.8401C216.979 57.4301 217.979 57.2001 218.979 57.2601C220.159 57.3301 221.239 57.8801 222.029 58.7801C222.389 59.2001 222.689 59.6801 222.869 60.2201C222.959 60.4901 223.009 60.7701 223.039 61.0501C223.059 61.2001 223.069 61.3501 223.039 61.5001C222.929 61.0901 222.759 60.6501 222.509 60.2001C220.739 56.9001 218.429 59.4501 216.069 57.8501V57.8401ZM223.309 68.2901C222.079 66.8201 222.979 65.4101 223.189 63.5601C223.249 63.5901 223.309 63.6301 223.369 63.6701C223.689 63.9101 223.769 64.3401 223.779 64.7201C223.799 65.6101 223.399 66.4001 223.299 67.2601C223.259 67.6001 223.269 67.9501 223.319 68.2901H223.309Z"
        fill="url(#paint194_linear_1974_24988)"
      />
      <path
        d="M213.599 64.79C213.599 64.79 213.729 64.67 213.969 64.43C214.199 64.18 214.569 63.81 214.879 63.16C215.019 62.83 215.139 62.39 215.049 61.89C214.989 61.65 214.909 61.39 214.749 61.16C214.599 60.93 214.379 60.69 214.089 60.54C213.519 60.23 212.839 60.23 212.249 60.36C211.949 60.42 211.659 60.52 211.369 60.63C211.069 60.75 210.799 60.89 210.549 61.01C210.299 61.13 210.049 61.24 209.849 61.28C209.629 61.32 209.689 61.28 209.659 61.27C209.649 61.22 209.629 61.19 209.619 61.15C209.609 61.1 209.599 61.05 209.579 61L209.549 60.82C209.519 60.57 209.539 60.28 209.549 59.92C209.559 59.56 209.599 59.09 209.409 58.56C209.229 58.03 208.849 57.61 208.479 57.33C208.109 57.04 207.689 56.83 207.259 56.66C206.819 56.51 206.369 56.41 205.909 56.37C204.989 56.3 204.039 56.42 203.149 56.8C202.269 57.18 201.379 57.78 200.909 58.81C200.799 59.06 200.709 59.35 200.699 59.65C200.689 59.95 200.749 60.27 200.879 60.54C201.009 60.82 201.209 61.04 201.419 61.22C201.639 61.4 201.839 61.52 202.069 61.64C202.299 61.76 202.539 61.86 202.809 61.92C203.069 61.98 203.379 61.99 203.659 61.89C203.929 61.79 204.159 61.62 204.329 61.38C204.499 61.15 204.549 60.81 204.429 60.55C204.429 60.55 204.449 60.66 204.389 60.85C204.329 61.04 204.129 61.28 203.779 61.38C203.429 61.51 203.029 61.38 202.549 61C202.429 60.91 202.309 60.8 202.189 60.68C202.089 60.57 201.989 60.46 201.929 60.33C201.799 60.08 201.789 59.84 201.909 59.54C202.039 59.24 202.309 58.92 202.699 58.65C203.079 58.38 203.569 58.16 204.129 58.03C204.689 57.89 205.319 57.85 205.969 57.95C206.289 58 206.619 58.08 206.919 58.21C207.219 58.33 207.529 58.52 207.739 58.73C207.939 58.94 208.039 59.1 208.069 59.47C208.109 59.83 208.049 60.36 208.129 60.95C208.179 61.24 208.239 61.54 208.419 61.87C208.599 62.23 208.999 62.57 209.439 62.61C209.909 62.65 210.219 62.52 210.499 62.4C210.779 62.27 211.029 62.12 211.259 61.97C211.499 61.82 211.709 61.69 211.939 61.57C212.169 61.45 212.409 61.35 212.659 61.28C213.149 61.14 213.689 61.13 214.069 61.49C214.259 61.67 214.409 61.91 214.479 62.18C214.549 62.45 214.539 62.76 214.459 63.07C214.299 63.68 213.939 64.26 213.559 64.82L213.599 64.79Z"
        fill="url(#paint195_linear_1974_24988)"
      />
      <path
        d="M176.069 75.18C176.069 75.18 175.909 75.31 175.569 75.38C175.229 75.45 174.699 75.34 174.149 74.91C173.879 74.7 173.599 74.42 173.359 74.07C173.129 73.74 172.919 73.3 172.749 72.83C172.579 72.35 172.449 71.82 172.369 71.24C172.299 70.67 172.249 70.01 172.399 69.55C172.549 69.06 172.879 68.72 173.379 68.6C173.629 68.54 173.929 68.54 174.229 68.6C174.439 68.64 174.799 68.8 175.179 68.97C175.559 69.14 175.979 69.34 176.509 69.47C176.789 69.52 177.089 69.59 177.469 69.52C177.829 69.46 178.259 69.25 178.499 68.95C178.949 68.44 179.129 67.85 179.209 67.3C179.279 66.75 179.259 66.23 179.209 65.74C179.169 65.25 179.109 64.78 179.099 64.34C179.079 63.9 179.119 63.49 179.249 63.18C179.369 62.87 179.609 62.64 179.979 62.45C180.359 62.26 180.759 62.16 181.139 62.21C181.519 62.25 181.879 62.47 182.149 62.81C182.419 63.15 182.589 63.6 182.599 64.07C182.599 64.53 182.439 65 182.069 65.32C181.699 65.65 181.159 65.8 180.609 65.84C180.609 65.84 180.699 65.87 180.919 65.92C181.129 65.95 181.489 66.01 181.999 65.86C182.249 65.78 182.539 65.64 182.809 65.37C183.069 65.1 183.289 64.71 183.389 64.24C183.479 63.77 183.449 63.22 183.239 62.66C183.019 62.11 182.589 61.52 181.869 61.18C181.509 61.01 181.099 60.93 180.679 60.94C180.259 60.95 179.849 61.05 179.469 61.2C179.079 61.35 178.649 61.61 178.309 62.01C177.959 62.4 177.759 62.92 177.669 63.41C177.499 64.39 177.649 65.28 177.679 66.14C177.699 66.56 177.699 66.98 177.619 67.33C177.579 67.5 177.529 67.66 177.449 67.8C177.339 67.97 177.319 67.98 177.279 68.01C177.239 68.04 177.119 68.06 176.919 68.03C176.729 68 176.509 67.93 176.269 67.84C176.019 67.74 175.769 67.64 175.509 67.54C175.229 67.43 174.939 67.32 174.559 67.24C174.189 67.19 173.859 67.17 173.479 67.24C173.119 67.3 172.739 67.42 172.409 67.63C172.069 67.84 171.779 68.14 171.579 68.48C171.379 68.82 171.269 69.21 171.219 69.58C171.179 69.96 171.219 70.33 171.259 70.67C171.309 71.02 171.379 71.37 171.479 71.71C171.669 72.4 171.949 73.08 172.339 73.71C172.719 74.35 173.289 74.92 173.959 75.29C174.299 75.47 174.669 75.61 175.059 75.62C175.449 75.62 175.819 75.48 176.079 75.22L176.069 75.18Z"
        fill="url(#paint196_linear_1974_24988)"
      />
      <path
        d="M187.799 64.4002L187.829 64.3202C187.849 64.2702 187.869 64.1902 187.919 64.0902C187.999 63.8902 188.149 63.5902 188.379 63.2402C188.609 62.8902 188.919 62.4802 189.329 62.0702C189.529 61.8702 189.769 61.6702 190.019 61.5102C190.279 61.3402 190.499 61.2602 190.819 61.2102C191.439 61.1202 192.239 61.2102 193.009 61.5002C193.199 61.5702 193.389 61.6602 193.559 61.7502C193.729 61.8502 193.879 61.9402 194.029 62.0802C194.329 62.3402 194.619 62.6902 194.839 63.0902C195.279 63.8902 195.509 64.8702 195.019 65.7002C194.789 66.1202 194.379 66.4802 193.869 66.6902C193.359 66.9002 192.739 66.9302 192.139 66.7302C192.139 66.7202 192.239 66.9702 192.779 67.2502C193.049 67.3802 193.459 67.5102 193.999 67.4702C194.269 67.4502 194.569 67.3902 194.879 67.2502C195.199 67.1202 195.519 66.9202 195.819 66.6202C196.119 66.3202 196.389 65.9302 196.559 65.4502C196.729 64.9602 196.779 64.4102 196.699 63.8502C196.619 63.3002 196.429 62.7302 196.129 62.2002C195.819 61.6702 195.399 61.1502 194.809 60.7202C194.189 60.3002 193.499 60.0702 192.769 59.9502C192.029 59.8502 191.229 59.8302 190.399 60.1202C189.979 60.2702 189.589 60.5402 189.299 60.8502C188.999 61.1602 188.749 61.5102 188.539 61.8902C188.129 62.6402 187.799 63.5102 187.809 64.4002H187.799Z"
        fill="url(#paint197_linear_1974_24988)"
      />
      <path
        d="M215.219 73.3702L215.249 73.2902C215.269 73.2402 215.289 73.1602 215.339 73.0602C215.419 72.8602 215.569 72.5602 215.799 72.2102C216.029 71.8602 216.339 71.4502 216.749 71.0402C216.949 70.8402 217.189 70.6402 217.439 70.4802C217.699 70.3102 217.919 70.2302 218.239 70.1802C218.859 70.0902 219.659 70.1802 220.429 70.4702C220.619 70.5402 220.809 70.6302 220.979 70.7202C221.149 70.8202 221.299 70.9102 221.449 71.0502C221.749 71.3102 222.039 71.6602 222.259 72.0602C222.699 72.8602 222.929 73.8402 222.439 74.6702C222.209 75.0902 221.799 75.4502 221.289 75.6602C220.779 75.8702 220.159 75.9002 219.559 75.7002C219.559 75.6902 219.659 75.9402 220.199 76.2202C220.469 76.3502 220.879 76.4802 221.419 76.4402C221.689 76.4202 221.989 76.3602 222.299 76.2202C222.619 76.0902 222.939 75.8902 223.239 75.5902C223.539 75.2902 223.809 74.9002 223.979 74.4202C224.149 73.9302 224.199 73.3802 224.119 72.8202C224.039 72.2702 223.849 71.7002 223.549 71.1702C223.239 70.6402 222.819 70.1202 222.229 69.6902C221.609 69.2702 220.919 69.0402 220.189 68.9202C219.449 68.8202 218.649 68.8002 217.819 69.0902C217.399 69.2402 217.009 69.5102 216.719 69.8202C216.419 70.1302 216.169 70.4802 215.959 70.8602C215.549 71.6102 215.219 72.4802 215.229 73.3702H215.219Z"
        fill="url(#paint198_linear_1974_24988)"
      />
      <path
        d="M173.129 116.59C174.229 124.98 175.159 131.36 175.159 131.36C171.569 131.36 170.259 127.77 168.859 124.6C166.719 119.76 165.449 114.56 170.329 114.29C171.279 114.24 173.139 116.6 173.139 116.6L173.129 116.59Z"
        fill="url(#paint199_linear_1974_24988)"
      />
      <path
        d="M172.479 128.53C172.479 128.53 170.719 126.67 171.269 123.02C172.549 114.4 166.709 113.81 168.039 119.69C168.039 119.69 168.849 116.92 169.589 117.74C170.499 118.76 168.609 119.32 169.579 123.77C170.079 126.08 172.489 128.52 172.489 128.52L172.479 128.53Z"
        fill="url(#paint200_linear_1974_24988)"
      />
      <path
        d="M223.569 116.59C222.469 124.98 221.139 131.36 221.139 131.36C224.729 131.36 226.449 127.77 227.849 124.6C229.989 119.76 231.259 114.56 226.379 114.29C225.429 114.24 223.569 116.6 223.569 116.6V116.59Z"
        fill="url(#paint201_linear_1974_24988)"
      />
      <path
        d="M224.229 128.53C224.229 128.53 225.989 126.67 225.439 123.02C224.159 114.4 229.999 113.81 228.669 119.69C228.669 119.69 227.859 116.92 227.119 117.74C226.209 118.76 228.099 119.32 227.129 123.77C226.629 126.08 224.219 128.52 224.219 128.52L224.229 128.53Z"
        fill="url(#paint202_linear_1974_24988)"
      />
      <path
        d="M222.889 88.89C219.769 81.75 212.429 79.2 201.569 78.51C201.569 78.51 176.769 81.75 173.649 88.89C170.249 96.67 171.219 107.59 172.189 114.74C173.159 121.89 175.109 133.48 176.889 136.76C178.669 140.04 187.689 148.66 189.639 150.12C191.459 151.48 193.789 153.79 198.299 153.79C202.309 153.79 205.479 151.35 207.249 149.96C209.159 148.46 217.829 139.69 219.619 136.41C221.399 133.13 223.379 121.88 224.349 114.73C225.319 107.58 226.299 96.66 222.889 88.88V88.89Z"
        fill="#C57D4E"
      />
      <path
        d="M220.179 108.25C218.369 106.83 215.739 105.65 212.189 106.01C200.799 107.17 200.979 118.53 199.909 124.98C213.889 130.52 222.019 120.43 222.019 120.43C222.019 120.43 224.409 111.55 220.189 108.25H220.179Z"
        fill="url(#paint203_linear_1974_24988)"
      />
      <path
        d="M183.329 106.5C179.769 106.26 177.409 107.15 175.609 108.62C171.409 112.05 174.489 121.71 174.489 121.71C174.489 121.71 182.689 131.45 196.629 125.47C195.519 119.09 194.719 107.26 183.329 106.5Z"
        fill="url(#paint204_linear_1974_24988)"
      />
      <path
        d="M187.969 117.88C184.769 116.92 172.389 114.32 172.979 118.43C174.289 127.53 175.479 133.78 177.059 136.61C178.719 139.58 183.589 144.25 185.689 144.6C188.939 145.15 192.399 133.17 192.469 129.07C192.579 123.32 191.169 118.83 187.969 117.88Z"
        fill="url(#paint205_radial_1974_24988)"
      />
      <path
        d="M208.589 117.88C211.789 116.92 224.169 114.32 223.579 118.43C222.269 127.53 221.079 133.78 219.499 136.61C217.839 139.58 212.969 144.25 210.869 144.6C207.619 145.15 204.159 133.17 204.089 129.07C203.979 123.32 205.389 118.83 208.589 117.88Z"
        fill="url(#paint206_radial_1974_24988)"
      />
      <path
        d="M198.859 145.58C196.579 145.69 194.739 146.51 194.759 147.41C194.769 148.32 196.629 148.97 198.899 148.86C201.179 148.75 203.009 147.93 202.999 147.03C202.989 146.12 201.129 145.47 198.859 145.58Z"
        fill="url(#paint207_linear_1974_24988)"
      />
      <path
        d="M172.319 115.65C172.319 115.65 174.599 132.2 176.719 136.8C177.409 138.3 183.439 144.61 187.309 148.21C187.309 148.21 179.619 140.42 177.559 135.14C175.789 130.61 172.309 115.64 172.309 115.64L172.319 115.65Z"
        fill="url(#paint208_linear_1974_24988)"
      />
      <path
        d="M224.249 115.65C224.249 115.65 221.969 132.2 219.849 136.8C219.159 138.3 213.079 144.61 209.199 148.21C209.199 148.21 216.939 140.42 218.999 135.14C220.769 130.61 224.249 115.64 224.249 115.64V115.65Z"
        fill="url(#paint209_linear_1974_24988)"
      />
      <path
        d="M185.209 146.2C185.209 146.2 191.399 151.45 192.059 151.83C193.389 152.58 194.749 153.56 198.199 153.68C201.559 153.79 203.619 152.39 204.559 151.76C205.549 151.1 210.609 146.86 211.089 146.4C211.089 146.4 207.079 151.11 205.539 152.38C203.039 154.44 200.099 155.53 198.259 155.53C195.939 155.53 194.039 154.11 192.059 152.99C189.899 151.77 185.209 146.21 185.209 146.21V146.2Z"
        fill="url(#paint210_linear_1974_24988)"
      />
      <path
        d="M215.559 122.19C214.209 122.55 213.269 123.5 213.439 124.31C213.619 125.12 214.849 125.49 216.189 125.13C217.529 124.77 218.479 123.83 218.299 123.01C218.119 122.2 216.889 121.84 215.549 122.19H215.559Z"
        fill="url(#paint211_linear_1974_24988)"
      />
      <path
        d="M179.589 122.09C178.179 121.78 176.899 122.21 176.749 123.06C176.589 123.91 177.609 124.86 179.029 125.17C180.449 125.48 181.719 125.05 181.869 124.2C182.019 123.35 180.999 122.4 179.589 122.08V122.09Z"
        fill="url(#paint212_linear_1974_24988)"
      />
      <path
        d="M205.039 78.49C194.269 77.52 179.989 84.13 175.869 97.5C172.979 106.89 172.169 111.71 172.679 117.57C172.889 120.05 173.619 123.79 174.069 126.4C174.069 126.4 173.889 119.32 179.009 116.62C179.009 116.62 177.979 104.86 183.689 95.85C187.169 90.36 193.889 88.75 197.749 88.48C201.819 88.2 207.219 89.26 210.619 92.77C215.449 97.74 216.829 106.48 217.109 116.62C223.309 116.66 222.679 122.01 222.559 126C222.559 126 223.689 120.79 224.289 115.48C224.819 110.84 224.979 106.54 223.139 100.4C220.559 91.77 215.789 79.46 205.029 78.49H205.039Z"
        fill="url(#paint213_linear_1974_24988)"
      />
      <path
        d="M195.389 73.93C171.709 76.42 170.179 108.82 171.219 114.06C171.519 115.54 173.629 116.03 173.629 116.03C173.629 116.03 174.269 110.29 174.969 108.87C176.249 106.27 179.159 96.46 181.329 92.63C182.509 90.56 185.529 87.57 189.149 86.35C194.819 84.43 200.259 84.61 205.909 86.69C207.389 87.24 212.129 87.8 215.869 93.86C217.089 95.84 221.599 103.9 223.269 116.27C224.639 113.86 225.549 114.23 225.939 112.16C226.329 110.11 227.959 70.51 195.379 73.94L195.389 73.93Z"
        fill="url(#paint214_linear_1974_24988)"
      />
      <path
        d="M214.869 75.02C214.269 74.62 211.539 71.73 206.739 70.93C204.159 70.5 202.029 70.34 196.739 70.69C194.099 70.86 188.199 71.71 186.149 72.08C183.349 72.59 184.419 73.35 182.869 74.67C180.099 77.02 176.169 77.23 174.779 78.4C173.479 79.5 173.849 80.14 173.969 81.01C174.419 84.38 171.249 85.02 170.109 87.13C168.949 89.28 169.749 91.76 168.039 94.03C167.219 95.12 167.529 96.78 167.549 98.55C167.629 103.53 168.229 110.94 171.219 114.07C171.219 114.07 171.589 109.9 171.589 105.34C171.589 100.78 174.259 96.3 176.219 91.29C178.679 85.02 187.069 80.6 197.149 80.59C199.329 80.59 208.039 79.91 210.349 80.18C220.559 81.39 222.099 91.1 222.879 93.71C224.369 98.66 225.139 113.93 225.139 113.93C225.139 113.93 228.419 108.71 228.509 107C228.969 97.8 230.229 95.63 226.029 86.49C225.639 85.65 225.899 84.14 225.489 83.44C224.869 82.39 223.659 81.91 223.029 80.74C222.359 79.48 221.599 78.29 220.609 77.47C219.659 76.69 218.169 77.26 216.969 76.43C216.309 75.97 215.619 75.5 214.869 75V75.02Z"
        fill="url(#paint215_linear_1974_24988)"
      />
      <path
        d="M167.489 97.04C167.499 97.9 167.269 103.76 169.269 114.43C171.229 114.06 171.889 115.38 172.319 115.65C172.319 115.65 172.879 119.93 173.739 124.51C173.739 124.51 175.089 107.64 175.369 105.87C175.369 105.87 168.219 102.99 167.489 97.04Z"
        fill="url(#paint216_linear_1974_24988)"
      />
      <path
        d="M220.899 105.95C222.329 111.64 222.639 117.15 223.129 123.15C223.129 123.15 224.199 116.3 224.759 115.56C225.239 114.93 226.089 114.07 227.629 114.5C227.629 114.5 230.449 106.4 228.959 95.98C228.959 95.98 225.689 104.51 220.889 105.95H220.899Z"
        fill="url(#paint217_linear_1974_24988)"
      />
      <path
        d="M209.709 86.7901C198.409 82.2501 186.669 86.2601 184.259 88.6401C178.299 94.5301 175.509 100.18 174.799 111.76C174.799 111.76 179.219 98.7201 180.599 96.4801C182.009 94.2001 184.299 90.3701 188.539 88.5001C192.389 86.8001 200.109 85.0901 208.559 88.2701C217.739 91.7201 222.279 113.74 222.279 113.74C222.279 113.74 221.139 91.3901 209.699 86.7901H209.709Z"
        fill="url(#paint218_linear_1974_24988)"
      />
      <path
        d="M180.719 105.49C182.719 105.28 187.829 106.46 189.379 107.02C190.099 107.38 190.509 108.01 190.389 109.21C190.729 108.5 190.579 108 190.279 107.53C191.499 108.55 191.339 110.25 189.959 109.78C188.389 109.24 182.189 107.49 180.919 107.46C178.949 107.41 176.199 108.13 175.429 108.62C175.429 108.62 178.559 105.72 180.729 105.49H180.719Z"
        fill="url(#paint219_linear_1974_24988)"
      />
      <path
        d="M210.719 107.99C210.719 107.99 215.549 105.09 220.369 108.63C222.059 109.87 219.999 116.46 219.999 116.46C219.999 116.46 221.869 105.13 210.719 108V107.99Z"
        fill="#C57D4E"
      />
      <path
        d="M215.069 105.49C213.069 105.28 207.949 106.46 206.399 107.02C205.679 107.38 205.269 108.01 205.389 109.21C205.049 108.5 205.199 108 205.499 107.53C204.279 108.55 204.429 110.25 205.819 109.78C207.399 109.24 213.599 107.49 214.869 107.46C216.849 107.41 219.599 108.13 220.369 108.62C220.369 108.62 217.239 105.72 215.059 105.49H215.069Z"
        fill="url(#paint220_linear_1974_24988)"
      />
      <path
        d="M212.279 111.53C204.629 111.53 203.919 116.21 203.759 119.58C204.339 119.71 204.949 119.82 206.079 120.17C207.609 120.64 209.409 121.4 212.009 121.38C214.049 121.36 218.449 120.44 218.519 116.05C218.569 112.57 214.119 111.69 212.279 111.53Z"
        fill="url(#paint221_linear_1974_24988)"
      />
      <path
        d="M204.108 119.32C205.778 119.56 206.898 120.13 208.048 120.44C207.148 119.61 206.628 118.85 206.688 117.48C206.748 116.29 207.658 115 208.428 114.28C205.718 115.88 204.108 119.31 204.108 119.31V119.32Z"
        fill="url(#paint222_linear_1974_24988)"
      />
      <path
        d="M204.108 119.32C204.588 118.85 205.438 117.9 206.768 117.11C206.938 116.18 207.458 115.36 208.208 114.79C205.728 115.99 204.108 119.33 204.108 119.33V119.32Z"
        fill="#DDDDDD"
      />
      <path
        d="M214.349 117.87C214.279 119.3 213.529 120.19 212.479 120.88C216.949 120.3 218.219 116.75 218.219 116.75C215.459 114.46 213.479 113.74 211.589 113.58C213.269 114.15 214.449 115.89 214.349 117.87Z"
        fill="url(#paint223_linear_1974_24988)"
      />
      <path
        d="M206.759 117.01C206.729 117.18 206.709 117.3 206.699 117.49C206.599 118.82 207.109 119.65 208.059 120.45C208.379 120.6 211.179 121.17 212.889 120.89C213.979 120.22 214.779 119.36 214.859 117.97C214.899 117.25 214.759 116.56 214.459 115.95C212.289 115.2 209.429 115.22 206.769 117.01H206.759Z"
        fill="url(#paint224_linear_1974_24988)"
      />
      <path
        d="M212.869 114.43C213.729 114.91 214.379 115.67 214.679 116.59C216.239 117.24 217.269 118.09 217.269 118.09L218.019 116.57C216.929 115.19 214.849 114.8 212.869 114.43Z"
        fill="#DDDDDD"
      />
      <path
        d="M212.869 114.43C211.669 114.21 210.419 114.19 209.269 114.41C208.899 114.48 208.539 114.61 208.209 114.77C207.459 115.35 206.889 116.15 206.739 117.09C207.719 116.51 208.989 116.01 210.539 115.87C212.089 115.73 213.549 116.11 214.699 116.59C214.429 115.65 213.729 114.9 212.869 114.42V114.43Z"
        fill="url(#paint225_linear_1974_24988)"
      />
      <path
        d="M210.888 114.68C209.478 114.57 208.238 115.6 208.148 116.96C208.038 118.33 209.108 119.52 210.518 119.63C211.938 119.74 213.168 118.71 213.268 117.35C213.368 115.98 212.308 114.79 210.888 114.69V114.68Z"
        fill="url(#paint226_radial_1974_24988)"
      />
      <path
        d="M211.328 116.14C210.988 115.95 210.548 116.07 210.348 116.41C210.138 116.75 210.248 117.19 210.578 117.38C210.908 117.57 211.348 117.45 211.558 117.11C211.768 116.77 211.658 116.33 211.328 116.14Z"
        fill="white"
      />
      <path
        d="M213.639 117.17C213.179 116.9 212.589 117.05 212.329 117.5C212.059 117.96 212.219 118.55 212.679 118.82C213.139 119.09 213.729 118.94 213.989 118.49C214.249 118.03 214.099 117.44 213.639 117.17Z"
        fill="white"
      />
      <path
        d="M219.919 113.36C219.919 113.36 219.169 114.93 215.439 113.58C208.249 111.26 204.249 115.45 204.099 119.31C204.099 119.31 206.259 115.06 210.339 114.66C212.819 114.42 214.969 115.44 217.119 116.6C217.149 118.32 214.849 120.43 212.379 120.93C214.499 120.95 219.209 118.76 219.559 116.97C219.429 117.19 218.979 117.35 218.399 117.14C218.399 117.14 220.419 116.33 219.919 113.35V113.36Z"
        fill="url(#paint227_linear_1974_24988)"
      />
      <path
        d="M208.609 111.89C206.119 112.74 205.039 114.55 205.039 114.55C205.039 114.55 206.159 113.07 208.839 112.27C211.619 111.44 215.449 112.25 215.449 112.25C213.759 111.46 211.099 111.04 208.609 111.89Z"
        fill="url(#paint228_linear_1974_24988)"
      />
      <path
        d="M210.048 114.3C205.378 115.09 204.108 119.32 204.108 119.32C204.108 119.32 205.908 115.68 210.148 114.93C212.558 114.5 215.288 115.69 217.128 116.62C217.128 116.62 214.258 113.59 210.048 114.3Z"
        fill="#391B13"
      />
      <path
        d="M183.86 111.53C191.51 111.53 192.22 116.21 192.38 119.58C191.8 119.71 191.19 119.82 190.06 120.17C188.53 120.64 186.73 121.4 184.13 121.38C182.09 121.36 177.69 120.44 177.62 116.05C177.57 112.57 182.02 111.69 183.86 111.53Z"
        fill="url(#paint229_linear_1974_24988)"
      />
      <path
        d="M192.029 119.32C190.359 119.56 189.239 120.13 188.089 120.44C188.989 119.61 189.509 118.85 189.449 117.48C189.389 116.29 188.479 115 187.709 114.28C190.419 115.88 192.029 119.31 192.029 119.31V119.32Z"
        fill="url(#paint230_linear_1974_24988)"
      />
      <path
        d="M192.03 119.32C191.55 118.85 190.7 117.9 189.37 117.11C189.2 116.18 188.68 115.36 187.93 114.79C190.41 115.99 192.03 119.33 192.03 119.33V119.32Z"
        fill="#DDDDDD"
      />
      <path
        d="M181.789 117.87C181.859 119.3 182.609 120.19 183.659 120.88C179.189 120.3 177.919 116.75 177.919 116.75C180.679 114.46 182.659 113.74 184.549 113.58C182.869 114.15 181.689 115.89 181.789 117.87Z"
        fill="url(#paint231_linear_1974_24988)"
      />
      <path
        d="M189.379 117.01C189.409 117.18 189.429 117.3 189.439 117.49C189.539 118.82 189.029 119.65 188.079 120.45C187.759 120.6 184.959 121.17 183.249 120.89C182.159 120.22 181.359 119.36 181.279 117.97C181.239 117.25 181.379 116.56 181.679 115.95C183.849 115.2 186.709 115.22 189.369 117.01H189.379Z"
        fill="url(#paint232_linear_1974_24988)"
      />
      <path
        d="M183.269 114.43C182.409 114.91 181.759 115.67 181.459 116.59C179.899 117.24 178.869 118.09 178.869 118.09L178.119 116.57C179.209 115.19 181.289 114.8 183.269 114.43Z"
        fill="#DDDDDD"
      />
      <path
        d="M183.269 114.43C184.469 114.21 185.719 114.19 186.869 114.41C187.239 114.48 187.599 114.61 187.929 114.77C188.679 115.35 189.249 116.15 189.399 117.09C188.419 116.51 187.149 116.01 185.599 115.87C184.049 115.73 182.589 116.11 181.439 116.59C181.709 115.65 182.409 114.9 183.269 114.42V114.43Z"
        fill="url(#paint233_linear_1974_24988)"
      />
      <path
        d="M185.249 114.68C186.659 114.57 187.899 115.6 187.989 116.96C188.099 118.33 187.029 119.52 185.619 119.63C184.199 119.74 182.969 118.71 182.869 117.35C182.769 115.98 183.829 114.79 185.249 114.69V114.68Z"
        fill="url(#paint234_radial_1974_24988)"
      />
      <path
        d="M185.809 116.14C185.469 115.95 185.029 116.07 184.829 116.41C184.619 116.75 184.729 117.19 185.059 117.38C185.389 117.57 185.829 117.45 186.039 117.11C186.249 116.77 186.139 116.33 185.809 116.14Z"
        fill="white"
      />
      <path
        d="M188.12 117.17C187.66 116.9 187.07 117.05 186.81 117.5C186.55 117.96 186.7 118.55 187.16 118.82C187.62 119.09 188.21 118.94 188.47 118.49C188.73 118.03 188.58 117.44 188.12 117.17Z"
        fill="white"
      />
      <path
        d="M176.219 113.36C176.219 113.36 176.969 114.93 180.699 113.58C187.889 111.26 191.889 115.45 192.039 119.31C192.039 119.31 189.879 115.06 185.799 114.66C183.319 114.42 181.169 115.44 179.019 116.6C178.989 118.32 181.289 120.43 183.759 120.93C181.639 120.95 176.929 118.76 176.579 116.97C176.709 117.19 177.159 117.35 177.739 117.14C177.739 117.14 175.719 116.33 176.219 113.35V113.36Z"
        fill="url(#paint235_linear_1974_24988)"
      />
      <path
        d="M187.529 111.89C190.019 112.74 191.099 114.55 191.099 114.55C191.099 114.55 189.979 113.07 187.299 112.27C184.519 111.44 180.689 112.25 180.689 112.25C182.379 111.46 185.039 111.04 187.529 111.89Z"
        fill="url(#paint236_linear_1974_24988)"
      />
      <path
        d="M186.089 114.3C190.759 115.09 192.029 119.32 192.029 119.32C192.029 119.32 190.229 115.68 185.989 114.93C183.579 114.5 180.849 115.69 179.009 116.62C179.009 116.62 181.879 113.59 186.089 114.3Z"
        fill="#391B13"
      />
      <path
        d="M192.1 130.82L197.75 134.17L203.06 130.72L202.3 130.17L197.46 130.23H192.64L192.1 130.82Z"
        fill="url(#paint237_linear_1974_24988)"
      />
      <path
        d="M192.26 130.73C192.26 130.73 194.4 130.16 196.28 130.84H198.58C198.58 130.84 200.86 130.08 203.05 130.72L203.15 129.82L201.32 129.5L197.46 130.34L193.93 129.5L192.09 129.68L192.26 130.72V130.73Z"
        fill="url(#paint238_linear_1974_24988)"
      />
      <path
        d="M191.53 126.87C191.53 126.87 190.53 127.35 190.38 128.66C190.21 130.16 192 130.97 192.28 130.82C192.56 130.67 192.05 129.54 193.71 129.74C195.37 129.94 195.28 130.66 195.55 130.9C195.82 131.14 198.73 131.2 199.22 130.94C199.71 130.67 199.58 129.69 201.14 129.74C202.71 129.78 202.75 130.7 202.97 130.82C203.19 130.94 204.12 130.22 204.39 128.85C204.66 127.48 202.98 126.88 202.98 126.88C202.98 126.88 203.83 128.1 203.47 128.88C203.11 129.66 200.7 128.99 199.72 129.52C197.9 130.5 196.8 130.26 195 129.52C193.81 129.03 192.15 129.64 191.48 128.8C191.25 128.51 191.19 127.46 191.53 126.88V126.87Z"
        fill="url(#paint239_linear_1974_24988)"
      />
      <path
        d="M193.73 126.19C193.7 127.14 193.83 127.55 194.3 128.17C195.02 129.12 200.07 129.89 200.94 127.72C201.11 127.29 201.11 126.61 201.02 125.75C200.92 124.77 193.77 125.24 193.74 126.19H193.73Z"
        fill="url(#paint240_linear_1974_24988)"
      />
      <path
        d="M189.379 139.13C189.379 139.13 192.229 143.08 193.139 143.64C195.539 145.1 201.949 144.74 203.109 143.8C204.829 142.41 206.789 139.14 206.789 139.14H189.379V139.13Z"
        fill="url(#paint241_linear_1974_24988)"
      />
      <path
        d="M185.299 135.87C184.629 135.71 184.509 134.75 184.739 134.23C184.939 133.77 187.989 135.94 189.169 137.36C187.659 136.43 185.969 136.03 185.299 135.86V135.87Z"
        fill="url(#paint242_linear_1974_24988)"
      />
      <path
        d="M210.179 136.11C211.139 135.68 211.269 134.91 211.029 134.4C210.819 133.94 207.809 136.04 206.669 137.49C208.159 136.52 209.519 136.29 210.179 136.11Z"
        fill="url(#paint243_linear_1974_24988)"
      />
      <path
        d="M186.329 135.14C186.329 135.14 196.929 135.42 197.459 135.39C197.979 135.36 209.709 135.14 209.709 135.14C209.709 135.14 204.969 139.83 204.419 140.45C203.859 141.07 198.239 142.43 197.329 142.26C196.419 142.09 191.609 140.1 190.809 139.52C190.009 138.95 186.329 135.14 186.329 135.14Z"
        fill="#78000A"
      />
      <path
        d="M191.419 137.21L190.799 139.09C190.799 139.09 195.469 141.84 198.009 141.84C200.549 141.84 205.179 139.53 205.179 139.53L204.239 137.22H191.419V137.21Z"
        fill="url(#paint244_linear_1974_24988)"
      />
      <path
        d="M186.329 135.14C186.329 135.14 190.599 141.05 192.579 142.66C194.559 144.26 201.509 144.37 203.749 142.66C205.219 141.53 209.719 135.14 209.719 135.14C209.719 135.14 204.039 140.07 202.529 140.45C201.019 140.83 195.469 140.61 194.049 140.42C192.639 140.23 186.329 135.14 186.329 135.14Z"
        fill="#D23F4C"
      />
      <path
        d="M190.669 135.77C190.669 135.77 190.279 137.97 192.569 138.53C194.869 139.1 202.499 138.77 203.529 138.64C206.039 138.33 205.839 135.58 205.839 135.58L190.659 135.76L190.669 135.77Z"
        fill="url(#paint245_linear_1974_24988)"
      />
      <path
        d="M193.309 141.4C193.599 141.01 196.749 140.75 198.329 140.84C199.909 140.93 202.259 140.87 202.939 141.4C203.629 141.92 202.109 143.52 198.329 143.49C194.549 143.46 192.589 142.35 193.309 141.4Z"
        fill="url(#paint246_linear_1974_24988)"
      />
      <path
        d="M199.169 141.5C199.829 141.27 202.339 141.08 203.039 140.68C203.739 140.29 204.579 139.92 204.579 139.92C204.579 139.92 203.629 141.33 202.859 141.69C202.089 142.05 198.509 141.72 199.169 141.49V141.5Z"
        fill="#D9646F"
      />
      <path
        d="M187.199 135.08C187.199 135.08 195.519 134.61 198.399 134.66C201.279 134.72 208.279 135.05 208.279 135.05C208.279 135.05 203.949 133.46 198.339 133.46C192.729 133.46 187.209 135.08 187.209 135.08H187.199Z"
        fill="url(#paint247_linear_1974_24988)"
      />
      <path
        d="M190.669 135.77C190.669 135.77 190.599 136.18 190.669 136.52C190.669 136.52 191.839 136.92 198.249 137.03C204.659 137.14 205.759 136.56 205.759 136.56C205.759 136.56 205.859 135.88 205.849 135.73L190.669 135.76V135.77Z"
        fill="url(#paint248_linear_1974_24988)"
      />
      <path
        d="M186.329 135.14C186.329 135.14 193.339 134.16 198.399 134.16C202.159 134.16 209.709 135.14 209.709 135.14C209.709 135.14 206.869 136.73 198.019 136.55C190.169 136.4 186.329 135.14 186.329 135.14Z"
        fill="#D23F4C"
      />
      <path
        d="M190.039 135.42C190.039 135.42 193.859 134.35 198.179 134.38C202.499 134.41 207.819 135.59 207.819 135.59C207.819 135.59 203.379 136.45 198.639 136.29C193.899 136.13 190.049 135.42 190.049 135.42H190.039Z"
        fill="url(#paint249_linear_1974_24988)"
      />
      <path
        d="M185.749 135.33C186.109 135.49 186.389 135.22 187.819 135.74C187.819 135.74 185.379 134.47 185.219 134.54C185.109 134.59 185.219 135.08 185.749 135.33Z"
        fill="#78000A"
      />
      <path
        d="M210.079 135.48C209.719 135.65 209.319 135.39 208.069 135.95C208.069 135.95 210.389 134.55 210.589 134.68C210.689 134.75 210.609 135.23 210.079 135.48Z"
        fill="#78000A"
      />
      <path
        d="M205.189 72.5901C206.729 73.1301 208.489 73.9301 209.749 75.0001C211.369 76.3801 209.149 77.9501 208.379 79.0901C208.229 79.3101 207.859 79.7501 207.849 80.0301C207.849 80.3001 208.249 80.6301 208.399 80.8101C208.929 81.4301 209.439 82.0601 209.949 82.7001C210.229 83.0601 210.469 83.3601 210.249 83.8201C209.939 84.4601 209.269 85.0101 208.799 85.5301C208.999 84.9701 209.299 84.4401 209.489 83.8901C209.589 83.6001 209.599 83.5901 209.389 83.3501C209.189 83.1001 208.839 82.9001 208.589 82.6901C207.429 81.6901 205.879 80.6701 206.759 78.9801C207.109 78.3001 207.589 77.6701 208.119 77.1201C208.319 76.9201 209.059 76.4201 209.059 76.1101C209.059 75.8801 208.619 75.6101 208.469 75.4701C208.089 75.1301 207.719 74.8001 207.339 74.4701C206.629 73.8501 205.909 73.2301 205.179 72.6201L205.189 72.5901Z"
        fill="url(#paint250_linear_1974_24988)"
      />
      <path
        d="M218.659 77.28C219.519 78.18 220.689 79.26 220.799 80.57C220.949 82.45 219.139 83.52 217.729 84.3C217.499 84.43 216.729 84.72 216.669 85.02C216.619 85.24 217.119 85.85 217.219 86.01C217.469 86.42 217.719 86.83 217.979 87.23C218.839 88.55 220.709 90.48 219.719 92.18C220.009 90.5 218.269 89.38 217.299 88.29C216.459 87.35 214.589 85.54 215.469 84.18C216.239 82.99 218.019 82.8 219.059 81.91C220.649 80.54 219.359 78.79 218.669 77.29L218.659 77.28Z"
        fill="url(#paint251_linear_1974_24988)"
      />
      <path
        d="M192.789 72.0801C193.369 72.2201 194.129 72.4301 194.559 72.8601C195.129 73.4201 194.789 74.0301 194.369 74.5501C193.959 75.0601 193.309 75.7501 193.569 76.4601C193.809 77.1101 194.649 77.3201 195.199 77.6001C195.539 77.7701 195.829 77.9601 195.909 78.3701C196.059 79.1201 195.409 79.4801 194.919 79.8801C193.589 80.9701 193.599 82.9701 194.809 84.1501C192.499 83.3501 192.509 80.1901 194.149 78.7501C194.049 78.6501 193.719 78.5201 193.559 78.4301C192.689 77.9101 192.029 77.0301 192.199 75.9701C192.269 75.4901 192.519 75.0501 192.819 74.6801C193.129 74.3001 193.689 74.0401 193.959 73.6601C194.379 73.0601 193.229 72.4001 192.779 72.0801H192.789Z"
        fill="url(#paint252_linear_1974_24988)"
      />
      <path
        d="M181.519 76.4502C181.279 77.3802 180.989 78.2602 181.689 79.0602C182.449 79.9202 183.549 80.5802 184.479 81.2502C185.269 81.8202 185.349 82.3302 184.959 83.1802C184.509 84.1702 184.529 85.2502 185.219 86.1402C184.399 85.8802 183.839 85.0702 183.669 84.2502C183.619 84.0102 183.599 83.7702 183.609 83.5302C183.619 83.2802 183.849 82.8002 183.809 82.5902C183.789 82.5002 183.789 82.5402 183.749 82.4702C183.669 82.3402 183.329 82.2002 183.199 82.1102C182.909 81.9002 182.619 81.6802 182.349 81.4502C181.869 81.0402 181.389 80.5802 181.019 80.0602C180.089 78.7502 180.479 77.5202 181.509 76.4402L181.519 76.4502Z"
        fill="url(#paint253_linear_1974_24988)"
      />
      <path
        d="M173.929 83.8C172.859 85.55 175.619 87.12 175.959 88.72C176.179 89.75 175.679 90.61 175.279 91.52C174.819 92.57 175.099 93.75 176.189 94.28C175.189 94.43 174.269 93.58 173.999 92.67C173.659 91.54 174.349 90.63 174.539 89.57C174.729 88.49 173.859 87.58 173.469 86.65C173.079 85.73 172.969 84.42 173.929 83.8Z"
        fill="url(#paint254_linear_1974_24988)"
      />
      <path
        d="M228.589 96.81C228.269 97.79 227.809 98.75 227.699 99.79C227.569 100.97 228.269 101.87 228.349 103.01C228.439 104.22 227.699 105.19 226.879 105.99C226.139 106.71 225.089 107.54 225.199 108.69C223.739 106.72 227.149 104.87 226.889 102.94C226.739 101.79 226.259 100.95 226.599 99.75C226.939 98.59 227.749 97.63 228.589 96.79V96.81Z"
        fill="url(#paint255_linear_1974_24988)"
      />
      <path
        d="M169.169 99.3101C169.929 99.8901 170.869 101.08 170.719 102.1C170.559 103.21 169.089 103.76 169.799 104.98C170.479 106.15 171.509 106.95 172.429 107.91C173.219 108.73 173.959 110.25 172.899 111.19C173.389 110.11 172.479 109.19 171.649 108.65C170.469 107.88 169.429 107.1 168.669 105.89C167.909 104.68 168.149 103.49 169.149 102.5C169.549 102.1 169.879 101.96 169.819 101.35C169.749 100.65 169.509 99.9401 169.179 99.3201L169.169 99.3101Z"
        fill="url(#paint256_linear_1974_24988)"
      />
      <path
        d="M167.869 94.3002C168.759 93.0802 169.049 91.5102 169.009 89.9302C168.989 89.0102 168.559 87.9702 168.969 87.1002C169.369 86.2502 170.279 85.6102 170.979 85.0102C171.619 84.4602 172.429 84.1502 173.059 83.5902C173.789 82.9602 173.649 82.5402 173.299 81.7002C172.589 79.9802 173.179 77.7302 174.789 76.9202C176.439 76.0902 178.999 76.4302 180.679 75.6702C181.039 75.5102 181.969 75.2502 182.169 74.8902C182.399 74.4802 182.199 73.7102 182.289 73.2502C182.579 71.6102 184.239 70.8802 185.779 71.0302C186.509 71.1002 187.199 71.3602 187.909 71.4902C188.759 71.6502 189.509 71.4402 190.269 71.0702C191.649 70.3902 192.839 69.4202 194.349 69.0002C195.219 68.7602 196.139 68.7102 197.009 68.9602C197.629 69.1402 198.369 69.8802 199.009 69.8902C199.529 69.8902 200.159 69.1502 200.569 68.8902C201.369 68.3702 202.279 68.1302 203.229 68.3802C204.589 68.7402 205.449 70.0002 206.829 70.2702C208.419 70.5802 210.149 70.3502 211.389 71.6302C211.779 72.0402 211.969 72.6802 212.439 73.0002C213.059 73.4102 213.979 73.4202 214.679 73.6702C216.269 74.2402 217.569 75.3802 219.129 75.9902C220.259 76.4402 221.999 75.9702 222.729 77.1402C223.149 77.8202 222.919 78.4502 222.789 79.1602C222.679 79.7802 222.899 80.3102 223.349 80.7502C224.569 81.9602 226.679 82.0002 226.769 84.0802C226.809 84.8202 226.699 85.5402 226.769 86.2902C226.879 87.3502 227.169 88.3902 227.489 89.4102C228.159 91.5802 229.029 93.7902 228.839 96.1002C228.649 92.5702 226.289 89.6702 225.699 86.2402C225.579 85.5102 225.699 84.7002 225.509 83.9902C225.309 83.2402 224.399 83.0902 223.769 82.8002C222.209 82.0802 220.799 80.7802 221.069 78.9102C221.089 78.7402 221.219 78.4102 221.109 78.2602C220.889 77.9902 219.779 78.1502 219.479 78.1102C217.549 77.7902 216.049 76.4802 214.249 75.8302C212.699 75.2602 211.149 75.3502 210.129 73.8302C209.649 73.1102 209.199 72.9102 208.339 72.8202C207.399 72.7202 206.439 72.7302 205.529 72.4302C204.499 72.0902 203.769 71.1502 202.769 70.8102C202.359 70.6702 202.099 70.8202 201.759 71.0602C201.129 71.5002 200.569 72.0202 199.809 72.2402C199.059 72.4602 198.309 72.3402 197.619 72.0002C197.069 71.7402 196.599 71.3202 195.979 71.2502C194.179 71.0402 192.439 72.7402 190.879 73.3802C190.069 73.7102 189.199 73.9102 188.319 73.8502C187.429 73.7902 186.629 73.4302 185.769 73.2702C185.369 73.2002 184.689 73.1102 184.419 73.4902C184.079 73.9702 184.319 74.9702 184.099 75.5402C183.589 76.8702 181.979 77.2202 180.789 77.6902C179.639 78.1402 178.349 78.4202 176.839 78.5302C176.179 78.5802 175.009 78.7402 174.789 79.5002C174.609 80.1302 174.819 81.7102 174.899 82.3402C174.999 83.1002 174.729 83.7302 174.159 84.2302C172.649 85.5502 170.049 86.3702 169.589 88.5802C169.389 89.5302 170.279 90.4502 169.899 91.3702C169.479 92.3902 168.629 93.5102 167.889 94.3102L167.869 94.3002Z"
        fill="url(#paint257_linear_1974_24988)"
      />
      <path
        d="M175.009 107.42C175.379 106.18 174.809 105.18 174.779 103.97C174.759 103.11 175.049 102.87 175.619 102.28C176.339 101.53 176.569 100.7 176.699 99.6602C176.859 98.4002 176.869 97.1002 177.539 95.9602C178.259 94.7302 180.389 94.0202 180.599 92.5302C180.719 91.6502 180.129 90.8402 180.599 89.9702C181.229 88.8102 182.579 88.9502 183.639 88.5602C184.679 88.1802 185.159 87.1402 185.909 86.3902C187.189 85.1102 189.169 84.7902 190.859 84.3202C193.999 83.4402 197.079 83.3202 200.209 84.2902C201.289 84.6302 201.999 84.9302 203.169 84.8402C204.689 84.7202 206.219 84.2702 207.759 84.4402C210.269 84.7102 211.939 86.9802 214.179 87.9302C215.829 88.6302 216.709 89.7802 217.109 91.4902C217.469 93.0002 217.569 93.4902 218.669 94.5002C220.939 96.5902 219.129 100.26 221.609 102.04C222.419 102.62 222.619 103.17 222.499 104.15C222.209 106.42 222.089 108.52 222.749 110.76C222.219 109.62 221.869 108.4 221.699 107.15C221.579 106.29 221.549 105.41 221.609 104.55C221.669 103.54 221.709 103.38 220.879 102.84C219.299 101.8 218.999 100.55 218.699 98.7102C218.499 97.4602 218.319 96.4402 217.309 95.6602C216.439 94.9902 215.989 94.5302 215.609 93.4902C215.269 92.5602 215.229 91.2802 214.479 90.5402C213.829 89.9002 212.579 89.7402 211.799 89.3002C210.459 88.5602 209.309 87.1302 207.759 86.8502C206.689 86.6602 205.519 87.0002 204.469 87.1502C202.649 87.4102 201.279 87.2102 199.559 86.6602C195.979 85.5102 192.829 86.2102 189.289 87.1202C188.549 87.3102 187.939 87.4602 187.359 87.9702C186.799 88.4702 186.399 89.1302 185.819 89.6202C185.249 90.0902 184.639 90.3702 183.929 90.5202C183.549 90.6002 182.779 90.5302 182.459 90.7802C182.289 90.9002 182.259 90.8902 182.179 91.0802C181.989 91.5602 182.339 92.4302 182.199 92.9802C182.099 93.3502 181.909 93.7102 181.689 94.0202C180.709 95.4002 178.899 95.8002 178.229 97.4202C177.729 98.6202 177.739 99.9502 177.259 101.16C176.909 102.05 176.399 102.32 175.769 102.94C175.549 103.15 175.429 103.21 175.299 103.51C174.769 104.74 175.629 106.11 175.029 107.43L175.009 107.42Z"
        fill="url(#paint258_linear_1974_24988)"
      />
      <path
        d="M221.259 450.75C221.259 450.75 231.669 468.35 234.499 470.76C237.329 473.18 257.609 534.16 257.609 534.16L253.709 533.47C253.709 533.47 234.329 481.21 232.109 476.44C229.889 471.67 223.059 455.67 221.249 450.74L221.259 450.75Z"
        fill="url(#paint259_linear_1974_24988)"
      />
      <path
        d="M188.189 452.16C188.189 452.16 192.189 509.71 190.209 539.37L187.539 540.16C187.539 540.16 186.489 479.73 185.299 467.76C184.839 463.14 188.189 452.15 188.189 452.15V452.16Z"
        fill="url(#paint260_linear_1974_24988)"
      />
      <path
        d="M190.51 533.8C190.51 533.8 192.09 537.36 186.96 539.63C181.82 541.9 176.28 541.33 175.33 540.84C174.38 540.34 173.11 538.73 172.68 536.52C172.68 536.52 172.96 538.73 176.28 539.12C179.6 539.51 185.02 538.6 187.11 537.35C188.8 536.34 190.28 535.11 190.51 533.81V533.8Z"
        fill="url(#paint261_linear_1974_24988)"
      />
      <path
        d="M172.699 536.65C172.699 536.65 173.519 540.12 177.529 540.12C181.539 540.12 189.979 539.18 190.499 533.79C190.499 533.79 191.439 535.3 191.569 538.56C191.699 541.82 183.859 544.5 180.239 544.36C177.119 544.24 171.699 544.36 172.699 536.65Z"
        fill="url(#paint262_linear_1974_24988)"
      />
      <path
        d="M252.659 530.65C252.659 530.65 253.319 536.13 258.219 535.31C263.119 534.49 269.939 531.23 270.299 526.93C270.299 526.93 269.029 531.38 258.169 532.87C254.509 533.37 252.659 530.66 252.659 530.66V530.65Z"
        fill="url(#paint263_linear_1974_24988)"
      />
      <path
        d="M252.659 530.65C252.659 530.65 253.619 533.88 257.609 534.16C261.599 534.44 269.809 530.67 270.309 526.93C270.309 526.93 272.489 531.9 270.759 533.89C269.029 535.88 264.109 539.45 258.409 538.7C254.129 538.14 252.959 535.01 252.829 533.59C252.699 532.17 252.669 530.65 252.669 530.65H252.659Z"
        fill="url(#paint264_linear_1974_24988)"
      />
      <path
        d="M252.51 567.01C252.51 567.01 251.72 574.73 251.72 576.03C251.72 577.33 253.83 581.54 257.3 582.15C260.24 582.67 271.89 582.96 274.84 581.42C276.4 580.6 277.86 577.53 277.86 576.33C277.86 574 277.86 570.52 277.86 570.52L252.53 567L252.51 567.01Z"
        fill="url(#paint265_linear_1974_24988)"
      />
      <path
        d="M272.319 544.18C272.319 544.18 274.609 555.4 274.839 557.32C275.069 559.24 277.579 564.95 277.809 568.49C278.039 572.03 277.399 574.95 272.409 576.25C266.929 577.68 259.019 576.91 255.979 575.1C253.709 573.75 252.439 570.75 252.669 566.16C252.899 561.57 255.649 557.88 255.979 542.02C255.979 542.02 257.469 537.22 264.779 537.56C272.089 537.9 272.319 544.18 272.319 544.18Z"
        fill="url(#paint266_linear_1974_24988)"
      />
      <path
        d="M271 542.93C270.67 542.39 270.78 541.31 269.17 540.07C266.79 538.24 260.72 539.24 260.01 539.67C259.27 540.12 257.37 541.73 257.08 542C256.79 542.26 259.7 555.93 258.59 562.22C258.41 563.25 273.18 563.03 273.25 562.52C273.31 562 270.03 547.13 269.96 545.95C269.9 544.77 270.94 543.23 271 542.94V542.93Z"
        fill="url(#paint267_linear_1974_24988)"
      />
      <path
        d="M269.46 544.11C269.46 544.11 268.73 543.5 268.4 543.73C268.07 543.96 266.54 547.3 266.54 547.3C266.54 547.3 269.96 558.39 273.37 564.73C273.3 563.19 271.84 558.23 271.78 557.85C271.71 557.47 269.46 544.11 269.46 544.11Z"
        fill="url(#paint268_linear_1974_24988)"
      />
      <path
        d="M272.3 544.79C272.3 544.79 268.96 543.5 268.69 543.27C268.42 543.04 267.26 545.46 267.26 547.15C267.26 548.84 273.36 564.74 273.36 564.74L272.29 544.79H272.3Z"
        fill="url(#paint269_linear_1974_24988)"
      />
      <path
        d="M259.77 543.26L260.28 543.46C260.28 543.46 260.69 546.94 260.57 547.45C260.31 548.55 259.76 559.46 257.91 564.86L259.77 543.27V543.26Z"
        fill="url(#paint270_linear_1974_24988)"
      />
      <path
        d="M255.949 543.49C255.949 543.49 260.039 542.74 260.239 542.89C260.439 543.04 259.969 546.23 259.969 547.07C259.969 547.91 258.509 565.04 257.509 565.88C256.519 566.72 255.939 543.49 255.939 543.49H255.949Z"
        fill="url(#paint271_linear_1974_24988)"
      />
      <path
        d="M271 557.44C267.57 559.63 263.48 559.88 260.16 562.32C259.29 562.96 258.49 561.37 259.36 560.74C262.7 558.29 266.77 558.05 270.2 555.86C271.1 555.29 271.9 556.87 271 557.44Z"
        fill="url(#paint272_linear_1974_24988)"
      />
      <path
        d="M271.76 562.78C269.64 561.77 267.54 560.65 265.37 559.79C263.56 559.07 261.61 559.02 259.9 558C258.99 557.46 259.79 555.87 260.7 556.42C262.46 557.47 264.69 557.53 266.57 558.36C268.45 559.19 270.3 560.13 272.17 561.02C273.1 561.47 272.69 563.24 271.75 562.79L271.76 562.78Z"
        fill="url(#paint273_linear_1974_24988)"
      />
      <path
        d="M268.8 552.65C266.6 554.72 264.54 556.41 261.71 557.14C260.71 557.4 260.29 555.63 261.29 555.37C263.85 554.71 265.69 553.22 267.68 551.35C268.47 550.61 269.6 551.9 268.81 552.65H268.8Z"
        fill="url(#paint274_linear_1974_24988)"
      />
      <path
        d="M269.21 557.18C267.77 556.18 266.15 555.85 264.59 555.17C263.21 554.58 262.09 553.44 260.73 552.87C259.77 552.47 260.19 550.7 261.15 551.1C262.7 551.75 263.95 552.99 265.53 553.61C267.07 554.21 268.61 554.62 270.01 555.6C270.89 556.21 270.09 557.79 269.21 557.18Z"
        fill="url(#paint275_linear_1974_24988)"
      />
      <path
        d="M267.39 548C266.41 548.83 265.46 549.42 264.33 549.93C263.19 550.44 262.24 551.41 261.04 551.74C260.04 552.01 259.62 550.24 260.62 549.97C261.65 549.69 262.51 548.8 263.5 548.34C264.64 547.81 265.6 547.26 266.58 546.42C267.4 545.72 268.2 547.31 267.38 548H267.39Z"
        fill="url(#paint276_linear_1974_24988)"
      />
      <path
        d="M268.05 551.93C265.54 551.2 263.21 549.96 261.12 548.2C260.3 547.51 261.09 545.92 261.92 546.62C263.92 548.29 266.08 549.46 268.47 550.16C269.46 550.45 269.04 552.22 268.05 551.93Z"
        fill="url(#paint277_linear_1974_24988)"
      />
      <path
        d="M273.43 562.28C270.82 563.1 268.16 563.92 265.44 563.9C262.75 563.89 260.08 563.07 257.45 562.48C256.45 562.25 256.87 560.48 257.87 560.71C260.36 561.27 262.89 562.05 265.43 562.06C268.02 562.07 270.52 561.28 273 560.5C273.99 560.19 274.41 561.96 273.42 562.27L273.43 562.28Z"
        fill="#2264A5"
      />
      <path
        d="M271.37 557.19C268.86 557.7 266.34 558.2 263.79 557.98C262.09 557.84 259.81 558.32 258.33 557.35C257.44 556.77 258.24 555.18 259.13 555.77C259.86 556.24 260.65 555.9 261.43 555.9C262.37 555.9 263.31 556.12 264.25 556.17C266.51 556.31 268.73 555.87 270.94 555.41C271.94 555.21 272.37 556.97 271.36 557.18L271.37 557.19Z"
        fill="#2264A5"
      />
      <path
        d="M269.54 551.84C266.08 553 262.58 553.79 259.21 551.86C258.29 551.33 259.1 549.75 260.01 550.28C262.95 551.96 266.12 551.08 269.11 550.07C270.1 549.74 270.52 551.51 269.53 551.84H269.54Z"
        fill="#2264A5"
      />
      <path
        d="M260.05 545.82C260.05 545.82 260.57 543.19 260.24 542.88C259.91 542.57 255.95 543.48 255.95 543.48C255.95 543.48 259.51 543.1 259.77 543.26C260.04 543.42 260.05 545.82 260.05 545.82Z"
        fill="url(#paint278_linear_1974_24988)"
      />
      <path
        d="M272.299 544.79C272.299 544.79 268.849 543.12 268.609 543.25C268.179 543.49 267.729 544.89 267.729 544.89C267.729 544.89 268.959 543.75 269.259 543.88C269.559 544.01 272.299 544.79 272.299 544.79Z"
        fill="url(#paint279_linear_1974_24988)"
      />
      <path
        d="M268.33 547.87C266.72 547.64 265.11 547.54 263.49 547.6C262.12 547.65 260.83 547.76 259.5 547.3C258.52 546.96 258.94 545.19 259.92 545.53C261.31 546.01 262.7 545.77 264.13 545.75C265.54 545.73 266.93 545.84 268.32 546.04C269.32 546.18 269.34 548.02 268.32 547.88L268.33 547.87Z"
        fill="#2264A5"
      />
      <path
        d="M277.85 576.34C277.85 576.34 277.68 580.6 274.82 581.72C270.41 583.44 258.16 583.3 255.01 581.72C253.45 580.94 251.72 579.39 251.72 576.2C251.72 576.2 252.48 580.54 255.98 581.35C261.99 582.75 270.14 582.37 274.3 581.1C276.28 580.49 277.52 577.93 277.85 576.34Z"
        fill="url(#paint280_linear_1974_24988)"
      />
      <path
        d="M277.81 570.17C277.81 570.17 277.51 573.58 275.05 574.86C271.04 576.95 258.24 577.52 254.68 573.71C252.9 571.81 252.66 569.72 252.66 566.17C252.66 566.17 251.09 572.64 255.09 575.2C258.65 577.48 270.19 578.11 275.17 575.88C278.36 574.45 277.81 570.18 277.81 570.18V570.17Z"
        fill="url(#paint281_linear_1974_24988)"
      />
      <path
        d="M164.11 213.1L157.51 169.49C157.51 169.49 152.08 169.16 147.29 177.56C142.5 185.96 138.39 198.36 138.39 198.36C138.39 198.36 148.84 206.7 164.11 213.09V213.1Z"
        fill="#2CB563"
      />
      <path
        d="M170.179 164.74C170.179 164.74 154.729 169.63 153.309 170.23C152.569 170.54 149.129 172.28 147.009 176.5C144.879 180.72 138.399 198.38 138.399 198.38C138.399 198.38 148.489 180.37 152.779 175.87C155.979 172.52 170.189 164.74 170.189 164.74H170.179Z"
        fill="url(#paint282_linear_1974_24988)"
      />
      <path
        d="M248.489 230.45C248.489 230.45 244.159 220.68 243.829 214.35C243.829 214.35 250.339 212.07 257.009 207.46C257.009 207.46 255.859 202.67 255.859 201.88L239.779 212.92C239.779 212.92 242.079 225.02 244.259 231.82L248.489 230.46V230.45Z"
        fill="url(#paint283_linear_1974_24988)"
      />
      <path
        d="M159.619 188.93C159.619 188.93 160.469 199.31 159.809 211.19C161.549 212.01 162.889 212.58 164.109 213.1L159.619 188.93Z"
        fill="#2CB563"
      />
      <path
        d="M239.34 213.1L245.94 169.49C245.94 169.49 251.37 169.16 256.16 177.56C260.95 185.96 265.06 198.36 265.06 198.36C265.06 198.36 254.61 206.7 239.34 213.09V213.1Z"
        fill="#2CB563"
      />
      <path
        d="M233.119 165.28C233.119 165.28 248.719 169.62 250.139 170.22C250.879 170.53 254.319 172.27 256.439 176.49C258.569 180.71 265.049 198.37 265.049 198.37C265.049 198.37 254.959 180.36 250.669 175.86C247.469 172.51 233.109 165.27 233.109 165.27L233.119 165.28Z"
        fill="url(#paint284_linear_1974_24988)"
      />
      <path
        d="M243.83 188.93C243.83 188.93 242.98 199.31 243.64 211.19C241.9 212.01 240.56 212.58 239.34 213.1L243.83 188.93Z"
        fill="#2CB563"
      />
      <path
        d="M232.949 248.7L239.339 213.1L242.579 196L231.229 237.45L232.949 248.7Z"
        fill="#2CB563"
      />
      <path
        d="M214.1 283.25C214.1 283.25 221.32 296.88 222.25 297.01C223.18 297.14 229.47 333.67 230.09 335.11C230.71 336.55 236.27 346.13 236.91 346.54C237.55 346.95 243.69 345.01 243.69 345.01L243.92 334.95L226.67 293.73L218.2 280.44L214.11 283.24L214.1 283.25Z"
        fill="url(#paint285_linear_1974_24988)"
      />
      <path
        d="M168.47 165.28L170.18 164.74L188.41 218.23L185.41 219.69C185.41 219.69 174.78 195.07 168.48 165.28H168.47Z"
        fill="url(#paint286_linear_1974_24988)"
      />
      <path
        d="M186.819 268.52L195.829 290.73C195.969 290.75 233.059 277.28 233.059 277.28C233.059 277.28 231.609 272.72 230.379 267.53C227.519 267.53 186.819 268.51 186.819 268.51V268.52Z"
        fill="url(#paint287_linear_1974_24988)"
      />
      <path
        d="M219.049 275.47C210.529 260.07 204.669 245.27 196.639 226.96C191.179 214.53 178.839 180.17 175.909 162.83L170.189 164.74C170.189 164.74 177.529 201.22 199.289 248.86C212.629 278.07 224.589 295.44 224.589 295.44L228.859 291.98C228.859 291.98 226.239 288.45 219.059 275.47H219.049Z"
        fill="#127869"
      />
      <path
        d="M242.39 269.35L221.77 204.73L172.87 221.21L171.04 221.9C171.04 221.9 168.95 222.48 169.47 223.22L170.31 223.69L193.23 287.15L242.38 269.34L242.39 269.35Z"
        fill="#BB0200"
      />
      <path
        d="M170.2 223.29C170.2 223.29 168.87 223.6 170.9 222.61C173.1 221.53 221.1 205.45 221.1 205.45L221.91 206.25L242.18 269.99L240.04 270.82L218.34 209.93L170.19 223.31L170.2 223.29Z"
        fill="url(#paint288_linear_1974_24988)"
      />
      <path
        d="M169.399 223.07C169.399 223.07 169.609 223.5 171.369 222.9C173.139 222.3 222.509 205.69 222.509 205.69L243.579 270.42L193.449 288.07L169.399 223.07Z"
        fill="#EFEFEF"
      />
      <path
        d="M181.01 254.47L177.47 244.84C177.47 244.84 179.22 243.86 181.5 244.04C183.77 244.23 188.19 243.6 188.63 243.53C189.07 243.46 198.95 250.69 200.28 250.37C201.61 250.04 214.71 248.69 234.07 241.22L241.28 263.37C241.28 263.37 228.61 265.33 223.71 265.26C220.02 265.21 209.97 265.23 204.03 267.26C202.15 267.9 189.74 271.77 187.26 271.35L181.01 254.49V254.47Z"
        fill="#EFEFEF"
      />
      <path
        d="M246.45 238.61C244.77 239.81 240.8 242.28 232.68 245.14C221.81 248.98 214.77 250.03 214.77 250.03L218.19 263.25C218.19 263.25 237.1 261.21 244.8 259.69C251.89 258.29 265.41 254.69 266.5 253.02C267.36 251.71 266.93 247.51 266.18 242.23C259.73 238.62 253.8 237.02 246.46 238.61H246.45Z"
        fill="#C57D4E"
      />
      <path
        d="M214.759 250.03C214.759 250.03 201.249 251.95 199.569 251.81C197.889 251.67 189.679 245.74 188.709 245.21C187.739 244.68 180.009 245.63 179.099 245.78C178.189 245.93 175.869 250.92 175.209 252.1C174.549 253.28 176.199 254.86 179.329 252.66C180.759 251.65 181.399 250.69 182.009 250.18C183.049 249.3 185.779 250.14 186.319 250.41C186.859 250.68 182.519 252.13 180.659 252.88C178.599 253.71 176.589 254.46 176.309 255.23C175.709 256.83 177.019 258.89 178.159 258.76C177.289 259.81 177.409 260.77 177.919 261.67C178.809 263.2 179.169 262.9 179.929 263.18C179.359 264.71 179.959 265.4 180.369 266.03C181.069 267.1 181.799 266.85 182.679 267.04C183.009 267.11 182.249 269.59 185.259 269.84C188.499 270.1 192.449 269.36 194.479 268.45C196.819 267.4 202.619 264.74 205.599 264.08C207.489 263.66 218.149 263.26 218.149 263.26L214.729 250.04L214.759 250.03Z"
        fill="#C57D4E"
      />
      <path
        d="M176.999 248.7C176.999 248.7 174.359 252.92 174.749 253.36C174.749 253.36 175.589 253.96 176.999 251.75C178.399 249.54 177.419 249.1 176.999 248.7Z"
        fill="#D59C74"
      />
      <path
        d="M177.64 247.58C177.64 247.58 178.56 245.95 179.04 245.78C179.57 245.59 187.59 244.64 188.64 245.11C189.68 245.58 193.07 248.11 193.07 248.11C193.07 248.11 189.61 246.07 188.25 245.65C186.89 245.23 179.69 246 179.25 246.21C178.81 246.42 177.64 247.58 177.64 247.58Z"
        fill="url(#paint289_linear_1974_24988)"
      />
      <path
        d="M193.52 248.42C193.52 248.42 198.46 251.72 199.57 251.81C200.68 251.9 212.55 250.27 214.76 250.03C214.76 250.03 202.32 254.01 200.48 253.51C198.64 253.01 193.52 248.42 193.52 248.42Z"
        fill="url(#paint290_linear_1974_24988)"
      />
      <path
        d="M189.209 252.17C189.209 252.17 178.709 253.46 178.549 254.75C178.389 256.04 178.949 257.5 179.609 257.76C180.049 257.94 180.939 257.92 182.009 257.79C181.069 258.12 180.439 258.48 180.409 258.85C180.309 260.02 180.849 261.31 181.489 261.58C181.879 261.74 182.369 261.83 182.939 261.86C182.939 261.86 182.939 261.87 182.939 261.88C182.319 264.7 185.059 264.71 185.719 264.95C185.779 264.97 185.839 264.99 185.899 265C185.879 265.04 185.859 265.08 185.859 265.11C185.699 266.4 186.129 266.98 186.779 267.27C192.319 269.76 197.579 265.48 197.579 265.48L189.209 252.16V252.17Z"
        fill="url(#paint291_linear_1974_24988)"
      />
      <path
        d="M195.6 267.97C195.6 267.97 201.18 263.55 203.73 263.13C206.27 262.71 217.08 263.3 217.08 263.3C217.08 263.3 205.98 264.15 205.31 264.21C204.41 264.29 195.6 267.98 195.6 267.98V267.97Z"
        fill="url(#paint292_linear_1974_24988)"
      />
      <path
        d="M177.6 253.58C178.49 253.31 180.18 252.35 181.2 251.08C182.22 249.8 182.99 249.63 184.51 249.94C186.03 250.25 186.33 250.4 186.29 250.53C186.25 250.66 179.54 253.34 179.54 253.34C179.54 253.34 186.56 251.67 188.02 250.38C189.48 249.09 186.4 249.1 185.47 249.02C184.54 248.94 181.69 249.89 181.19 249.9C181.19 249.9 178.6 253.19 177.6 253.58Z"
        fill="url(#paint293_linear_1974_24988)"
      />
      <path
        d="M177.209 258.39C177.319 258.48 177.719 258.78 178.119 258.78C178.119 258.78 177.819 259.09 177.669 259.6C177.669 259.6 179.019 258.63 180.179 258.46C180.179 258.46 177.869 258.62 177.209 258.39Z"
        fill="url(#paint294_linear_1974_24988)"
      />
      <path
        d="M178.829 262.79C179.199 263.04 179.929 263.18 179.929 263.18C179.929 263.18 179.589 264.11 179.729 264.59C179.729 264.59 180.319 262.95 181.139 262.7C181.139 262.7 179.689 262.97 178.829 262.79Z"
        fill="url(#paint295_linear_1974_24988)"
      />
      <path
        d="M181.209 266.76C181.569 266.91 182.159 267 182.679 267.05C182.679 267.05 182.739 267.59 182.929 268.14C182.929 268.14 182.799 267.12 184.019 266.49C184.019 266.49 182.999 266.88 181.209 266.76Z"
        fill="url(#paint296_linear_1974_24988)"
      />
      <path
        d="M218.189 263.24C218.189 263.24 227.259 262.64 234.029 261.94C240.799 261.25 249.729 260.61 265.919 254.28C267.859 253.52 266.539 244.96 266.539 244.96C266.539 244.96 266.599 251.01 263.049 252.32C256.699 254.65 245.769 259.6 218.199 263.24H218.189Z"
        fill="url(#paint297_linear_1974_24988)"
      />
      <path
        d="M219.229 250.39C219.229 250.39 258.169 240.27 261.149 242.16C264.129 244.05 263.149 249.38 246.009 251.98C228.869 254.58 219.24 250.39 219.24 250.39H219.229Z"
        fill="url(#paint298_linear_1974_24988)"
      />
      <path
        d="M229.859 246.1C236.329 244.75 253.109 239.5 253.109 239.5C251.459 237.27 249.979 234.16 248.489 230.45C246.959 230.94 246.109 231.22 244.259 231.81C245.319 235.28 246.239 238.12 246.239 238.12C240.029 242.78 229.859 246.1 229.859 246.1Z"
        fill="url(#paint299_linear_1974_24988)"
      />
      <path
        d="M224.579 295.44C224.579 295.44 229.319 324.82 231.569 332.49C233.509 339.1 237.569 344.34 237.569 344.34L253.949 341.44C253.949 341.44 244.019 303.55 228.839 291.98L224.569 295.44H224.579Z"
        fill="#127869"
      />
      <path
        d="M228.85 291.97L248.25 327.1L253.95 341.43C253.95 341.43 275.81 331.66 276.97 329.26C278.13 326.86 276.97 311.28 276.97 311.28L251.55 276.82L246.55 278.23L228.85 291.96V291.97Z"
        fill="url(#paint300_linear_1974_24988)"
      />
      <path
        d="M228.85 291.97C228.85 291.97 244.17 286.36 251.56 276.83C251.56 276.83 264.8 289.86 267.27 291.97C269.74 294.08 279.19 313.67 279.07 316.64C278.94 319.61 260.76 336.44 258.72 334.52C256.68 332.61 242.66 307.69 241.41 304.48C240.16 301.27 228.86 291.96 228.86 291.96L228.85 291.97Z"
        fill="#127869"
      />
      <path
        d="M253.949 341.44C253.949 341.44 247.669 326.07 247.349 325.49C247.029 324.91 230.079 294.23 230.079 294.23L253.939 341.44H253.949Z"
        fill="url(#paint301_linear_1974_24988)"
      />
      <path
        d="M269.949 295.92C269.949 295.92 278.919 311.98 279.059 316.64C279.119 318.73 263.159 334.96 259.239 334.96C258.019 334.96 252.689 325.05 252.689 325.05L269.949 295.91V295.92Z"
        fill="url(#paint302_linear_1974_24988)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1974_24988"
          x1="661.97"
          y1="208.8"
          x2="681.63"
          y2="223.11"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1974_24988"
          x1="591.49"
          y1="178.43"
          x2="587.25"
          y2="2.20032"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#492219" />
          <stop offset="0.4" stopColor="#4C231A" />
          <stop offset="0.73" stopColor="#56281D" />
          <stop offset={1} stopColor="#652F23" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1974_24988"
          x1="606.402"
          y1="66.4952"
          x2="607.353"
          y2="141.442"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6B3329" />
          <stop offset="0.3" stopColor="#663026" />
          <stop offset="0.64" stopColor="#592A20" />
          <stop offset="0.98" stopColor="#431F16" />
          <stop offset={1} stopColor="#421F16" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1974_24988"
          x1="626.059"
          y1="130.873"
          x2="644.377"
          y2="73.8663"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#492219" />
          <stop offset="0.4" stopColor="#4C231A" />
          <stop offset="0.73" stopColor="#56281D" />
          <stop offset={1} stopColor="#652F23" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1974_24988"
          x1="596.22"
          y1="172.61"
          x2="589.28"
          y2="71.7902"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#421F16" />
          <stop offset="0.45" stopColor="#51261D" />
          <stop offset={1} stopColor="#6B3329" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1974_24988"
          x1="603.1"
          y1="146.33"
          x2="626.06"
          y2="171.32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1974_24988"
          x1="599.72"
          y1="165.06"
          x2="620.09"
          y2="168.06"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1974_24988"
          x1="615.53"
          y1="164.35"
          x2="644.42"
          y2="159.84"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_1974_24988"
          x1="613.89"
          y1="165.81"
          x2="588.54"
          y2="159.16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_1974_24988"
          x1="612.06"
          y1="138.61"
          x2="615.38"
          y2="152.68"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_1974_24988"
          x1="579.33"
          y1="227.11"
          x2="559.74"
          y2="147.27"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_1974_24988"
          x1="604.89"
          y1="272.96"
          x2="609.14"
          y2="277.11"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#171921" />
          <stop offset={1} stopColor="#23252C" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_1974_24988"
          x1="602.539"
          y1="267.22"
          x2="606.449"
          y2="275.48"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#23252C" />
          <stop offset={1} stopColor="#33353C" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_1974_24988"
          x1="637.28"
          y1="291.26"
          x2="647.5"
          y2="277.66"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#171921" />
          <stop offset={1} stopColor="#23252C" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_1974_24988"
          x1="577.16"
          y1="287.86"
          x2="571.47"
          y2="271.76"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#171921" />
          <stop offset={1} stopColor="#23252C" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_1974_24988"
          x1="623.53"
          y1="271.32"
          x2="618.58"
          y2={291}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#171921" />
          <stop offset={1} stopColor="#23252C" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_1974_24988"
          x1="593.55"
          y1="270.29"
          x2="597.5"
          y2={291}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#171921" />
          <stop offset={1} stopColor="#23252C" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_1974_24988"
          x1="610.37"
          y1="279.62"
          x2={609}
          y2="321.29"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#171921" />
          <stop offset={1} stopColor="#23252C" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_1974_24988"
          x1="590.34"
          y1="273.01"
          x2="577.43"
          y2="284.54"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#171921" />
          <stop offset={1} stopColor="#23252C" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_1974_24988"
          x1="629.46"
          y1="278.88"
          x2={628}
          y2="287.16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#171921" />
          <stop offset={1} stopColor="#23252C" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_1974_24988"
          x1="638.91"
          y1="271.87"
          x2="640.92"
          y2="295.43"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#23252C" />
          <stop offset={1} stopColor="#33353C" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_1974_24988"
          x1="576.7"
          y1="269.96"
          x2="574.84"
          y2="291.69"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#23252C" />
          <stop offset={1} stopColor="#33353C" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_1974_24988"
          x1="605.88"
          y1="261.98"
          x2="607.43"
          y2="280.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#23252C" />
          <stop offset={1} stopColor="#33353C" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_1974_24988"
          x1="606.67"
          y1="271.8"
          x2="609.36"
          y2="303.2"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#23252C" />
          <stop offset={1} stopColor="#33353C" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_1974_24988"
          x1="621.24"
          y1="268.75"
          x2="623.6"
          y2="307.21"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#171921" />
          <stop offset={1} stopColor="#23252C" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_1974_24988"
          x1="626.01"
          y1="268.41"
          x2="627.35"
          y2="290.24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#171921" />
          <stop offset={1} stopColor="#23252C" />
        </linearGradient>
        <linearGradient
          id="paint26_linear_1974_24988"
          x1="585.1"
          y1="266.39"
          x2="586.54"
          y2="289.77"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#171921" />
          <stop offset={1} stopColor="#23252C" />
        </linearGradient>
        <linearGradient
          id="paint27_linear_1974_24988"
          x1="589.91"
          y1="270.95"
          x2="592.25"
          y2="309.02"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#171921" />
          <stop offset={1} stopColor="#23252C" />
        </linearGradient>
        <linearGradient
          id="paint28_linear_1974_24988"
          x1="588.52"
          y1="252.45"
          x2="588.14"
          y2="276.91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#171921" />
          <stop offset={1} stopColor="#23252C" />
        </linearGradient>
        <linearGradient
          id="paint29_linear_1974_24988"
          x1="586.93"
          y1="260.69"
          x2="588.78"
          y2="282.34"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#23252C" />
          <stop offset={1} stopColor="#33353C" />
        </linearGradient>
        <linearGradient
          id="paint30_linear_1974_24988"
          x1="624.48"
          y1="253.61"
          x2="624.11"
          y2="277.59"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#171921" />
          <stop offset={1} stopColor="#23252C" />
        </linearGradient>
        <linearGradient
          id="paint31_linear_1974_24988"
          x1="622.5"
          y1="260.8"
          x2="624.59"
          y2="285.27"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#23252C" />
          <stop offset={1} stopColor="#33353C" />
        </linearGradient>
        <linearGradient
          id="paint32_linear_1974_24988"
          x1="600.38"
          y1="292.91"
          x2="601.89"
          y2="292.91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#171921" />
          <stop offset={1} stopColor="#23252C" />
        </linearGradient>
        <linearGradient
          id="paint33_linear_1974_24988"
          x1="615.34"
          y1="151.28"
          x2="615.13"
          y2="175.34"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E1E1E5" />
          <stop offset={1} stopColor="#F1F0F5" />
        </linearGradient>
        <linearGradient
          id="paint34_linear_1974_24988"
          x1="585.03"
          y1="104.54"
          x2="588.25"
          y2="124.29"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#421F16" />
          <stop offset="0.95" stopColor="#683127" />
          <stop offset={1} stopColor="#6B3329" />
        </linearGradient>
        <linearGradient
          id="paint35_linear_1974_24988"
          x1="586.58"
          y1="191.65"
          x2="587.28"
          y2="216.15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint36_linear_1974_24988"
          x1="640.26"
          y1="191.65"
          x2="639.56"
          y2="216.15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint37_linear_1974_24988"
          x1="613.5"
          y1="78.1501"
          x2="613.39"
          y2="149.18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset="0.32" stopColor="#F9D5AD" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint38_linear_1974_24988"
          x1="628.1"
          y1="120.82"
          x2="624.95"
          y2="103.34"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.52" stopColor="#F5D1A8" />
          <stop offset="0.85" stopColor="#F2C99F" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint39_linear_1974_24988"
          x1="601.1"
          y1="123.88"
          x2="597.73"
          y2="103.03"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.52" stopColor="#F5D1A8" />
          <stop offset="0.85" stopColor="#F2C99F" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <radialGradient
          id="paint40_radial_1974_24988"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(595.241 124.46) scale(10.8309 13.71)"
        >
          <stop stopColor="#F9B38E" />
          <stop offset="0.61" stopColor="#F7C59E" />
          <stop offset={1} stopColor="#F7D4AB" />
        </radialGradient>
        <radialGradient
          id="paint41_radial_1974_24988"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(633.68 0.500276) rotate(180) scale(10.8309 13.71)"
        >
          <stop stopColor="#F9B38E" />
          <stop offset="0.61" stopColor="#F7C59E" />
          <stop offset={1} stopColor="#F7D4AB" />
        </radialGradient>
        <linearGradient
          id="paint42_linear_1974_24988"
          x1="607.17"
          y1="142.91"
          x2="618.34"
          y2="142.91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset="0.68" stopColor="#FCD7B0" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint43_linear_1974_24988"
          x1="613.25"
          y1="71.1602"
          x2="613.13"
          y2="113.88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.97" stopColor="#F0C499" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint44_linear_1974_24988"
          x1="628.29"
          y1="106.47"
          x2="638.46"
          y2="106.47"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset="0.68" stopColor="#FCD7B0" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint45_linear_1974_24988"
          x1="624.46"
          y1="144.42"
          x2="628.62"
          y2="67.6402"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.51" stopColor="#E3B086" />
          <stop offset={1} stopColor="#DBA379" />
        </linearGradient>
        <linearGradient
          id="paint46_linear_1974_24988"
          x1="613.54"
          y1="142.36"
          x2="612.49"
          y2="157.54"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint47_linear_1974_24988"
          x1="620.07"
          y1="102.13"
          x2="636.26"
          y2="102.13"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#673024" />
          <stop offset="0.34" stopColor="#52261C" />
          <stop offset="0.68" stopColor="#462017" />
          <stop offset={1} stopColor="#421F16" />
        </linearGradient>
        <linearGradient
          id="paint48_linear_1974_24988"
          x1="606.07"
          y1="0.000274681"
          x2="589.91"
          y2="0.000274681"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#673024" />
          <stop offset="0.34" stopColor="#52261C" />
          <stop offset="0.68" stopColor="#462017" />
          <stop offset={1} stopColor="#421F16" />
        </linearGradient>
        <linearGradient
          id="paint49_linear_1974_24988"
          x1="669.26"
          y1="233.34"
          x2="665.01"
          y2="214.48"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C699" />
          <stop offset="0.5" stopColor="#E4B386" />
          <stop offset={1} stopColor="#DBA679" />
        </linearGradient>
        <linearGradient
          id="paint50_linear_1974_24988"
          x1="658.46"
          y1="214.65"
          x2="658.64"
          y2="236.26"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F0F5" />
          <stop offset={1} stopColor="#E1E1E5" />
        </linearGradient>
        <linearGradient
          id="paint51_linear_1974_24988"
          x1="624.019"
          y1={215}
          x2="620.579"
          y2="71.7403"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6B3329" />
          <stop offset="0.3" stopColor="#663026" />
          <stop offset="0.64" stopColor="#592A20" />
          <stop offset="0.98" stopColor="#431F16" />
          <stop offset={1} stopColor="#421F16" />
        </linearGradient>
        <linearGradient
          id="paint52_linear_1974_24988"
          x1="616.689"
          y1="161.69"
          x2="648.859"
          y2="31.4003"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6B3329" />
          <stop offset="0.3" stopColor="#663026" />
          <stop offset="0.64" stopColor="#592A20" />
          <stop offset="0.98" stopColor="#431F16" />
          <stop offset={1} stopColor="#421F16" />
        </linearGradient>
        <linearGradient
          id="paint53_linear_1974_24988"
          x1="658.719"
          y1="194.95"
          x2="635.139"
          y2="111.95"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#421F16" />
          <stop offset="0.02" stopColor="#431F16" />
          <stop offset="0.36" stopColor="#592A20" />
          <stop offset="0.7" stopColor="#663026" />
          <stop offset={1} stopColor="#6B3329" />
        </linearGradient>
        <linearGradient
          id="paint54_linear_1974_24988"
          x1="592.22"
          y1="183.78"
          x2="595.24"
          y2="70.4402"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#421F16" />
          <stop offset="0.45" stopColor="#51261D" />
          <stop offset={1} stopColor="#6B3329" />
        </linearGradient>
        <linearGradient
          id="paint55_linear_1974_24988"
          x1="594.719"
          y1="113.38"
          x2="590.439"
          y2="163.4"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#421F16" />
          <stop offset="0.95" stopColor="#683127" />
          <stop offset={1} stopColor="#6B3329" />
        </linearGradient>
        <linearGradient
          id="paint56_linear_1974_24988"
          x1="652.51"
          y1="218.15"
          x2="623.96"
          y2="57.7502"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6B3329" />
          <stop offset={1} stopColor="#421F16" />
        </linearGradient>
        <linearGradient
          id="paint57_linear_1974_24988"
          x1="646.67"
          y1="189.97"
          x2="615.85"
          y2="81.4803"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6B3329" />
          <stop offset={1} stopColor="#421F16" />
        </linearGradient>
        <linearGradient
          id="paint58_linear_1974_24988"
          x1="599.53"
          y1="184.48"
          x2="591.67"
          y2="60.5302"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6B3329" />
          <stop offset="0.3" stopColor="#663026" />
          <stop offset="0.64" stopColor="#592A20" />
          <stop offset="0.98" stopColor="#431F16" />
          <stop offset={1} stopColor="#421F16" />
        </linearGradient>
        <linearGradient
          id="paint59_linear_1974_24988"
          x1="617.98"
          y1="74.2702"
          x2="615.92"
          y2="67.0102"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#421F16" />
          <stop offset="0.02" stopColor="#431F16" />
          <stop offset="0.36" stopColor="#592A20" />
          <stop offset="0.7" stopColor="#663026" />
          <stop offset={1} stopColor="#6B3329" />
        </linearGradient>
        <linearGradient
          id="paint60_linear_1974_24988"
          x1="582.11"
          y1="174.51"
          x2={600}
          y2="36.3503"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6B3329" />
          <stop offset="0.3" stopColor="#663026" />
          <stop offset="0.64" stopColor="#592A20" />
          <stop offset="0.98" stopColor="#431F16" />
          <stop offset={1} stopColor="#421F16" />
        </linearGradient>
        <linearGradient
          id="paint61_linear_1974_24988"
          x1="646.989"
          y1="153.23"
          x2="667.059"
          y2="71.9403"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6B3329" />
          <stop offset="0.3" stopColor="#663026" />
          <stop offset="0.64" stopColor="#592A20" />
          <stop offset="0.98" stopColor="#431F16" />
          <stop offset={1} stopColor="#421F16" />
        </linearGradient>
        <linearGradient
          id="paint62_linear_1974_24988"
          x1="653.02"
          y1="159.62"
          x2="634.63"
          y2="94.8501"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#421F16" />
          <stop offset="0.02" stopColor="#431F16" />
          <stop offset="0.36" stopColor="#592A20" />
          <stop offset="0.7" stopColor="#663026" />
          <stop offset={1} stopColor="#6B3329" />
        </linearGradient>
        <linearGradient
          id="paint63_linear_1974_24988"
          x1="518.747"
          y1="172.627"
          x2="532.685"
          y2="172.04"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D5AB" />
          <stop offset="0.15" stopColor="#F4CFA4" />
          <stop offset="0.48" stopColor="#F1C89B" />
          <stop offset={1} stopColor="#F0C699" />
        </linearGradient>
        <linearGradient
          id="paint64_linear_1974_24988"
          x1="537.949"
          y1="185.47"
          x2="545.359"
          y2="176.31"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C699" />
          <stop offset="0.52" stopColor="#F1C89B" />
          <stop offset="0.85" stopColor="#F4CFA4" />
          <stop offset={1} stopColor="#F7D5AB" />
        </linearGradient>
        <linearGradient
          id="paint65_linear_1974_24988"
          x1="546.917"
          y1="185.353"
          x2="525.431"
          y2="185.647"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C699" />
          <stop offset="0.52" stopColor="#F1C89B" />
          <stop offset="0.85" stopColor="#F4CFA4" />
          <stop offset={1} stopColor="#F7D5AB" />
        </linearGradient>
        <linearGradient
          id="paint66_linear_1974_24988"
          x1="546.775"
          y1="191.255"
          x2="526.078"
          y2="191.525"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C699" />
          <stop offset="0.52" stopColor="#F1C89B" />
          <stop offset="0.85" stopColor="#F4CFA4" />
          <stop offset={1} stopColor="#F7D5AB" />
        </linearGradient>
        <linearGradient
          id="paint67_linear_1974_24988"
          x1="519.835"
          y1="170.659"
          x2="537.979"
          y2="169.896"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDAB3" />
          <stop offset={1} stopColor="#F7D5AB" />
        </linearGradient>
        <linearGradient
          id="paint68_linear_1974_24988"
          x1="538.099"
          y1="173.694"
          x2="543.315"
          y2="173.474"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDAB3" />
          <stop offset={1} stopColor="#F7D5AB" />
        </linearGradient>
        <linearGradient
          id="paint69_linear_1974_24988"
          x1="526.63"
          y1="190.851"
          x2="530.137"
          y2="190.704"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDAB3" />
          <stop offset={1} stopColor="#F7D5AB" />
        </linearGradient>
        <linearGradient
          id="paint70_linear_1974_24988"
          x1="531.764"
          y1="186.772"
          x2="545.841"
          y2="186.179"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDAB3" />
          <stop offset={1} stopColor="#F7D5AB" />
        </linearGradient>
        <linearGradient
          id="paint71_linear_1974_24988"
          x1="527.063"
          y1="186.379"
          x2="529.85"
          y2="186.262"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDAB3" />
          <stop offset={1} stopColor="#F7D5AB" />
        </linearGradient>
        <linearGradient
          id="paint72_linear_1974_24988"
          x1="527.811"
          y1="195.836"
          x2="530.679"
          y2="195.715"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDAB3" />
          <stop offset={1} stopColor="#F7D5AB" />
        </linearGradient>
        <linearGradient
          id="paint73_linear_1974_24988"
          x1="535.438"
          y1="192.502"
          x2="546.528"
          y2="192.036"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDAB3" />
          <stop offset={1} stopColor="#F7D5AB" />
        </linearGradient>
        <linearGradient
          id="paint74_linear_1974_24988"
          x1="544.63"
          y1="205.84"
          x2="537.99"
          y2="189.95"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D5AB" />
          <stop offset="0.29" stopColor="#F5D1A7" />
          <stop offset="0.54" stopColor="#F1C89C" />
          <stop offset="0.55" stopColor="#F1C89C" />
        </linearGradient>
        <linearGradient
          id="paint75_linear_1974_24988"
          x1="534.686"
          y1="212.702"
          x2="546.396"
          y2="212.209"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C699" />
          <stop offset="0.52" stopColor="#F1C89B" />
          <stop offset="0.85" stopColor="#F4CFA4" />
          <stop offset={1} stopColor="#F7D5AB" />
        </linearGradient>
        <linearGradient
          id="paint76_linear_1974_24988"
          x1="533.02"
          y1="203.89"
          x2="545.57"
          y2="203.89"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D5AB" />
          <stop offset={1} stopColor="#FFDAB3" />
        </linearGradient>
        <linearGradient
          id="paint77_linear_1974_24988"
          x1="530.969"
          y1="182.52"
          x2="536.459"
          y2="178.47"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C699" />
          <stop offset="0.52" stopColor="#F1C89B" />
          <stop offset="0.85" stopColor="#F4CFA4" />
          <stop offset={1} stopColor="#F7D5AB" />
        </linearGradient>
        <linearGradient
          id="paint78_linear_1974_24988"
          x1="540.56"
          y1="182.29"
          x2="543.72"
          y2="179.97"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D5AB" />
          <stop offset="0.15" stopColor="#F4CFA4" />
          <stop offset="0.48" stopColor="#F1C89B" />
          <stop offset={1} stopColor="#F0C699" />
        </linearGradient>
        <linearGradient
          id="paint79_linear_1974_24988"
          x1="531.324"
          y1="180.144"
          x2="542.854"
          y2="179.659"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDAB3" />
          <stop offset={1} stopColor="#F7D5AB" />
        </linearGradient>
        <linearGradient
          id="paint80_linear_1974_24988"
          x1="540.82"
          y1="198.58"
          x2="537.1"
          y2="189.68"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C699" />
          <stop offset="0.5" stopColor="#E4B386" />
          <stop offset={1} stopColor="#DBA679" />
        </linearGradient>
        <linearGradient
          id="paint81_linear_1974_24988"
          x1="548.195"
          y1="196.209"
          x2="525.617"
          y2="196.509"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C699" />
          <stop offset="0.52" stopColor="#F1C89B" />
          <stop offset="0.85" stopColor="#F4CFA4" />
          <stop offset={1} stopColor="#F7D5AB" />
        </linearGradient>
        <linearGradient
          id="paint82_linear_1974_24988"
          x1="546.92"
          y1="266.32"
          x2="562.72"
          y2="226.56"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint83_linear_1974_24988"
          x1="559.88"
          y1="229.38"
          x2="568.89"
          y2="236.14"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint84_linear_1974_24988"
          x1="615.125"
          y1="201.7"
          x2="624.786"
          y2="201.293"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C699" />
          <stop offset="0.52" stopColor="#F1C89B" />
          <stop offset="0.85" stopColor="#F4CFA4" />
          <stop offset={1} stopColor="#F7D5AB" />
        </linearGradient>
        <linearGradient
          id="paint85_linear_1974_24988"
          x1="622.05"
          y1="199.51"
          x2="621.85"
          y2="202.22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA679" />
          <stop offset="0.5" stopColor="#E4B386" />
          <stop offset={1} stopColor="#F0C699" />
        </linearGradient>
        <linearGradient
          id="paint86_linear_1974_24988"
          x1="602.792"
          y1="186.184"
          x2="615.56"
          y2="185.647"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C699" />
          <stop offset="0.52" stopColor="#F1C89B" />
          <stop offset="0.85" stopColor="#F4CFA4" />
          <stop offset={1} stopColor="#F7D5AB" />
        </linearGradient>
        <linearGradient
          id="paint87_linear_1974_24988"
          x1="601.16"
          y1="170.36"
          x2="642.36"
          y2="202.84"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C699" />
          <stop offset="0.5" stopColor="#E4B386" />
          <stop offset={1} stopColor="#DBA679" />
        </linearGradient>
        <linearGradient
          id="paint88_linear_1974_24988"
          x1="611.856"
          y1="188.956"
          x2="625.434"
          y2="188.384"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C699" />
          <stop offset="0.52" stopColor="#F1C89B" />
          <stop offset="0.85" stopColor="#F4CFA4" />
          <stop offset={1} stopColor="#F7D5AB" />
        </linearGradient>
        <linearGradient
          id="paint89_linear_1974_24988"
          x1="613.189"
          y1="194.464"
          x2="626.178"
          y2="193.918"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C699" />
          <stop offset="0.52" stopColor="#F1C89B" />
          <stop offset="0.85" stopColor="#F4CFA4" />
          <stop offset={1} stopColor="#F7D5AB" />
        </linearGradient>
        <linearGradient
          id="paint90_linear_1974_24988"
          x1="628.56"
          y1="209.612"
          x2="641.458"
          y2="209.069"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C699" />
          <stop offset="0.52" stopColor="#F1C89B" />
          <stop offset="0.85" stopColor="#F4CFA4" />
          <stop offset={1} stopColor="#F7D5AB" />
        </linearGradient>
        <linearGradient
          id="paint91_linear_1974_24988"
          x1="598.096"
          y1="175.923"
          x2="627.67"
          y2="174.678"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDAB3" />
          <stop offset={1} stopColor="#F7D5AB" />
        </linearGradient>
        <linearGradient
          id="paint92_linear_1974_24988"
          x1="615.029"
          y1="188.252"
          x2="626.2"
          y2="187.782"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDAB3" />
          <stop offset={1} stopColor="#F7D5AB" />
        </linearGradient>
        <linearGradient
          id="paint93_linear_1974_24988"
          x1="616.75"
          y1="193.944"
          x2="628.24"
          y2="193.461"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDAB3" />
          <stop offset={1} stopColor="#F7D5AB" />
        </linearGradient>
        <linearGradient
          id="paint94_linear_1974_24988"
          x1="630.127"
          y1="193.351"
          x2="648.741"
          y2="192.568"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDAB3" />
          <stop offset={1} stopColor="#F7D5AB" />
        </linearGradient>
        <linearGradient
          id="paint95_linear_1974_24988"
          x1="630.42"
          y1="201.57"
          x2="616.78"
          y2="199.85"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C699" />
          <stop offset="0.52" stopColor="#F1C89B" />
          <stop offset="0.85" stopColor="#F4CFA4" />
          <stop offset={1} stopColor="#F7D5AB" />
        </linearGradient>
        <linearGradient
          id="paint96_linear_1974_24988"
          x1="627.29"
          y1="179.68"
          x2="608.81"
          y2="185.31"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C699" />
          <stop offset="0.5" stopColor="#E4B386" />
          <stop offset={1} stopColor="#DBA679" />
        </linearGradient>
        <linearGradient
          id="paint97_linear_1974_24988"
          x1="615.931"
          y1="181.368"
          x2="628.689"
          y2="180.831"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDAB3" />
          <stop offset={1} stopColor="#F7D5AB" />
        </linearGradient>
        <linearGradient
          id="paint98_linear_1974_24988"
          x1="638.99"
          y1="217.65"
          x2="688.67"
          y2="241.07"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset="0.68" stopColor="#FCD7B0" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint99_linear_1974_24988"
          x1="626.49"
          y1="199.4"
          x2="665.67"
          y2="258.56"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint100_linear_1974_24988"
          x1="558.72"
          y1="235.54"
          x2="547.3"
          y2="224.04"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset="0.68" stopColor="#FCD7B0" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint101_linear_1974_24988"
          x1="633.8"
          y1="108.81"
          x2="619.18"
          y2="114.48"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint102_linear_1974_24988"
          x1="619.52"
          y1="112.21"
          x2={624}
          y2="112.21"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.47" stopColor="#FCFCFC" />
          <stop offset="0.77" stopColor="#F5F3F3" />
          <stop offset={1} stopColor="#ECE7E7" />
        </linearGradient>
        <linearGradient
          id="paint103_linear_1974_24988"
          x1="629.45"
          y1="112.08"
          x2="633.01"
          y2="112.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.47" stopColor="#FCFCFC" />
          <stop offset="0.77" stopColor="#F5F3F3" />
          <stop offset={1} stopColor="#ECE7E7" />
        </linearGradient>
        <linearGradient
          id="paint104_linear_1974_24988"
          x1="631.8"
          y1="116.05"
          x2="621.33"
          y2="109.51"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B89C8C" />
          <stop offset={1} stopColor="#715241" />
        </linearGradient>
        <linearGradient
          id="paint105_linear_1974_24988"
          x1="640.48"
          y1="112.32"
          x2="626.88"
          y2="110.71"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B89C8C" />
          <stop offset={1} stopColor="#715241" />
        </linearGradient>
        <radialGradient
          id="paint106_radial_1974_24988"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(625.72 112.29) scale(3.06)"
        >
          <stop stopColor="#2A3A3B" />
          <stop offset={1} stopColor="#1C2727" />
        </radialGradient>
        <linearGradient
          id="paint107_linear_1974_24988"
          x1="619.53"
          y1="111.76"
          x2={636}
          y2="111.76"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5A2A1F" />
          <stop offset="0.29" stopColor="#492219" />
          <stop offset="0.66" stopColor="#3D1C14" />
          <stop offset={1} stopColor="#391B13" />
        </linearGradient>
        <linearGradient
          id="paint108_linear_1974_24988"
          x1="626.68"
          y1="107.19"
          x2="615.78"
          y2="121.06"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint109_linear_1974_24988"
          x1="592.93"
          y1="108.81"
          x2="607.55"
          y2="114.48"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint110_linear_1974_24988"
          x1="607.21"
          y1="0.000259355"
          x2="602.73"
          y2="0.000259355"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.47" stopColor="#FCFCFC" />
          <stop offset="0.77" stopColor="#F5F3F3" />
          <stop offset={1} stopColor="#ECE7E7" />
        </linearGradient>
        <linearGradient
          id="paint111_linear_1974_24988"
          x1="597.28"
          y1="112.08"
          x2="593.72"
          y2="112.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.47" stopColor="#FCFCFC" />
          <stop offset="0.77" stopColor="#F5F3F3" />
          <stop offset={1} stopColor="#ECE7E7" />
        </linearGradient>
        <linearGradient
          id="paint112_linear_1974_24988"
          x1="594.93"
          y1="116.05"
          x2="605.4"
          y2="109.51"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#715241" />
          <stop offset={1} stopColor="#B89C8C" />
        </linearGradient>
        <linearGradient
          id="paint113_linear_1974_24988"
          x1="586.25"
          y1="112.32"
          x2="599.85"
          y2="110.71"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B89C8C" />
          <stop offset={1} stopColor="#715241" />
        </linearGradient>
        <radialGradient
          id="paint114_radial_1974_24988"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(601.01 0.500254) rotate(-180) scale(3.06)"
        >
          <stop stopColor="#2A3A3B" />
          <stop offset={1} stopColor="#1C2727" />
        </radialGradient>
        <linearGradient
          id="paint115_linear_1974_24988"
          x1="607.2"
          y1="0.000127119"
          x2="590.73"
          y2="0.000127119"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5A2A1F" />
          <stop offset="0.29" stopColor="#492219" />
          <stop offset="0.66" stopColor="#3D1C14" />
          <stop offset={1} stopColor="#391B13" />
        </linearGradient>
        <linearGradient
          id="paint116_linear_1974_24988"
          x1="600.05"
          y1="107.19"
          x2="610.95"
          y2="121.06"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint117_linear_1974_24988"
          x1="597.44"
          y1="127.45"
          x2="603.17"
          y2="132.45"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.51" stopColor="#E3B086" />
          <stop offset={1} stopColor="#DBA379" />
        </linearGradient>
        <linearGradient
          id="paint118_linear_1974_24988"
          x1="627.2"
          y1="128.43"
          x2="623.95"
          y2="132.45"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint119_linear_1974_24988"
          x1="613.71"
          y1="131.07"
          x2="613.4"
          y2="140.32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint120_linear_1974_24988"
          x1="628.982"
          y1="125.88"
          x2="613.993"
          y2="126.616"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E8D8D7" />
          <stop offset="0.14" stopColor="#EFE4E4" />
          <stop offset="0.39" stopColor="#FAF8F7" />
          <stop offset="0.57" stopColor="white" />
          <stop offset={1} stopColor="#E8D2D1" />
        </linearGradient>
        <linearGradient
          id="paint121_linear_1974_24988"
          x1="1411.57"
          y1="120.143"
          x2="1435.2"
          y2="119.925"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E8D8D7" />
          <stop offset="0.04" stopColor="#EBDDDC" />
          <stop offset="0.21" stopColor="#F6F0EF" />
          <stop offset="0.38" stopColor="#FCFBFB" />
          <stop offset="0.57" stopColor="white" />
          <stop offset="0.69" stopColor="#FBF7F7" />
          <stop offset="0.87" stopColor="#F1E3E3" />
          <stop offset={1} stopColor="#E8D2D1" />
        </linearGradient>
        <linearGradient
          id="paint122_linear_1974_24988"
          x1="606.618"
          y1="137.921"
          x2="623.429"
          y2="136.065"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F96E7E" />
          <stop offset="0.03" stopColor="#F9707F" />
          <stop offset="0.25" stopColor="#FD7985" />
          <stop offset="0.53" stopColor="#FF7D88" />
          <stop offset="0.76" stopColor="#FD7985" />
          <stop offset={1} stopColor="#F86D7D" />
        </linearGradient>
        <linearGradient
          id="paint123_linear_1974_24988"
          x1="605.646"
          y1="126.744"
          x2="623.644"
          y2="126.832"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E8D8D7" />
          <stop offset="0.05" stopColor="#EADCDB" />
          <stop offset="0.31" stopColor="#F6EFEE" />
          <stop offset="0.48" stopColor="#FBF6F6" />
          <stop offset={1} stopColor="#E8D2D1" />
        </linearGradient>
        <linearGradient
          id="paint124_linear_1974_24988"
          x1="610.413"
          y1="134.609"
          x2="623.289"
          y2="134.479"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F96E7E" />
          <stop offset="0.03" stopColor="#F9707F" />
          <stop offset="0.25" stopColor="#FD7985" />
          <stop offset="0.53" stopColor="#FF7D88" />
          <stop offset="0.76" stopColor="#FD7985" />
          <stop offset={1} stopColor="#F86D7D" />
        </linearGradient>
        <linearGradient
          id="paint125_linear_1974_24988"
          x1="613.28"
          y1="129.67"
          x2="613.24"
          y2="125.41"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.52" stopColor="#F5D1A8" />
          <stop offset="0.85" stopColor="#F2C99F" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint126_linear_1974_24988"
          x1="613.407"
          y1="125.284"
          x2="613.287"
          y2="117.029"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint127_linear_1974_24988"
          x1="618.85"
          y1="124.65"
          x2="615.28"
          y2="126.41"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint128_linear_1974_24988"
          x1="607.8"
          y1="124.84"
          x2="611.62"
          y2="126.39"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <radialGradient
          id="paint129_diamond_1974_24988"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(508 444) rotate(90) scale(142 315.828)"
        >
          <stop stopColor="white" />
          <stop offset={1} stopColor="#CACACA" />
        </radialGradient>
        <linearGradient
          id="paint130_linear_1974_24988"
          x1="287.88"
          y1="540.96"
          x2="254.51"
          y2="541.07"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset={1} stopColor="#A9563F" />
        </linearGradient>
        <linearGradient
          id="paint131_linear_1974_24988"
          x1="182.509"
          y1="548.45"
          x2="177.839"
          y2="510.36"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9563F" />
          <stop offset={1} stopColor="#C57D4E" />
        </linearGradient>
        <linearGradient
          id="paint132_linear_1974_24988"
          x1="181.539"
          y1="582.25"
          x2="181.719"
          y2="567.54"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.36" stopColor="#F8F8FA" />
          <stop offset={1} stopColor="#F1F0F5" />
        </linearGradient>
        <linearGradient
          id="paint133_linear_1974_24988"
          x1="181.549"
          y1="577.13"
          x2="182.009"
          y2="539.04"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.36" stopColor="#F8F8FA" />
          <stop offset={1} stopColor="#F1F0F5" />
        </linearGradient>
        <linearGradient
          id="paint134_linear_1974_24988"
          x1="179.789"
          y1="518.48"
          x2="181.599"
          y2="565.85"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E1E1E5" />
          <stop offset={1} stopColor="#F1F0F5" />
        </linearGradient>
        <linearGradient
          id="paint135_linear_1974_24988"
          x1="194.989"
          y1="540.49"
          x2="180.929"
          y2="552.95"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F0F5" />
          <stop offset={1} stopColor="#E1E1E5" />
        </linearGradient>
        <linearGradient
          id="paint136_linear_1974_24988"
          x1="175.309"
          y1="571.59"
          x2="176.479"
          y2="546.58"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.36" stopColor="#F8F8FA" />
          <stop offset={1} stopColor="#F1F0F5" />
        </linearGradient>
        <linearGradient
          id="paint137_linear_1974_24988"
          x1="200.4"
          y1="545.75"
          x2="190.59"
          y2="554.44"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F0F5" />
          <stop offset={1} stopColor="#E1E1E5" />
        </linearGradient>
        <linearGradient
          id="paint138_linear_1974_24988"
          x1="186.809"
          y1="572.2"
          x2="187.979"
          y2="547.03"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.36" stopColor="#F8F8FA" />
          <stop offset={1} stopColor="#F1F0F5" />
        </linearGradient>
        <linearGradient
          id="paint139_linear_1974_24988"
          x1="180.399"
          y1="540.3"
          x2="180.749"
          y2="566.07"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2264A5" />
          <stop offset="0.25" stopColor="#1F60A0" />
          <stop offset="0.54" stopColor="#165592" />
          <stop offset="0.85" stopColor="#09437A" />
          <stop offset={1} stopColor="#01396D" />
        </linearGradient>
        <linearGradient
          id="paint140_linear_1974_24988"
          x1="179.519"
          y1="540.31"
          x2="179.869"
          y2="566.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2264A5" />
          <stop offset="0.25" stopColor="#1F60A0" />
          <stop offset="0.54" stopColor="#165592" />
          <stop offset="0.85" stopColor="#09437A" />
          <stop offset={1} stopColor="#01396D" />
        </linearGradient>
        <linearGradient
          id="paint141_linear_1974_24988"
          x1="180.729"
          y1="540.3"
          x2="181.079"
          y2="566.06"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2264A5" />
          <stop offset="0.25" stopColor="#1F60A0" />
          <stop offset="0.54" stopColor="#165592" />
          <stop offset="0.85" stopColor="#09437A" />
          <stop offset={1} stopColor="#01396D" />
        </linearGradient>
        <linearGradient
          id="paint142_linear_1974_24988"
          x1="180.349"
          y1="540.3"
          x2="180.699"
          y2="566.07"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2264A5" />
          <stop offset="0.25" stopColor="#1F60A0" />
          <stop offset="0.54" stopColor="#165592" />
          <stop offset="0.85" stopColor="#09437A" />
          <stop offset={1} stopColor="#01396D" />
        </linearGradient>
        <linearGradient
          id="paint143_linear_1974_24988"
          x1="181.729"
          y1="540.28"
          x2="182.079"
          y2="566.05"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2264A5" />
          <stop offset="0.25" stopColor="#1F60A0" />
          <stop offset="0.54" stopColor="#165592" />
          <stop offset="0.85" stopColor="#09437A" />
          <stop offset={1} stopColor="#01396D" />
        </linearGradient>
        <linearGradient
          id="paint144_linear_1974_24988"
          x1="180.769"
          y1="540.3"
          x2="181.119"
          y2="566.06"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2264A5" />
          <stop offset="0.25" stopColor="#1F60A0" />
          <stop offset="0.54" stopColor="#165592" />
          <stop offset="0.85" stopColor="#09437A" />
          <stop offset={1} stopColor="#01396D" />
        </linearGradient>
        <linearGradient
          id="paint145_linear_1974_24988"
          x1="187.669"
          y1="548.35"
          x2="188.399"
          y2={554}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.36" stopColor="#F8F8FA" />
          <stop offset={1} stopColor="#F1F0F5" />
        </linearGradient>
        <linearGradient
          id="paint146_linear_1974_24988"
          x1="176.079"
          y1="549.94"
          x2="176.789"
          y2="555.43"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.36" stopColor="#F8F8FA" />
          <stop offset={1} stopColor="#F1F0F5" />
        </linearGradient>
        <linearGradient
          id="paint147_linear_1974_24988"
          x1="181.499"
          y1="565.37"
          x2="181.729"
          y2="582.84"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2264A5" />
          <stop offset="0.25" stopColor="#1F60A0" />
          <stop offset="0.54" stopColor="#165592" />
          <stop offset="0.85" stopColor="#09437A" />
          <stop offset={1} stopColor="#01396D" />
        </linearGradient>
        <linearGradient
          id="paint148_linear_1974_24988"
          x1="181.619"
          y1={578}
          x2="181.619"
          y2="572.54"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F0F5" />
          <stop offset={1} stopColor="#E1E1E5" />
        </linearGradient>
        <linearGradient
          id="paint149_linear_1974_24988"
          x1="160.569"
          y1="136.97"
          x2="219.479"
          y2="171.35"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9563F" />
          <stop offset={1} stopColor="#C57D4E" />
        </linearGradient>
        <linearGradient
          id="paint150_linear_1974_24988"
          x1="186.16"
          y1="168.63"
          x2="205.29"
          y2="171.45"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset={1} stopColor="#A9563F" />
        </linearGradient>
        <linearGradient
          id="paint151_linear_1974_24988"
          x1="201.079"
          y1="167.96"
          x2="227.509"
          y2="163.83"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset={1} stopColor="#A9563F" />
        </linearGradient>
        <linearGradient
          id="paint152_linear_1974_24988"
          x1="199.469"
          y1="169.34"
          x2="175.659"
          y2="163.09"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset={1} stopColor="#A9563F" />
        </linearGradient>
        <linearGradient
          id="paint153_linear_1974_24988"
          x1="191.669"
          y1="140.9"
          x2="219.339"
          y2="166.24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9563F" />
          <stop offset={1} stopColor="#C57D4E" />
        </linearGradient>
        <linearGradient
          id="paint154_linear_1974_24988"
          x1="150.129"
          y1="322.9"
          x2="136.779"
          y2="281.94"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9563F" />
          <stop offset={1} stopColor="#C57D4E" />
        </linearGradient>
        <linearGradient
          id="paint155_linear_1974_24988"
          x1="148.929"
          y1="351.52"
          x2="135.007"
          y2="352.988"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9563F" />
          <stop offset={1} stopColor="#C57D4E" />
        </linearGradient>
        <linearGradient
          id="paint156_linear_1974_24988"
          x1="142.46"
          y1="343.665"
          x2="137.636"
          y2="344.174"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9563F" />
          <stop offset={1} stopColor="#C57D4E" />
        </linearGradient>
        <linearGradient
          id="paint157_linear_1974_24988"
          x1="130.407"
          y1="338.742"
          x2="141.644"
          y2="320.201"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset={1} stopColor="#CD8653" />
        </linearGradient>
        <linearGradient
          id="paint158_linear_1974_24988"
          x1="147.187"
          y1="322.704"
          x2="140.235"
          y2="322.472"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9563F" />
          <stop offset={1} stopColor="#C57D4E" />
        </linearGradient>
        <linearGradient
          id="paint159_linear_1974_24988"
          x1="142.889"
          y1="205.49"
          x2="166.819"
          y2="206.72"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset={1} stopColor="#A9563F" />
        </linearGradient>
        <linearGradient
          id="paint160_linear_1974_24988"
          x1="135.419"
          y1="400.17"
          x2="160.649"
          y2="214.2"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset={1} stopColor="#A9563F" />
        </linearGradient>
        <linearGradient
          id="paint161_linear_1974_24988"
          x1="191.019"
          y1="269.95"
          x2="195.009"
          y2="273.84"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#366EA1" />
          <stop offset="0.58" stopColor="#487BA7" />
          <stop offset={1} stopColor="#5988AD" />
        </linearGradient>
        <linearGradient
          id="paint162_linear_1974_24988"
          x1="188.81"
          y1="264.56"
          x2="192.48"
          y2="272.32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5988AD" />
          <stop offset={1} stopColor="#7DA3C4" />
        </linearGradient>
        <linearGradient
          id="paint163_linear_1974_24988"
          x1="189.089"
          y1="232.46"
          x2="188.839"
          y2="405.35"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#366EA1" />
          <stop offset="0.58" stopColor="#487BA7" />
          <stop offset={1} stopColor="#5988AD" />
        </linearGradient>
        <linearGradient
          id="paint164_linear_1974_24988"
          x1="195.69"
          y1="318.03"
          x2="188.38"
          y2="461.55"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#366EA1" />
          <stop offset="0.58" stopColor="#487BA7" />
          <stop offset={1} stopColor="#5988AD" />
        </linearGradient>
        <linearGradient
          id="paint165_linear_1974_24988"
          x1="222.689"
          y1="288.08"
          x2="232.289"
          y2="275.31"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#366EA1" />
          <stop offset="0.58" stopColor="#487BA7" />
          <stop offset={1} stopColor="#5988AD" />
        </linearGradient>
        <linearGradient
          id="paint166_linear_1974_24988"
          x1="162.729"
          y1="284.69"
          x2="157.029"
          y2="268.56"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#366EA1" />
          <stop offset="0.58" stopColor="#487BA7" />
          <stop offset={1} stopColor="#5988AD" />
        </linearGradient>
        <linearGradient
          id="paint167_linear_1974_24988"
          x1="203.22"
          y1="312.55"
          x2="241.28"
          y2="312.55"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5988AD" />
          <stop offset="0.42" stopColor="#487BA7" />
          <stop offset={1} stopColor="#366EA1" />
        </linearGradient>
        <linearGradient
          id="paint168_linear_1974_24988"
          x1="208.519"
          y1="268.41"
          x2="203.869"
          y2="286.89"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#366EA1" />
          <stop offset="0.58" stopColor="#487BA7" />
          <stop offset={1} stopColor="#5988AD" />
        </linearGradient>
        <linearGradient
          id="paint169_linear_1974_24988"
          x1="180.359"
          y1="267.44"
          x2="184.069"
          y2="286.89"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#366EA1" />
          <stop offset="0.58" stopColor="#487BA7" />
          <stop offset={1} stopColor="#5988AD" />
        </linearGradient>
        <linearGradient
          id="paint170_linear_1974_24988"
          x1="196.059"
          y1="279.24"
          x2="194.409"
          y2="329.55"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#366EA1" />
          <stop offset="0.58" stopColor="#487BA7" />
          <stop offset={1} stopColor="#5988AD" />
        </linearGradient>
        <linearGradient
          id="paint171_linear_1974_24988"
          x1="181.309"
          y1="273.06"
          x2="149.379"
          y2="272.14"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#366EA1" />
          <stop offset="0.58" stopColor="#487BA7" />
          <stop offset={1} stopColor="#5988AD" />
        </linearGradient>
        <linearGradient
          id="paint172_linear_1974_24988"
          x1="214.09"
          y1="275.51"
          x2="212.71"
          y2="283.28"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#366EA1" />
          <stop offset="0.58" stopColor="#487BA7" />
          <stop offset={1} stopColor="#5988AD" />
        </linearGradient>
        <linearGradient
          id="paint173_linear_1974_24988"
          x1="224.579"
          y1="268.7"
          x2="226.489"
          y2="291.11"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5988AD" />
          <stop offset={1} stopColor="#7DA3C4" />
        </linearGradient>
        <linearGradient
          id="paint174_linear_1974_24988"
          x1="161.92"
          y1="267.5"
          x2="160.34"
          y2="285.94"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5988AD" />
          <stop offset={1} stopColor="#7DA3C4" />
        </linearGradient>
        <linearGradient
          id="paint175_linear_1974_24988"
          x1="191.949"
          y1="259.64"
          x2="193.399"
          y2="276.64"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5988AD" />
          <stop offset={1} stopColor="#7DA3C4" />
        </linearGradient>
        <linearGradient
          id="paint176_linear_1974_24988"
          x1="192.33"
          y1="264.67"
          x2="196.05"
          y2="308.15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5988AD" />
          <stop offset={1} stopColor="#7DA3C4" />
        </linearGradient>
        <linearGradient
          id="paint177_linear_1974_24988"
          x1="206.369"
          y1={266}
          x2="208.579"
          y2="302.11"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#366EA1" />
          <stop offset="0.58" stopColor="#487BA7" />
          <stop offset={1} stopColor="#5988AD" />
        </linearGradient>
        <linearGradient
          id="paint178_linear_1974_24988"
          x1="210.85"
          y1="265.68"
          x2="212.1"
          y2="286.18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#366EA1" />
          <stop offset="0.58" stopColor="#487BA7" />
          <stop offset={1} stopColor="#5988AD" />
        </linearGradient>
        <linearGradient
          id="paint179_linear_1974_24988"
          x1="172.44"
          y1="263.78"
          x2="173.78"
          y2="285.73"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#366EA1" />
          <stop offset="0.58" stopColor="#487BA7" />
          <stop offset={1} stopColor="#5988AD" />
        </linearGradient>
        <linearGradient
          id="paint180_linear_1974_24988"
          x1="176.949"
          y1="268.06"
          x2="179.139"
          y2="303.81"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#366EA1" />
          <stop offset="0.58" stopColor="#487BA7" />
          <stop offset={1} stopColor="#5988AD" />
        </linearGradient>
        <linearGradient
          id="paint181_linear_1974_24988"
          x1="174.149"
          y1="258.42"
          x2="175.889"
          y2="278.76"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5988AD" />
          <stop offset={1} stopColor="#7DA3C4" />
        </linearGradient>
        <linearGradient
          id="paint182_linear_1974_24988"
          x1="207.549"
          y1="258.53"
          x2="209.509"
          y2="281.51"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5988AD" />
          <stop offset={1} stopColor="#7DA3C4" />
        </linearGradient>
        <linearGradient
          id="paint183_linear_1974_24988"
          x1="186.78"
          y1="293.75"
          x2="195.12"
          y2="293.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#366EA1" />
          <stop offset="0.58" stopColor="#487BA7" />
          <stop offset={1} stopColor="#5988AD" />
        </linearGradient>
        <linearGradient
          id="paint184_linear_1974_24988"
          x1="216.439"
          y1="316.46"
          x2="241.719"
          y2="316.46"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5988AD" />
          <stop offset="0.42" stopColor="#487BA7" />
          <stop offset={1} stopColor="#366EA1" />
        </linearGradient>
        <linearGradient
          id="paint185_linear_1974_24988"
          x1="201.979"
          y1="186.31"
          x2="199.51"
          y2="149.58"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F0F5" />
          <stop offset={1} stopColor="#E1E1E5" />
        </linearGradient>
        <linearGradient
          id="paint186_linear_1974_24988"
          x1="166.389"
          y1="323.77"
          x2="175.169"
          y2="506.57"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5988AD" />
          <stop offset={1} stopColor="#7DA3C4" />
        </linearGradient>
        <linearGradient
          id="paint187_linear_1974_24988"
          x1="151.16"
          y1="446.3"
          x2="195.29"
          y2="439.68"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5988AD" />
          <stop offset="0.42" stopColor="#487BA7" />
          <stop offset={1} stopColor="#366EA1" />
        </linearGradient>
        <linearGradient
          id="paint188_linear_1974_24988"
          x1="161.83"
          y1="448.09"
          x2="186.89"
          y2="446.19"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5988AD" />
          <stop offset="0.42" stopColor="#487BA7" />
          <stop offset={1} stopColor="#366EA1" />
        </linearGradient>
        <linearGradient
          id="paint189_linear_1974_24988"
          x1="223.65"
          y1="323.41"
          x2="232.3"
          y2="503.42"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5988AD" />
          <stop offset={1} stopColor="#7DA3C4" />
        </linearGradient>
        <linearGradient
          id="paint190_linear_1974_24988"
          x1="145.519"
          y1="248.96"
          x2="127.989"
          y2="347.44"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset={1} stopColor="#A9563F" />
        </linearGradient>
        <linearGradient
          id="paint191_linear_1974_24988"
          x1="220.619"
          y1="448.98"
          x2="244.739"
          y2="439.88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5988AD" />
          <stop offset="0.42" stopColor="#487BA7" />
          <stop offset={1} stopColor="#366EA1" />
        </linearGradient>
        <linearGradient
          id="paint192_linear_1974_24988"
          x1="222.31"
          y1="438.04"
          x2="246.42"
          y2="434.42"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5988AD" />
          <stop offset="0.42" stopColor="#487BA7" />
          <stop offset={1} stopColor="#366EA1" />
        </linearGradient>
        <linearGradient
          id="paint193_linear_1974_24988"
          x1="197.327"
          y1="135.037"
          x2="199.06"
          y2="74.1218"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1E100C" />
          <stop offset="0.49" stopColor="#2D1712" />
          <stop offset={1} stopColor="#42231C" />
        </linearGradient>
        <linearGradient
          id="paint194_linear_1974_24988"
          x1="200.609"
          y1="93.6046"
          x2="192.073"
          y2="29.4276"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1E100C" />
          <stop offset="0.49" stopColor="#2D1712" />
          <stop offset={1} stopColor="#42231C" />
        </linearGradient>
        <linearGradient
          id="paint195_linear_1974_24988"
          x1="199.989"
          y1="96.8614"
          x2="207.516"
          y2="62.4865"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1E100C" />
          <stop offset="0.49" stopColor="#2D1712" />
          <stop offset={1} stopColor="#42231C" />
        </linearGradient>
        <linearGradient
          id="paint196_linear_1974_24988"
          x1="154.28"
          y1="77.9706"
          x2="186.858"
          y2="64.643"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1E100C" />
          <stop offset="0.49" stopColor="#2D1712" />
          <stop offset={1} stopColor="#42231C" />
        </linearGradient>
        <linearGradient
          id="paint197_linear_1974_24988"
          x1="193.709"
          y1="91.5002"
          x2="191.859"
          y2="56.3602"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1E100C" />
          <stop offset="0.49" stopColor="#2D1712" />
          <stop offset={1} stopColor="#42231C" />
        </linearGradient>
        <linearGradient
          id="paint198_linear_1974_24988"
          x1="221.129"
          y1="100.48"
          x2="219.269"
          y2="65.3402"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1E100C" />
          <stop offset="0.49" stopColor="#2D1712" />
          <stop offset={1} stopColor="#42231C" />
        </linearGradient>
        <linearGradient
          id="paint199_linear_1974_24988"
          x1="168.939"
          y1="113.62"
          x2="174.909"
          y2="136.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset="0.3" stopColor="#C1774B" />
          <stop offset="0.68" stopColor="#B66846" />
          <stop offset={1} stopColor="#A9563F" />
        </linearGradient>
        <linearGradient
          id="paint200_linear_1974_24988"
          x1="168.909"
          y1="116.96"
          x2="178.209"
          y2="143.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9563F" />
          <stop offset="0.32" stopColor="#B66846" />
          <stop offset="0.7" stopColor="#C1774B" />
          <stop offset={1} stopColor="#C57D4E" />
        </linearGradient>
        <linearGradient
          id="paint201_linear_1974_24988"
          x1="226.559"
          y1="115.39"
          x2="223.659"
          y2="139.9"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset="0.3" stopColor="#C1774B" />
          <stop offset="0.68" stopColor="#B66846" />
          <stop offset={1} stopColor="#A9563F" />
        </linearGradient>
        <linearGradient
          id="paint202_linear_1974_24988"
          x1="227.469"
          y1="116.32"
          x2="224.129"
          y2="139.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9563F" />
          <stop offset="0.32" stopColor="#B66846" />
          <stop offset="0.7" stopColor="#C1774B" />
          <stop offset={1} stopColor="#C57D4E" />
        </linearGradient>
        <linearGradient
          id="paint203_linear_1974_24988"
          x1="211.319"
          y1="121.78"
          x2="211.149"
          y2="102.18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset="0.3" stopColor="#C1774B" />
          <stop offset="0.68" stopColor="#B66846" />
          <stop offset={1} stopColor="#A9563F" />
        </linearGradient>
        <linearGradient
          id="paint204_linear_1974_24988"
          x1="185.009"
          y1="119.97"
          x2="186.039"
          y2="101.57"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset="0.3" stopColor="#C1774B" />
          <stop offset="0.68" stopColor="#B66846" />
          <stop offset={1} stopColor="#A9563F" />
        </linearGradient>
        <radialGradient
          id="paint205_radial_1974_24988"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(182.213 129.33) scale(10.507 13.3)"
        >
          <stop stopColor="#D1744D" />
          <stop offset={1} stopColor="#C57D4E" />
        </radialGradient>
        <radialGradient
          id="paint206_radial_1974_24988"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(219.656 0.500045) rotate(180) scale(10.507 13.3)"
        >
          <stop stopColor="#D1744D" />
          <stop offset={1} stopColor="#C57D4E" />
        </radialGradient>
        <linearGradient
          id="paint207_linear_1974_24988"
          x1="199.079"
          y1="153.07"
          x2="198.759"
          y2="143.45"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset={1} stopColor="#CD8653" />
        </linearGradient>
        <linearGradient
          id="paint208_linear_1974_24988"
          x1="172.319"
          y1="131.93"
          x2="187.319"
          y2="131.93"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset={1} stopColor="#A9563F" />
        </linearGradient>
        <linearGradient
          id="paint209_linear_1974_24988"
          x1="209.199"
          y1="131.93"
          x2="224.249"
          y2="131.93"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset={1} stopColor="#CD8653" />
        </linearGradient>
        <linearGradient
          id="paint210_linear_1974_24988"
          x1="200.909"
          y1="179.15"
          x2="199.709"
          y2="164.86"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset={1} stopColor="#A9563F" />
        </linearGradient>
        <linearGradient
          id="paint211_linear_1974_24988"
          x1="213.979"
          y1="124.12"
          x2="223.339"
          y2="121.83"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CD8653" />
          <stop offset={1} stopColor="#C57D4E" />
        </linearGradient>
        <linearGradient
          id="paint212_linear_1974_24988"
          x1="174.759"
          y1="120.56"
          x2="181.209"
          y2="124.91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset={1} stopColor="#CD8653" />
        </linearGradient>
        <linearGradient
          id="paint213_linear_1974_24988"
          x1="197.699"
          y1="151.11"
          x2="199.489"
          y2="73.24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9563F" />
          <stop offset={1} stopColor="#C57D4E" />
        </linearGradient>
        <linearGradient
          id="paint214_linear_1974_24988"
          x1="198.969"
          y1="94.65"
          x2="200.319"
          y2="47.3"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1E100C" />
          <stop offset="0.49" stopColor="#2D1712" />
          <stop offset={1} stopColor="#42231C" />
        </linearGradient>
        <linearGradient
          id="paint215_linear_1974_24988"
          x1="198.259"
          y1="122.5"
          x2="198.259"
          y2="63.86"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1E100C" />
          <stop offset="0.49" stopColor="#2D1712" />
          <stop offset={1} stopColor="#42231C" />
        </linearGradient>
        <linearGradient
          id="paint216_linear_1974_24988"
          x1="170.029"
          y1="73.5"
          x2="171.669"
          y2="107.47"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42231C" />
          <stop offset="0.51" stopColor="#2D1712" />
          <stop offset={1} stopColor="#1E100C" />
        </linearGradient>
        <linearGradient
          id="paint217_linear_1974_24988"
          x1="223.659"
          y1="72.56"
          x2="225.189"
          y2="104.41"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42231C" />
          <stop offset="0.51" stopColor="#2D1712" />
          <stop offset={1} stopColor="#1E100C" />
        </linearGradient>
        <linearGradient
          id="paint218_linear_1974_24988"
          x1="198.539"
          y1="113.42"
          x2="198.719"
          y2="69.2401"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9563F" />
          <stop offset={1} stopColor="#C57D4E" />
        </linearGradient>
        <linearGradient
          id="paint219_linear_1974_24988"
          x1="191.099"
          y1="107.67"
          x2="175.419"
          y2="107.67"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#673024" />
          <stop offset="0.34" stopColor="#52261C" />
          <stop offset="0.68" stopColor="#462017" />
          <stop offset={1} stopColor="#421F16" />
        </linearGradient>
        <linearGradient
          id="paint220_linear_1974_24988"
          x1="204.669"
          y1="107.67"
          x2="220.369"
          y2="107.67"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#673024" />
          <stop offset="0.34" stopColor="#52261C" />
          <stop offset="0.68" stopColor="#462017" />
          <stop offset={1} stopColor="#421F16" />
        </linearGradient>
        <linearGradient
          id="paint221_linear_1974_24988"
          x1="217.779"
          y1="114.08"
          x2="203.679"
          y2="119.55"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9563F" />
          <stop offset="0.32" stopColor="#B66846" />
          <stop offset="0.7" stopColor="#C1774B" />
          <stop offset={1} stopColor="#C57D4E" />
        </linearGradient>
        <linearGradient
          id="paint222_linear_1974_24988"
          x1="204.008"
          y1="117.36"
          x2="208.338"
          y2="117.36"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.47" stopColor="#FCFCFC" />
          <stop offset="0.77" stopColor="#F5F3F3" />
          <stop offset={1} stopColor="#ECE7E7" />
        </linearGradient>
        <linearGradient
          id="paint223_linear_1974_24988"
          x1="213.589"
          y1="117.24"
          x2="217.029"
          y2="117.24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.47" stopColor="#FCFCFC" />
          <stop offset="0.77" stopColor="#F5F3F3" />
          <stop offset={1} stopColor="#ECE7E7" />
        </linearGradient>
        <linearGradient
          id="paint224_linear_1974_24988"
          x1="215.849"
          y1="121.07"
          x2="205.749"
          y2="114.76"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#936655" />
          <stop offset={1} stopColor="#5A3D32" />
        </linearGradient>
        <linearGradient
          id="paint225_linear_1974_24988"
          x1="224.229"
          y1="117.47"
          x2="211.109"
          y2="115.91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#936655" />
          <stop offset={1} stopColor="#5A3D32" />
        </linearGradient>
        <radialGradient
          id="paint226_radial_1974_24988"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(209.988 117.44) scale(2.95001)"
        >
          <stop stopColor="#2A3A3B" />
          <stop offset={1} stopColor="#1C2727" />
        </radialGradient>
        <linearGradient
          id="paint227_linear_1974_24988"
          x1="204.019"
          y1="116.93"
          x2="219.909"
          y2="116.93"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5A2A1F" />
          <stop offset="0.29" stopColor="#492219" />
          <stop offset="0.66" stopColor="#3D1C14" />
          <stop offset={1} stopColor="#391B13" />
        </linearGradient>
        <linearGradient
          id="paint228_linear_1974_24988"
          x1="210.919"
          y1="112.52"
          x2="200.399"
          y2="125.91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9563F" />
          <stop offset={1} stopColor="#C57D4E" />
        </linearGradient>
        <linearGradient
          id="paint229_linear_1974_24988"
          x1="178.35"
          y1="114.08"
          x2="192.46"
          y2="119.55"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9563F" />
          <stop offset="0.32" stopColor="#B66846" />
          <stop offset="0.7" stopColor="#C1774B" />
          <stop offset={1} stopColor="#C57D4E" />
        </linearGradient>
        <linearGradient
          id="paint230_linear_1974_24988"
          x1="192.129"
          y1="117.36"
          x2="187.799"
          y2="117.36"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.47" stopColor="#FCFCFC" />
          <stop offset="0.77" stopColor="#F5F3F3" />
          <stop offset={1} stopColor="#ECE7E7" />
        </linearGradient>
        <linearGradient
          id="paint231_linear_1974_24988"
          x1="182.549"
          y1="117.24"
          x2="179.109"
          y2="117.24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.47" stopColor="#FCFCFC" />
          <stop offset="0.77" stopColor="#F5F3F3" />
          <stop offset={1} stopColor="#ECE7E7" />
        </linearGradient>
        <linearGradient
          id="paint232_linear_1974_24988"
          x1="180.279"
          y1="121.07"
          x2="190.389"
          y2="114.76"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5A3D32" />
          <stop offset={1} stopColor="#936655" />
        </linearGradient>
        <linearGradient
          id="paint233_linear_1974_24988"
          x1="188.759"
          y1="135.96"
          x2="186.969"
          y2="125.69"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#936655" />
          <stop offset={1} stopColor="#5A3D32" />
        </linearGradient>
        <radialGradient
          id="paint234_radial_1974_24988"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(186.149 117.44) rotate(180) scale(2.95001)"
        >
          <stop stopColor="#2A3A3B" />
          <stop offset={1} stopColor="#1C2727" />
        </radialGradient>
        <linearGradient
          id="paint235_linear_1974_24988"
          x1="192.119"
          y1="116.93"
          x2="176.229"
          y2="116.93"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5A2A1F" />
          <stop offset="0.29" stopColor="#492219" />
          <stop offset="0.66" stopColor="#3D1C14" />
          <stop offset={1} stopColor="#391B13" />
        </linearGradient>
        <linearGradient
          id="paint236_linear_1974_24988"
          x1="185.219"
          y1="112.52"
          x2="195.739"
          y2="125.91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9563F" />
          <stop offset={1} stopColor="#C57D4E" />
        </linearGradient>
        <linearGradient
          id="paint237_linear_1974_24988"
          x1="197.79"
          y1={134}
          x2="197.27"
          y2="126.21"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset="0.3" stopColor="#C1774B" />
          <stop offset="0.68" stopColor="#B66846" />
          <stop offset={1} stopColor="#A9563F" />
        </linearGradient>
        <linearGradient
          id="paint238_linear_1974_24988"
          x1="197.63"
          y1="129.65"
          x2="197.6"
          y2="133.23"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9563F" />
          <stop offset="0.32" stopColor="#B66846" />
          <stop offset="0.7" stopColor="#C1774B" />
          <stop offset={1} stopColor="#C57D4E" />
        </linearGradient>
        <linearGradient
          id="paint239_linear_1974_24988"
          x1="197.55"
          y1="133.71"
          x2="197.23"
          y2="123.31"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9563F" />
          <stop offset="0.32" stopColor="#B66846" />
          <stop offset="0.7" stopColor="#C1774B" />
          <stop offset={1} stopColor="#C57D4E" />
        </linearGradient>
        <linearGradient
          id="paint240_linear_1974_24988"
          x1="197.38"
          y1="124.79"
          x2="197.43"
          y2="128.45"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset={1} stopColor="#CD8653" />
        </linearGradient>
        <linearGradient
          id="paint241_linear_1974_24988"
          x1="187.619"
          y1="130.62"
          x2="201.359"
          y2="142.62"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset="0.3" stopColor="#C1774B" />
          <stop offset="0.68" stopColor="#B66846" />
          <stop offset={1} stopColor="#A9563F" />
        </linearGradient>
        <linearGradient
          id="paint242_linear_1974_24988"
          x1="182.288"
          y1="132.864"
          x2="188.183"
          y2="137.204"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9563F" />
          <stop offset="0.32" stopColor="#B66846" />
          <stop offset="0.7" stopColor="#C1774B" />
          <stop offset={1} stopColor="#C57D4E" />
        </linearGradient>
        <linearGradient
          id="paint243_linear_1974_24988"
          x1="211.486"
          y1="133.93"
          x2="207.874"
          y2="137.354"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9563F" />
          <stop offset="0.32" stopColor="#B66846" />
          <stop offset="0.7" stopColor="#C1774B" />
          <stop offset={1} stopColor="#C57D4E" />
        </linearGradient>
        <linearGradient
          id="paint244_linear_1974_24988"
          x1="190.799"
          y1="139.52"
          x2="205.179"
          y2="139.52"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E8D8D7" />
          <stop offset="0.04" stopColor="#EBDDDC" />
          <stop offset="0.21" stopColor="#F6F0EF" />
          <stop offset="0.38" stopColor="#FCFBFB" />
          <stop offset="0.57" stopColor="white" />
          <stop offset="0.69" stopColor="#FBF7F7" />
          <stop offset="0.87" stopColor="#F1E3E3" />
          <stop offset={1} stopColor="#E8D2D1" />
        </linearGradient>
        <linearGradient
          id="paint245_linear_1974_24988"
          x1="187.589"
          y1="137.36"
          x2="208.009"
          y2="137.16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E8D8D7" />
          <stop offset="0.04" stopColor="#EBDDDC" />
          <stop offset="0.21" stopColor="#F6F0EF" />
          <stop offset="0.38" stopColor="#FCFBFB" />
          <stop offset="0.57" stopColor="white" />
          <stop offset="0.69" stopColor="#FBF7F7" />
          <stop offset="0.87" stopColor="#F1E3E3" />
          <stop offset={1} stopColor="#E8D2D1" />
        </linearGradient>
        <linearGradient
          id="paint246_linear_1974_24988"
          x1="193.159"
          y1="142.2"
          x2="203.099"
          y2="142.1"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D23F50" />
          <stop offset="0.21" stopColor="#D64856" />
          <stop offset="0.47" stopColor="#D94C59" />
          <stop offset="0.78" stopColor="#D74856" />
          <stop offset={1} stopColor="#D34051" />
        </linearGradient>
        <linearGradient
          id="paint247_linear_1974_24988"
          x1="197.739"
          y1="135.43"
          x2="197.679"
          y2="131.58"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset={1} stopColor="#CD8653" />
        </linearGradient>
        <linearGradient
          id="paint248_linear_1974_24988"
          x1="187.579"
          y1="136.48"
          x2="207.999"
          y2="136.29"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E8D8D7" />
          <stop offset="0.05" stopColor="#EADCDB" />
          <stop offset="0.31" stopColor="#F6EFEE" />
          <stop offset="0.48" stopColor="#FBF6F6" />
          <stop offset={1} stopColor="#E8D2D1" />
        </linearGradient>
        <linearGradient
          id="paint249_linear_1974_24988"
          x1="190.039"
          y1="135.44"
          x2="207.809"
          y2="135.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D23F50" />
          <stop offset="0.21" stopColor="#D64856" />
          <stop offset="0.47" stopColor="#D94C59" />
          <stop offset="0.78" stopColor="#D74856" />
          <stop offset={1} stopColor="#D34051" />
        </linearGradient>
        <linearGradient
          id="paint250_linear_1974_24988"
          x1="207.949"
          y1="129.8"
          x2="207.769"
          y2="77.3601"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1E100C" />
          <stop offset="0.49" stopColor="#2D1712" />
          <stop offset={1} stopColor="#42231C" />
        </linearGradient>
        <linearGradient
          id="paint251_linear_1974_24988"
          x1="218.189"
          y1="129.76"
          x2="217.999"
          y2="77.33"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1E100C" />
          <stop offset="0.49" stopColor="#2D1712" />
          <stop offset={1} stopColor="#42231C" />
        </linearGradient>
        <linearGradient
          id="paint252_linear_1974_24988"
          x1="194.239"
          y1="129.84"
          x2="194.059"
          y2="77.4101"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1E100C" />
          <stop offset="0.49" stopColor="#2D1712" />
          <stop offset={1} stopColor="#42231C" />
        </linearGradient>
        <linearGradient
          id="paint253_linear_1974_24988"
          x1="183.029"
          y1="129.88"
          x2="182.849"
          y2="77.4502"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1E100C" />
          <stop offset="0.49" stopColor="#2D1712" />
          <stop offset={1} stopColor="#42231C" />
        </linearGradient>
        <linearGradient
          id="paint254_linear_1974_24988"
          x1="174.829"
          y1="129.91"
          x2="174.639"
          y2="77.4801"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1E100C" />
          <stop offset="0.49" stopColor="#2D1712" />
          <stop offset={1} stopColor="#42231C" />
        </linearGradient>
        <linearGradient
          id="paint255_linear_1974_24988"
          x1="226.359"
          y1="129.76"
          x2="226.819"
          y2="93.41"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1E100C" />
          <stop offset="0.49" stopColor="#2D1712" />
          <stop offset={1} stopColor="#42231C" />
        </linearGradient>
        <linearGradient
          id="paint256_linear_1974_24988"
          x1="170.539"
          y1="129.07"
          x2="170.999"
          y2="92.7201"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1E100C" />
          <stop offset="0.49" stopColor="#2D1712" />
          <stop offset={1} stopColor="#42231C" />
        </linearGradient>
        <linearGradient
          id="paint257_linear_1974_24988"
          x1="198.299"
          y1="106.71"
          x2="198.389"
          y2="89.1802"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1E100C" />
          <stop offset="0.49" stopColor="#2D1712" />
          <stop offset={1} stopColor="#42231C" />
        </linearGradient>
        <linearGradient
          id="paint258_linear_1974_24988"
          x1="199.289"
          y1="111.36"
          x2="202.739"
          y2="150.01"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1E100C" />
          <stop offset="0.49" stopColor="#2D1712" />
          <stop offset={1} stopColor="#42231C" />
        </linearGradient>
        <linearGradient
          id="paint259_linear_1974_24988"
          x1="221.259"
          y1="492.46"
          x2="257.609"
          y2="492.46"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5988AD" />
          <stop offset="0.42" stopColor="#487BA7" />
          <stop offset={1} stopColor="#366EA1" />
        </linearGradient>
        <linearGradient
          id="paint260_linear_1974_24988"
          x1="185.429"
          y1="468.07"
          x2="196.709"
          y2="598.1"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5988AD" />
          <stop offset="0.42" stopColor="#487BA7" />
          <stop offset={1} stopColor="#366EA1" />
        </linearGradient>
        <linearGradient
          id="paint261_linear_1974_24988"
          x1="174.35"
          y1="538.15"
          x2="185.33"
          y2="537.52"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5988AD" />
          <stop offset="0.42" stopColor="#487BA7" />
          <stop offset={1} stopColor="#366EA1" />
        </linearGradient>
        <linearGradient
          id="paint262_linear_1974_24988"
          x1="182.919"
          y1="556.73"
          x2="181.519"
          y2="526.67"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5988AD" />
          <stop offset={1} stopColor="#7DA3C4" />
        </linearGradient>
        <linearGradient
          id="paint263_linear_1974_24988"
          x1="275.549"
          y1="528.74"
          x2="258.109"
          y2="532.43"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5988AD" />
          <stop offset="0.42" stopColor="#487BA7" />
          <stop offset={1} stopColor="#366EA1" />
        </linearGradient>
        <linearGradient
          id="paint264_linear_1974_24988"
          x1="263.109"
          y1="554.09"
          x2="261.699"
          y2="523.92"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5988AD" />
          <stop offset={1} stopColor="#7DA3C4" />
        </linearGradient>
        <linearGradient
          id="paint265_linear_1974_24988"
          x1="264.89"
          y1="582.49"
          x2="264.67"
          y2="564.32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.36" stopColor="#F8F8FA" />
          <stop offset={1} stopColor="#F1F0F5" />
        </linearGradient>
        <linearGradient
          id="paint266_linear_1974_24988"
          x1="265.339"
          y1="576.79"
          x2="264.779"
          y2="531.15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.36" stopColor="#F8F8FA" />
          <stop offset={1} stopColor="#F1F0F5" />
        </linearGradient>
        <linearGradient
          id="paint267_linear_1974_24988"
          x1="266.86"
          y1="507.37"
          x2="264.75"
          y2="562.58"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E1E1E5" />
          <stop offset={1} stopColor="#F1F0F5" />
        </linearGradient>
        <linearGradient
          id="paint268_linear_1974_24988"
          x1="247.52"
          y1="533.24"
          x2="264.21"
          y2="548.04"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F0F5" />
          <stop offset={1} stopColor="#E1E1E5" />
        </linearGradient>
        <linearGradient
          id="paint269_linear_1974_24988"
          x1="270.99"
          y1="570.62"
          x2="269.57"
          y2={540}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.36" stopColor="#F8F8FA" />
          <stop offset={1} stopColor="#F1F0F5" />
        </linearGradient>
        <linearGradient
          id="paint270_linear_1974_24988"
          x1="241.7"
          y1="538.73"
          x2="253.92"
          y2="549.57"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F0F5" />
          <stop offset={1} stopColor="#E1E1E5" />
        </linearGradient>
        <linearGradient
          id="paint271_linear_1974_24988"
          x1="259.349"
          y1="571.38"
          x2="257.919"
          y2="540.49"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.36" stopColor="#F8F8FA" />
          <stop offset={1} stopColor="#F1F0F5" />
        </linearGradient>
        <linearGradient
          id="paint272_linear_1974_24988"
          x1="265.55"
          y1="532.37"
          x2="265.12"
          y2="563.86"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2264A5" />
          <stop offset="0.25" stopColor="#1F60A0" />
          <stop offset="0.54" stopColor="#165592" />
          <stop offset="0.85" stopColor="#09437A" />
          <stop offset={1} stopColor="#01396D" />
        </linearGradient>
        <linearGradient
          id="paint273_linear_1974_24988"
          x1="266.48"
          y1="532.2"
          x2="266.05"
          y2="563.91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2264A5" />
          <stop offset="0.25" stopColor="#1F60A0" />
          <stop offset="0.54" stopColor="#165592" />
          <stop offset="0.85" stopColor="#09437A" />
          <stop offset={1} stopColor="#01396D" />
        </linearGradient>
        <linearGradient
          id="paint274_linear_1974_24988"
          x1="265.19"
          y1="532.33"
          x2="264.76"
          y2="563.85"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2264A5" />
          <stop offset="0.25" stopColor="#1F60A0" />
          <stop offset="0.54" stopColor="#165592" />
          <stop offset="0.85" stopColor="#09437A" />
          <stop offset={1} stopColor="#01396D" />
        </linearGradient>
        <linearGradient
          id="paint275_linear_1974_24988"
          x1="265.59"
          y1="532.22"
          x2="265.16"
          y2="563.91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2264A5" />
          <stop offset="0.25" stopColor="#1F60A0" />
          <stop offset="0.54" stopColor="#165592" />
          <stop offset="0.85" stopColor="#09437A" />
          <stop offset={1} stopColor="#01396D" />
        </linearGradient>
        <linearGradient
          id="paint276_linear_1974_24988"
          x1="264.11"
          y1="532.3"
          x2="263.68"
          y2="563.82"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2264A5" />
          <stop offset="0.25" stopColor="#1F60A0" />
          <stop offset="0.54" stopColor="#165592" />
          <stop offset="0.85" stopColor="#09437A" />
          <stop offset={1} stopColor="#01396D" />
        </linearGradient>
        <linearGradient
          id="paint277_linear_1974_24988"
          x1="265.13"
          y1="532.24"
          x2="264.7"
          y2="563.91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2264A5" />
          <stop offset="0.25" stopColor="#1F60A0" />
          <stop offset="0.54" stopColor="#165592" />
          <stop offset="0.85" stopColor="#09437A" />
          <stop offset={1} stopColor="#01396D" />
        </linearGradient>
        <linearGradient
          id="paint278_linear_1974_24988"
          x1="258.32"
          y1="542.27"
          x2="257.43"
          y2="549.21"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.36" stopColor="#F8F8FA" />
          <stop offset={1} stopColor="#F1F0F5" />
        </linearGradient>
        <linearGradient
          id="paint279_linear_1974_24988"
          x1="270.109"
          y1="544.07"
          x2="269.249"
          y2="550.73"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.36" stopColor="#F8F8FA" />
          <stop offset={1} stopColor="#F1F0F5" />
        </linearGradient>
        <linearGradient
          id="paint280_linear_1974_24988"
          x1="265.13"
          y1="550.38"
          x2="264.67"
          y2="584.18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2264A5" />
          <stop offset="0.25" stopColor="#1F60A0" />
          <stop offset="0.54" stopColor="#165592" />
          <stop offset="0.85" stopColor="#09437A" />
          <stop offset={1} stopColor="#01396D" />
        </linearGradient>
        <linearGradient
          id="paint281_linear_1974_24988"
          x1="265.1"
          y1="577.96"
          x2="265.1"
          y2="570.66"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F0F5" />
          <stop offset={1} stopColor="#E1E1E5" />
        </linearGradient>
        <linearGradient
          id="paint282_linear_1974_24988"
          x1="156.469"
          y1="154.64"
          x2="152.449"
          y2="204.21"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.36" stopColor="#F8F8F9" />
          <stop offset={1} stopColor="#F1F0F4" />
        </linearGradient>
        <linearGradient
          id="paint283_linear_1974_24988"
          x1="267.369"
          y1="213.76"
          x2="220.989"
          y2="222.02"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset={1} stopColor="#A9563F" />
        </linearGradient>
        <linearGradient
          id="paint284_linear_1974_24988"
          x1="246.929"
          y1="155.31"
          x2="250.899"
          y2="204.15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.36" stopColor="#F8F8F9" />
          <stop offset={1} stopColor="#F1F0F4" />
        </linearGradient>
        <linearGradient
          id="paint285_linear_1974_24988"
          x1={239}
          y1="350.39"
          x2="221.21"
          y2="276.9"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5988AD" />
          <stop offset="0.42" stopColor="#487BA7" />
          <stop offset={1} stopColor="#366EA1" />
        </linearGradient>
        <linearGradient
          id="paint286_linear_1974_24988"
          x1="189.58"
          y1="273.89"
          x2="175.07"
          y2="166.9"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F0F5" />
          <stop offset={1} stopColor="#E1E1E5" />
        </linearGradient>
        <linearGradient
          id="paint287_linear_1974_24988"
          x1="201.299"
          y1="316.58"
          x2="207.839"
          y2="283.51"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5988AD" />
          <stop offset="0.42" stopColor="#487BA7" />
          <stop offset={1} stopColor="#366EA1" />
        </linearGradient>
        <linearGradient
          id="paint288_linear_1974_24988"
          x1="266.719"
          y1="270.797"
          x2="128.869"
          y2="163.575"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDDBBB" />
          <stop offset="0.4" stopColor="#F3E7D3" />
          <stop offset={1} stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint289_linear_1974_24988"
          x1="196.678"
          y1="249.982"
          x2="167.194"
          y2="242.056"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset={1} stopColor="#CD8653" />
        </linearGradient>
        <linearGradient
          id="paint290_linear_1974_24988"
          x1="219.195"
          y1="254.884"
          x2="178.145"
          y2="243.84"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset={1} stopColor="#CD8653" />
        </linearGradient>
        <linearGradient
          id="paint291_linear_1974_24988"
          x1="171.631"
          y1="265.573"
          x2="189.183"
          y2="259.968"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset={1} stopColor="#CD8653" />
        </linearGradient>
        <linearGradient
          id="paint292_linear_1974_24988"
          x1="223.346"
          y1="260.218"
          x2="197.271"
          y2="266.254"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset={1} stopColor="#A9563F" />
        </linearGradient>
        <linearGradient
          id="paint293_linear_1974_24988"
          x1="191.845"
          y1="248.957"
          x2="178.327"
          y2="252.092"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset={1} stopColor="#A9563F" />
        </linearGradient>
        <linearGradient
          id="paint294_linear_1974_24988"
          x1="177.167"
          y1="259.071"
          x2="180.315"
          y2="258.353"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset={1} stopColor="#A9563F" />
        </linearGradient>
        <linearGradient
          id="paint295_linear_1974_24988"
          x1="178.911"
          y1="263.778"
          x2="181.384"
          y2="263.216"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset={1} stopColor="#A9563F" />
        </linearGradient>
        <linearGradient
          id="paint296_linear_1974_24988"
          x1="181.225"
          y1="267.648"
          x2="184.281"
          y2="266.953"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset={1} stopColor="#A9563F" />
        </linearGradient>
        <linearGradient
          id="paint297_linear_1974_24988"
          x1="268.637"
          y1="250.819"
          x2="215.693"
          y2="258.833"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset={1} stopColor="#A9563F" />
        </linearGradient>
        <linearGradient
          id="paint298_linear_1974_24988"
          x1="216.988"
          y1="250.812"
          x2="267.991"
          y2="245.318"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset={1} stopColor="#CD8653" />
        </linearGradient>
        <linearGradient
          id="paint299_linear_1974_24988"
          x1="270.739"
          y1="232.66"
          x2="224.349"
          y2="240.92"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C57D4E" />
          <stop offset={1} stopColor="#A9563F" />
        </linearGradient>
        <linearGradient
          id="paint300_linear_1974_24988"
          x1="228.85"
          y1="309.14"
          x2="277.49"
          y2="309.14"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#127869" />
          <stop offset="0.38" stopColor="#0D5E52" />
          <stop offset="0.73" stopColor="#0A4D44" />
          <stop offset={1} stopColor="#0A483F" />
        </linearGradient>
        <linearGradient
          id="paint301_linear_1974_24988"
          x1="230.089"
          y1="317.83"
          x2="253.949"
          y2="317.83"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#127869" />
          <stop offset="0.52" stopColor="#1F7F6B" />
          <stop offset={1} stopColor="#25836D" />
        </linearGradient>
        <linearGradient
          id="paint302_linear_1974_24988"
          x1="251.369"
          y1="301.38"
          x2="289.159"
          y2="341.95"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#127869" />
          <stop offset="0.52" stopColor="#1F7F6B" />
          <stop offset={1} stopColor="#25836D" />
        </linearGradient>
      </defs>
    </svg>
  );
}
